(function(e, t) {
    'object' == typeof exports && 'object' == typeof module ? module.exports = t() : 'function' == typeof define && define.amd ? define([], t) : 'object' == typeof exports ? exports.mitekScienceSDK = t() : e.mitekScienceSDK = t()
}
)(this, function() {
    var e = Math.floor
      , t = Math.min
      , n = Math.max;
    return function(e) {
        function t(t) {
            for (var a = t[0], n = t[1], o = 0, s = [], d, l; o < a.length; o++)
                l = a[o],
                Object.prototype.hasOwnProperty.call(r, l) && r[l] && s.push(r[l][0]),
                r[l] = 0;
            for (d in n)
                Object.prototype.hasOwnProperty.call(n, d) && (e[d] = n[d]);
            for (i && i(t); s.length; )
                s.shift()()
        }
        function a(e) {
            return n.p + '' + ({
                0: 'vendors-mitek4-mitek5',
                3: 'mitek2',
                4: 'mitek4',
                5: 'mitek5',
                6: 'vendors-mitek4',
                7: 'vendors-mitek5'
            }[e] || e) + '.bundle.js'
        }
        function n(t) {
            if (o[t])
                return o[t].exports;
            var a = o[t] = {
                i: t,
                l: !1,
                exports: {}
            };
            return e[t].call(a.exports, a, a.exports, n),
            a.l = !0,
            a.exports
        }
        var o = {}
          , r = {
            2: 0
        };
        n.e = function(e) {
            var t = []
              , i = r[e];
            if (0 !== i)
                if (i)
                    t.push(i[2]);
                else {
                    var o = new Promise(function(t, a) {
                        i = r[e] = [t, a]
                    }
                    );
                    t.push(i[2] = o);
                    var s = document.createElement('script'), d;
                    s.charset = 'utf-8',
                    s.timeout = 120,
                    n.nc && s.setAttribute('nonce', n.nc),
                    s.src = a(e);
                    var l = new Error;
                    d = function(t) {
                        s.onerror = s.onload = null,
                        clearTimeout(c);
                        var a = r[e];
                        if (0 !== a) {
                            if (a) {
                                var n = t && ('load' === t.type ? 'missing' : t.type)
                                  , i = t && t.target && t.target.src;
                                l.message = 'Loading chunk ' + e + ' failed.\n(' + n + ': ' + i + ')',
                                l.name = 'ChunkLoadError',
                                l.type = n,
                                l.request = i,
                                a[1](l)
                            }
                            r[e] = void 0
                        }
                    }
                    ;
                    var c = setTimeout(function() {
                        d({
                            type: 'timeout',
                            target: s
                        })
                    }, 12e4);
                    s.onerror = s.onload = d,
                    document.head.appendChild(s)
                }
            return Promise.all(t)
        }
        ,
        n.m = e,
        n.c = o,
        n.d = function(e, t, a) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: a
            })
        }
        ,
        n.r = function(e) {
            'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: 'Module'
            }),
            Object.defineProperty(e, '__esModule', {
                value: !0
            })
        }
        ,
        n.t = function(e, t) {
            if (1 & t && (e = n(e)),
            8 & t)
                return e;
            if (4 & t && 'object' == typeof e && e && e.__esModule)
                return e;
            var a = Object.create(null);
            if (n.r(a),
            Object.defineProperty(a, 'default', {
                enumerable: !0,
                value: e
            }),
            2 & t && 'string' != typeof e)
                for (var i in e)
                    n.d(a, i, function(t) {
                        return e[t]
                    }
                    .bind(null, i));
            return a
        }
        ,
        n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e['default']
            }
            : function() {
                return e
            }
            ;
            return n.d(t, 'a', t),
            t
        }
        ,
        n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        }
        ,
        n.p = '',
        n.oe = function(e) {
            throw console.error(e),
            e
        }
        ;
        var s = this.webpackJsonpmitekScienceSDK = this.webpackJsonpmitekScienceSDK || []
          , d = s.push.bind(s);
        s.push = t,
        s = s.slice();
        for (var l = 0; l < s.length; l++)
            t(s[l]);
        var i = d;
        return n(n.s = 70)
    }([function(e, t, a) {
        'use strict';
        var n = a(20)
          , i = new n.a;
        t.a = i
    }
    , function(e, t, a) {
        'use strict';
        function n() {
            return C.MitekMibiData
        }
        function i(e, t) {
            var a = new FileReader;
            a.addEventListener('loadend', function() {
                t(this.result)
            }),
            a.readAsDataURL(e)
        }
        function o() {
            try {
                'undefined' == typeof C.MitekCaptureSession.EXIFData.Exif && (C.MitekCaptureSession.EXIFData.Exif = {
                    37510: ''
                }),
                C.MitekCaptureSession.EXIFData.Exif[_.ExifIFD.UserComment] = JSON.stringify(C.MitekMibiData)
            } catch (t) {
                console.warn('Unable to add MibiData to EXIF data')
            }
        }
        function r(e) {
            R.b(e) && i(e, s)
        }
        function s(e) {
            try {
                var t = _.load(e);
                C.MitekCaptureSession.EXIFData = t
            } catch (t) {
                console.warn('Unable to load EXIF data: ' + t)
            }
        }
        function d(e) {
            try {
                var t = _.dump(C.MitekCaptureSession.EXIFData);
                e = _.insert(t, e)
            } catch (t) {
                console.warn('Unable to insert EXIF data: ' + t)
            }
            return e
        }
        function l(e) {
            C.MitekMibiData.ImageSource.Upload = !0 === e ? 'true' : 'false'
        }
        function c(e) {
            C.MitekMibiData.ImageSource.Method = e
        }
        function p(e) {
            C.MitekMibiData.WASMSupported = !0 === e ? 'true' : 'false'
        }
        function m(e) {
            C.MitekMibiData.ImageSource.IQA = !0 === e ? 'true' : 'false'
        }
        function u() {
            C.MitekMibiData.UserAgent = navigator.userAgent,
            C.MitekMibiData.ImageSource.Platform = Object(f.e)() ? 'Mobile' : 'Desktop'
        }
        function g() {
            T = null,
            C.MitekMibiData.UserAgent = '',
            C.MitekMibiData.UXP = [],
            C.MitekCaptureSession.EXIFData = {}
        }
        function y() {
            C.MitekMibiData.MiSnapResultCode = 'SuccessAutoCamera'
        }
        function S() {
            C.MitekMibiData.MiSnapResultCode = 'SuccessStillCamera'
        }
        function h(e) {
            C.MitekMibiData.Doctype = e
        }
        function E(e, t) {
            if (Object(f.d)(e)) {
                void 0 === t && (t = ''),
                null === T && (T = Date.now());
                var a = Date.now() - T
                  , n = [];
                t instanceof Array ? n = t : n.push(t),
                n.unshift(a),
                '' == C.MitekMibiData.UserAgent && u();
                var i = {};
                i[e] = n,
                C.MitekMibiData.UXP.push(i)
            }
        }
        a.d(t, 'd', function() {
            return n
        }),
        a.d(t, 'a', function() {
            return o
        }),
        a.d(t, 'b', function() {
            return r
        }),
        a.d(t, 'e', function() {
            return d
        }),
        a.d(t, 'l', function() {
            return l
        }),
        a.d(t, 'i', function() {
            return c
        }),
        a.d(t, 'm', function() {
            return p
        }),
        a.d(t, 'h', function() {
            return m
        }),
        a.d(t, 'c', function() {
            return g
        }),
        a.d(t, 'j', function() {
            return y
        }),
        a.d(t, 'k', function() {
            return S
        }),
        a.d(t, 'g', function() {
            return h
        }),
        a.d(t, 'f', function() {
            return E
        });
        var f = a(2)
          , R = a(12)
          , A = a(19)
          , _ = a(57)
          , C = Object(A.a)()
          , T = null
    }
    , function(e, t, a) {
        'use strict';
        (function(e) {
            function n(e) {
                return null != e
            }
            function i(e) {
                return !1 !== e && n(e)
            }
            function o(e) {
                return function(t) {
                    return p()(t) === e
                }
            }
            function r(e) {
                return !isNaN(parseFloat(e)) && isFinite(e)
            }
            function s(e, t) {
                var a = function() {
                    return t.apply(t, arguments)
                };
                return a.message = e,
                a
            }
            function d(e, t) {
                return function(a) {
                    return a >= e && a <= t
                }
            }
            function l(e, t, a) {
                return !!('undefined' != typeof e && r(e) && 0 < e) && (e < t || e > a)
            }
            a.d(t, 'd', function() {
                return n
            }),
            a.d(t, 'h', function() {
                return i
            }),
            a.d(t, 'f', function() {
                return r
            }),
            a.d(t, 'b', function() {
                return d
            }),
            a.d(t, 'e', function() {
                return m
            }),
            a.d(t, 'a', function() {
                return l
            }),
            a.d(t, 'g', function() {
                return y
            }),
            a.d(t, 'c', function() {
                return S
            }),
            a.d(t, 'i', function() {
                return A
            });
            var c = a(9)
              , p = a.n(c);
            var m = function(e) {
                return function() {
                    return 'undefined' != typeof e.orientation || -1 !== e.navigator.userAgent.indexOf('IEMobile')
                }
            }(e || {})
              , u = function(e) {
                return function() {
                    return e.navigator.userAgent.includes('Firefox')
                }
            }(e || {})
              , g = function(e) {
                return function() {
                    return e.navigator.userAgent.includes('Chrome')
                }
            }(e || {})
              , y = function(e) {
                return function() {
                    return e.navigator.userAgent.includes('Safari') && !e.navigator.userAgent.includes('Chrome')
                }
            }(e || {})
              , S = function() {
                return function() {
                    return !u() == !y()
                }
            }()
              , h = o('string')
              , E = o('function')
              , f = o('object')
              , R = function() {
                var e = [].slice.call(arguments);
                return function(t) {
                    return e.reduce(function(e, a) {
                        return a(t) ? e : (e.push(a.message),
                        e)
                    }, [])
                }
            }(s({
                msg: 'bad image'
            }, function(e) {
                return console.log('x', e),
                0 === e
            }), s({
                msg: 'more bad image'
            }, function(e) {
                return console.log('x', e),
                0 === e
            }))
              , A = {
                init: function(e) {
                    try {
                        window.addEventListener('unhandledrejection', function(t) {
                            e && console.log('Caught promise unhandled', t);
                            try {
                                'AbortError' === t.reason.name && t.preventDefault()
                            } catch (t) {}
                        }, {
                            once: !0
                        })
                    } catch (t) {}
                }
            }
        }
        ).call(this, a(16))
    }
    , function(e, t, a) {
        'use strict';
        function n() {
            return [{
                code: 111,
                type: 'CONSTRAINT_NOT_SATISFIED'
            }, {
                code: 112,
                type: 'NO_CAMERA_FOUND'
            }, {
                code: 113,
                type: 'CAMERA_PERMISSION_DENIED'
            }, {
                code: 120,
                type: 'CAMERA_UNKNOWN_DEVICE_ISSUE'
            }, {
                code: 130,
                type: 'MEDIA_RECORDER_NOT_SUPPORTED'
            }, {
                code: 405,
                type: 'USER_ACTION_EVENT_REQUIRED',
                desc: 'must pass html target element'
            }]
        }
        function i() {
            return [{
                code: 400,
                type: 'INVALID_DOCUMENT_TYPE',
                desc: 'Unrecognized document type'
            }, {
                code: 330,
                type: 'SDK_NOT_INITIALIZED',
                desc: 'Must call "init" method before capture'
            }, {
                code: 331,
                type: 'UNKNOWN_METHOD'
            }, {
                code: 332,
                type: 'INVALID_COMMAND_SIGNATURE',
                desc: '[str,fn] expected'
            }, {
                code: 333,
                type: 'USER_MEDIA_NOT_SUPPORTED'
            }, {
                code: 334,
                type: 'WASM_NOT_SUPPORTED'
            }, {
                code: 335,
                type: 'DEVICE_NOT_SUPPORTED'
            }, {
                code: 336,
                type: 'WEBGL_NOT_SUPPORTED'
            }, {
                code: 337,
                type: 'INVALID_COMMAND_SIGNATURE',
                desc: '[number] expected'
            }, {
                code: 338,
                type: 'UNKNOWN_ERROR',
                desc: 'choose valid error'
            }, {
                code: 339,
                type: 'WEBGL_SHADER_NOT_SUPPORTED'
            }, {
                code: 500,
                type: 'VIDEO_RECORDING_EXCEEDED_MAX_TIME'
            }, {
                code: 600,
                type: 'VIDEO_SOURCE_INVALID'
            }, {
                code: 601,
                type: 'VIDEO_PLAYBACK_ENDED'
            }]
        }
        function o() {
            return [].concat(i()).concat(n()).sort(function(e, t) {
                return e.code - t.code
            })
        }
        function r(e) {
            if ('number' != typeof e || +e === NaN)
                return r(337);
            var t = o().filter(function(t) {
                return t.code === e
            });
            return t.length ? t : r(338)
        }
        a.d(t, 'b', function() {
            return n
        }),
        a.d(t, 'a', function() {
            return o
        }),
        a.d(t, 'c', function() {
            return r
        })
    }
    , function(e, t, a) {
        'use strict';
        (function(e) {
            var n = a(7)
              , i = a.n(n)
              , o = a(13)
              , r = a.n(o)
              , s = a(14)
              , d = a.n(s)
              , l = a(5)
              , c = a.n(l)
              , p = a(2)
              , m = function() {
                function t() {
                    r()(this, t),
                    this.MINIMUM_VIDEO_BITRATE = 5e5,
                    this.MAXIMUM_VIDEO_BITRATE = 6e6,
                    this.MAXIMUM_RECORDING_SESSION_MS = 45e3,
                    this.RECORDING_CHUNK_MS = 10,
                    this.mediaRecorder = null,
                    this.recordedBlobs = [],
                    this.videoQuality = 80,
                    this.recordingMessage = 'Recording',
                    this.isVideoRecordingEnabled = !1,
                    this.isAudioRecordingEnabled = !1,
                    this.isDebugEnabled = !1,
                    this.videoSource = null
                }
                return d()(t, [{
                    key: 'getAudioConstraint',
                    value: function() {
                        return !!this.isAudioRecordingEnabled && {
                            echoCancellation: {
                                exact: !0
                            }
                        }
                    }
                }, {
                    key: 'getMibiData',
                    value: function() {
                        return {
                            VIDEO_RECORDING_ENABLED: this.isVideoRecordingEnabled,
                            AUDIO_RECORDING_ENABLED: this.isAudioRecordingEnabled,
                            VIDEO_QUALITY: this.videoQuality,
                            RECORDING_MESSAGE: this.recordingMessage
                        }
                    }
                }, {
                    key: 'getMaximumVideoRecordingTimeMS',
                    value: function() {
                        return this.MAXIMUM_RECORDING_SESSION_MS
                    }
                }, {
                    key: 'supportsRecording',
                    value: function() {
                        return 'undefined' != typeof e.MediaRecorder && 'undefined' != typeof e.MediaRecorder.isTypeSupported && 'undefined' != typeof this.getSupportedMimeType()
                    }
                }, {
                    key: 'enableDebug',
                    value: function() {
                        this.isDebugEnabled = !0
                    }
                }, {
                    key: 'getBitrateNormalized',
                    value: function() {
                        return (this.MAXIMUM_VIDEO_BITRATE - this.MINIMUM_VIDEO_BITRATE) * (this.videoQuality - 1) / 99 + this.MINIMUM_VIDEO_BITRATE
                    }
                }, {
                    key: 'getSupportedMimeType',
                    value: function() {
                        var t = this.isAudioRecordingEnabled ? 'video/webm;codecs=vp9,opus' : 'video/webm;codecs=vp9,'
                          , a = this.isAudioRecordingEnabled ? 'video/webm;codecs=vp8,opus' : 'video/webm;codecs=vp8,';
                        return [t, a, 'video/webm', 'video/mp4'].find(function(t) {
                            return e.MediaRecorder.isTypeSupported(t)
                        })
                    }
                }, {
                    key: 'startRecording',
                    value: function() {
                        var t = i()(c.a.mark(function t(a) {
                            var n = this, i;
                            return c.a.wrap(function(t) {
                                for (; ; )
                                    switch (t.prev = t.next) {
                                    case 0:
                                        i = {
                                            videoBitsPerSecond: this.getBitrateNormalized(),
                                            mimeType: this.getSupportedMimeType()
                                        },
                                        this.mediaRecorder = new e.MediaRecorder(a,i),
                                        this.mediaRecorder.ondataavailable = function(e) {
                                            n.handleDataAvailable(e)
                                        }
                                        ,
                                        this.mediaRecorder.onstop = function() {
                                            return n.handleStop()
                                        }
                                        ,
                                        this.mediaRecorder.onerror = function() {
                                            return n.handleError()
                                        }
                                        ,
                                        this.isDebugEnabled && console.log('Created MediaRecorder', this.mediaRecorder, 'with options', i),
                                        this.mediaRecorder.start(this.RECORDING_CHUNK_MS);
                                    case 7:
                                    case 'end':
                                        return t.stop();
                                    }
                            }, t, this)
                        }));
                        return function() {
                            return t.apply(this, arguments)
                        }
                    }()
                }, {
                    key: 'stopRecording',
                    value: function() {
                        var e = i()(c.a.mark(function e() {
                            var t;
                            return c.a.wrap(function(e) {
                                for (; ; )
                                    switch (e.prev = e.next) {
                                    case 0:
                                        return this.cancelRecording(),
                                        t = new Blob(this.recordedBlobs,{
                                            type: Object(p.g)() ? 'video/mp4' : 'video/webm'
                                        }),
                                        e.abrupt('return', new Promise(function(e, a) {
                                            var n = new FileReader;
                                            n.onloadend = function() {
                                                e(n.result)
                                            }
                                            ,
                                            n.onerror = function() {
                                                a()
                                            }
                                            ,
                                            n.readAsDataURL(t)
                                        }
                                        ));
                                    case 3:
                                    case 'end':
                                        return e.stop();
                                    }
                            }, e, this)
                        }));
                        return function() {
                            return e.apply(this, arguments)
                        }
                    }()
                }, {
                    key: 'cancelRecording',
                    value: function() {
                        this.mediaRecorder && 'recording' === this.mediaRecorder.state && this.mediaRecorder.stop()
                    }
                }, {
                    key: 'handleDataAvailable',
                    value: function(e) {
                        e.data && 0 < e.data.size && this.recordedBlobs.push(e.data)
                    }
                }, {
                    key: 'handleStop',
                    value: function() {
                        this.recordedBlobs = []
                    }
                }, {
                    key: 'handleError',
                    value: function() {}
                }]),
                t
            }();
            t.a = new m
        }
        ).call(this, a(16))
    }
    , function(e, t, a) {
        e.exports = a(109)
    }
    , function(e, t, a) {
        var n = a(105);
        e.exports = function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var a = null == arguments[t] ? {} : Object(arguments[t])
                  , i = Object.keys(a);
                'function' == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(a).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(a, e).enumerable
                }))),
                i.forEach(function(t) {
                    n(e, t, a[t])
                })
            }
            return e
        }
        ,
        e.exports['default'] = e.exports,
        e.exports.__esModule = !0
    }
    , function(e) {
        function t(e, t, a, n, i, o, r) {
            try {
                var s = e[o](r)
                  , d = s.value
            } catch (e) {
                return void a(e)
            }
            s.done ? t(d) : Promise.resolve(d).then(n, i)
        }
        e.exports = function(e) {
            return function() {
                var a = this
                  , n = arguments;
                return new Promise(function(i, o) {
                    function r(e) {
                        t(d, i, o, r, s, 'next', e)
                    }
                    function s(e) {
                        t(d, i, o, r, s, 'throw', e)
                    }
                    var d = e.apply(a, n);
                    r(void 0)
                }
                )
            }
        }
        ,
        e.exports['default'] = e.exports,
        e.exports.__esModule = !0
    }
    , function(e, t, a) {
        var n = a(44)('wks')
          , i = a(33)
          , o = a(11).Symbol
          , r = 'function' == typeof o
          , s = e.exports = function(e) {
            return n[e] || (n[e] = r && o[e] || (r ? o : i)('Symbol.' + e))
        }
        ;
        s.store = n
    }
    , function(e) {
        function t(a) {
            '@babel/helpers - typeof';
            return 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? (e.exports = t = function(e) {
                return typeof e
            }
            ,
            e.exports['default'] = e.exports,
            e.exports.__esModule = !0) : (e.exports = t = function(e) {
                return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e
            }
            ,
            e.exports['default'] = e.exports,
            e.exports.__esModule = !0),
            t(a)
        }
        e.exports = t,
        e.exports['default'] = e.exports,
        e.exports.__esModule = !0
    }
    , function(e, t, a) {
        'use strict';
        var n = a(9)
          , i = a.n(n);
        t.a = function() {
            var e = function() {
                try {
                    if ('object' === ('undefined' == typeof WebAssembly ? 'undefined' : i()(WebAssembly)) && 'function' == typeof WebAssembly.instantiate) {
                        var e = new WebAssembly.Module(Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0));
                        if (e instanceof WebAssembly.Module)
                            return new WebAssembly.Instance(e)instanceof WebAssembly.Instance
                    }
                } catch (t) {}
                return !1
            }();
            return e
        }
    }
    , function(e) {
        var t = e.exports = 'undefined' != typeof window && window.Math == Math ? window : 'undefined' != typeof self && self.Math == Math ? self : Function('return this')();
        'number' == typeof __g && (__g = t)
    }
    , function(e, a, i) {
        'use strict';
        (function(e) {
            function o(e, i, o, r) {
                var s = Math.trunc
                  , c = {
                    width: e,
                    height: i,
                    errorCode: null
                };
                if (!Object(d.d)(e) || !Object(d.d)(i) || !Object(d.d)(o) || !Object(d.d)(r))
                    return c.errorCode = l.PARAMETER_NOT_SET,
                    c;
                if (!Object(d.f)(e) || !Object(d.f)(i) || !Object(d.f)(o) || !Object(d.f)(r))
                    return c.errorCode = l.PARAMETER_NOT_NUMERIC,
                    c;
                var p = n(e, i)
                  , m = t(e, i);
                if (m < r)
                    return c.errorCode = l.IMAGE_SMALLER_THAN_MIN_SIZE,
                    c;
                if (o < r)
                    return c.errorCode = l.MAX_SIZE_EXCEEDS_MIN_SIZE,
                    c;
                if (p > o) {
                    if (e > i) {
                        var u = e / i;
                        c.width = o,
                        c.height = c.width / u
                    } else {
                        var u = i / e;
                        c.height = o,
                        c.width = c.height / u
                    }
                    c.width = s(c.width),
                    c.height = s(c.height)
                }
                return c
            }
            function r(t) {
                var a = performance.now()
                  , n = {
                    imageData: null,
                    processTime: null,
                    mibiData: null,
                    errorCode: null
                }
                  , i = !1;
                return (t.imageData instanceof e.File || 'undefined' != typeof t.imageData.data || 'string' == typeof t.imageData) && (i = !0),
                new Promise(function(r, s) {
                    if (!1 == i)
                        return n.errorCode = l.INVALID_IMAGE_DATA,
                        void s(n);
                    var p = new e.Image, m = document.createElement('canvas'), u = m.getContext('2d'), g = e.URL || e.webkitURL, y = {}, S, h;
                    if (t.imageData instanceof e.File)
                        S = g.createObjectURL(t.imageData);
                    else if ('string' == typeof t.imageData)
                        S = t.imageData;
                    else if ('undefined' != typeof t.imageData.data)
                        return y = o(t.imageData.width, t.imageData.height, t.maxImageSize, t.minImageSize),
                        m.width = t.imageData.width,
                        m.height = t.imageData.height,
                        u.putImageData(t.imageData, 0, 0),
                        u.drawImage(m, 0, 0, t.imageData.width, t.imageData.height, 0, 0, y.width, y.height),
                        h = void 0 === t.imageReturnType || t.imageReturnType === c.IMAGE_DATA ? u.getImageData(0, 0, y.width, y.height) : m.toDataURL('image/jpeg', t.imageQuality),
                        n.imageData = h,
                        n.processTime = (performance.now() - a).toFixed(2),
                        void r(n);
                    p.onerror = function() {
                        return n.errorCode = l.CORRUPT_IMAGE,
                        s(n),
                        n
                    }
                    ,
                    p.onload = function() {
                        y = o(p.width, p.height, t.maxImageSize, t.minImageSize),
                        Object(d.d)(y.errorCode) ? (n.errorCode = y.errorCode,
                        s(n)) : (m.width = y.width,
                        m.height = y.height,
                        u.drawImage(p, 0, 0, y.width, y.height),
                        h = void 0 === t.imageReturnType || t.imageReturnType === c.IMAGE_DATA ? u.getImageData(0, 0, m.width, m.height) : m.toDataURL('image/jpeg', t.imageQuality),
                        g.revokeObjectURL(S),
                        n.imageData = h,
                        n.processTime = (performance.now() - a).toFixed(2),
                        r(n))
                    }
                    ,
                    p.src = S
                }
                )
            }
            function s(e) {
                return e.type.match('image/jpeg.*')
            }
            i.d(a, 'a', function() {
                return c
            }),
            i.d(a, 'c', function() {
                return r
            }),
            i.d(a, 'b', function() {
                return s
            });
            var d = i(2)
              , l = {
                PARAMETER_NOT_SET: 'PARAMETER_NOT_SET',
                PARAMETER_NOT_NUMERIC: 'PARAMETER_NOT_NUMERIC',
                MAX_SIZE_EXCEEDS_MIN_SIZE: 'MAX_SIZE_EXCEEDS_MIN_SIZE',
                IMAGE_SMALLER_THAN_MIN_SIZE: 'IMAGE_SMALLER_THAN_MIN_SIZE',
                INVALID_IMAGE_DATA: 'INVALID_IMAGE_DATA',
                CORRUPT_IMAGE: 'CORRUPT_IMAGE'
            }
              , c = {
                IMAGE_DATA: 'ImageData object',
                DATA_URL: 'DataURL Object'
            }
        }
        ).call(this, i(16))
    }
    , function(e) {
        e.exports = function(e, t) {
            if (!(e instanceof t))
                throw new TypeError('Cannot call a class as a function')
        }
        ,
        e.exports['default'] = e.exports,
        e.exports.__esModule = !0
    }
    , function(e) {
        function t(e, t) {
            for (var a = 0, n; a < t.length; a++)
                n = t[a],
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                'value'in n && (n.writable = !0),
                Object.defineProperty(e, n.key, n)
        }
        e.exports = function(e, a, n) {
            return a && t(e.prototype, a),
            n && t(e, n),
            e
        }
        ,
        e.exports['default'] = e.exports,
        e.exports.__esModule = !0
    }
    , function(e, t, a) {
        'use strict';
        var n = a(13)
          , i = a.n(n)
          , o = a(14)
          , r = a.n(o)
          , s = a(0)
          , d = function() {
            function e() {
                i()(this, e),
                this.hasRootStateBeenReset = !1,
                this.isVideoElementsLoaded = !1,
                this.isScienceLoaded = !1,
                this.isReadyToProcessFrames = !1
            }
            return r()(e, [{
                key: 'updateReadinessState',
                value: function(e) {
                    var t = !0;
                    switch (e.ready) {
                    case 'scienceLoaded':
                        !0 === this.isScienceLoaded && (t = !1),
                        this.isScienceLoaded = !0;
                        break;
                    case 'videoElementsLoaded':
                        !0 === this.isVideoElementsLoaded && (t = !1),
                        this.isVideoElementsLoaded = !0;
                        break;
                    default:
                    }
                    t && this.onStateUpdate()
                }
            }, {
                key: 'onStateUpdate',
                value: function() {
                    this.cVideoAndScienceReady()
                }
            }, {
                key: 'resetVideoAndScienceState',
                value: function() {
                    this.isVideoElementsLoaded = !1
                }
            }, {
                key: 'resetReadyToProcessFramesState',
                value: function() {
                    this.isReadyToProcessFrames = !1
                }
            }, {
                key: 'resetState',
                value: function() {
                    this.hasRootStateBeenReset = !0,
                    this.resetVideoAndScienceState(),
                    this.resetReadyToProcessFramesState()
                }
            }, {
                key: 'cVideoAndScienceReady',
                value: function() {
                    var e = this;
                    this.isScienceLoaded && this.isVideoElementsLoaded && setTimeout(function() {
                        s.a.emit('_APPEND_VIDEO_COMPONENT_'),
                        s.a.emit('FRAME_PROCESSING_STARTED'),
                        s.a.emit('CAMERA_DISPLAY_STARTED'),
                        s.a.emit('USER_MEDIA_STREAM_ACTIVE'),
                        setTimeout(function() {
                            e.isReadyToProcessFrames = !0
                        }, 1e3)
                    }, 500)
                }
            }, {
                key: 'shouldProcessFrames',
                value: function() {
                    return this.isReadyToProcessFrames
                }
            }]),
            e
        }();
        t.a = new d
    }
    , function(e) {
        var t = function() {
            return this
        }();
        try {
            t = t || new Function('return this')()
        } catch (a) {
            'object' == typeof window && (t = window)
        }
        e.exports = t
    }
    , function(e, t, a) {
        var n = a(23);
        e.exports = function(e) {
            if (!n(e))
                throw TypeError(e + ' is not an object!');
            return e
        }
    }
    , function(e, t, a) {
        var n = a(28)
          , i = a(46);
        e.exports = a(24) ? function(e, t, a) {
            return n.f(e, t, i(1, a))
        }
        : function(e, t, a) {
            return e[t] = a,
            e
        }
    }
    , function(e, t) {
        'use strict';
        t.a = function() {
            return {
                MitekCaptureSession: {
                    MitekImageType: '',
                    Callback: '',
                    CVStartCallback: null,
                    ProcessImageCallback: null,
                    CaptureParams: '',
                    EXIFData: {}
                },
                MitekMibiAction: {
                    PAGE_LOADED: 'PL',
                    WORK_FLOW: 'WF',
                    START_CAPTURE: 'SC',
                    PICTURE_CAPTURED: 'PC',
                    SKIP_LINK: 'SL',
                    STATE_SELECTED: 'SP',
                    BACK_PARTIAL_DATA_FAILURE: 'ID',
                    DEVICE_EXCLUDED_ERROR: 'DE',
                    TOTAL_CV_TIME: 'TC',
                    TOTAL_ENCODING_TIME: 'EI',
                    FULL_BACK_SENT: 'FB',
                    CV_ENCODING_QUALITY: 'QX',
                    CV_IMAGE_WIDTH: 'QW',
                    CV_IMAGE_HEIGHT: 'QH',
                    CV_LANDSCAPE_PORTRAIT: 'LP',
                    CV_MEASURE_CONFIDENCE: 'QC',
                    CV_MEASURE_MIN_WIDTH: 'QM',
                    CV_ERROR_FOCUS: 'QF',
                    CV_ERROR_TOO_DARK: 'QD',
                    CV_ERROR_TOO_FAR: 'TF',
                    CV_ERROR_SKEW: 'QS',
                    CV_ERROR_HORIZONTAL_FILL: 'HF',
                    CV_ERROR_MIN_PADDING: 'MP',
                    CV_ERROR_CONFIDENCE: 'QE',
                    CV_ERROR_FAILURE: 'QQ',
                    CV_SUCCESS: 'SU',
                    CV_FINAL_IMAGE_SIZE: 'IS',
                    CV_NO_BARCODE_FOUND: 'NB',
                    CV_ERROR_GLARE: 'GD',
                    CV_ERROR_FOUR_CORNERS: 'FC',
                    AUTOCAPTURE_STOP: 'C',
                    AUTOCAPTURE_FRAME_PROCESSED: 'MC',
                    NOT_FOUND: 'NF',
                    BRIGHTNESS_FAILED: 'BF',
                    SHAPRNESS_FAILED: 'SF',
                    AUTOCAPTURE_TIME: 'MT',
                    AUTOCAPTURE_TIMEOUT: 'MF',
                    AUTOCAPTURE_ROTATE: 'RP',
                    MEASURED_HEIGHT: 'MH',
                    MEASURED_WIDTH: 'MW',
                    MEASURED_VIDEO_FRAME: 'MV',
                    CV_MEASURE_BRIGHTNESS: 'MB',
                    CV_MEASURE_SHARPNESS: 'MS',
                    CV_ERROR_LOW_CONTRAST: 'LC',
                    CV_ERROR_ASPECT_RATIO: 'AR',
                    CV_ERROR_BUSY_BACKGROUND: 'BB',
                    AUTOCAPTURE_CAMERA_DISPLAY: 'CD',
                    AUTOCAPTURE_FRAME_PROCESSING_STARTED: 'FP',
                    FACE_FAILURE_COUNT: 'FFC',
                    AUTOCAPTURE_FAST_SCORE: 'FST',
                    MEASURED_FOUR_CORNERS: 'MFC',
                    VIDEO_RECORDING_DATA: 'VID',
                    GLARE_FAILURE: 'GF',
                    AUTOCAPTURE_START: 'SA',
                    MANUAL_CAPTURE_START: 'SS'
                },
                MitekCaptureResult: {
                    IQA_GOOD: 0,
                    IQA_NF: 1,
                    IQA_OOF: 2,
                    IQA_DARK: 3,
                    IQA_MINFILL: 4,
                    IQA_SKEW: 5,
                    IQA_MINWIDTH: 6,
                    IQA_GLARE: 7,
                    IQA_FOURCORNERS: 8,
                    IQA_CORRUPTIMAGE: 9,
                    IQA_MINPADDING: 10,
                    IQA_LOWCONTRAST: 11,
                    IQA_BUSYBACKGROUND: 12,
                    PERMISSION_DENIED: 99,
                    Result: function() {
                        return {
                            errors: [],
                            status: '',
                            Metrics: {},
                            finalImage: null
                        }
                    }
                },
                MitekMibiData: {
                    MibiVersion: '1.6',
                    UserAgent: '',
                    Parameters: {
                        MiSnapVersion: 'MobileWeb 4.9.5'
                    },
                    WASMSupported: !0,
                    MiSnapResultCode: 'SuccessAutoCamera',
                    ImageSource: {
                        Platform: 'Mobile',
                        Method: 'CAPTURE_AND_PROCESS_FRAME',
                        Upload: 'false',
                        IQA: 'enabled'
                    },
                    Doctype: '',
                    UXP: []
                }
            }
        }
    }
    , function(e, t, a) {
        'use strict';
        var n = a(9), o = a.n(n), i = function() {
            this.events = {}
        }, r;
        r = 'function' == typeof Array.prototype.indexOf ? function(e, t) {
            return e.indexOf(t)
        }
        : function(e, t) {
            for (var a = 0, n = e.length, i = -1, o = !1; a < n && !o; )
                e[a] === t && (i = a,
                o = !0),
                a++;
            return i
        }
        ;
        i.prototype.on = function(e, t) {
            'object' !== o()(this.events[e]) && (this.events[e] = []),
            this.events[e].push(t)
        }
        ,
        i.prototype.removeListener = function(e, t) {
            var a;
            'object' === o()(this.events[e]) && (a = r(this.events[e], t),
            -1 < a && this.events[e].splice(a, 1))
        }
        ,
        i.prototype.removeAllListeners = function() {
            this.events = {}
        }
        ,
        i.prototype.emit = function(e) {
            var t = [].slice.call(arguments, 1), a, n, i;
            if ('object' === o()(this.events[e]))
                for (n = this.events[e].slice(),
                i = n.length,
                a = 0; a < i; a++)
                    n[a].apply(this, t)
        }
        ,
        i.prototype.once = function(e, t) {
            this.on(e, function a() {
                this.removeListener(e, a),
                t.apply(this, arguments)
            })
        }
        ,
        t.a = i
    }
    , function(e, t, a) {
        'use strict';
        var n = a(13)
          , i = a.n(n)
          , o = a(14)
          , r = a.n(o)
          , s = function() {
            function e() {
                i()(this, e),
                this.handlers = []
            }
            return r()(e, [{
                key: 'addHandler',
                value: function(e) {
                    if (this.isValidHandler(e))
                        return this.handlers.push(e),
                        this;
                    var t = new Error('Attempt to register an invalid handler with the mediator.');
                    return t.handler = e,
                    t
                }
            }, {
                key: 'isValidHandler',
                value: function(e) {
                    return 'function' == typeof e.canHandle && 'function' == typeof e.handle
                }
            }, {
                key: 'request',
                value: function(e) {
                    for (var t = 0, a; t < this.handlers.length; t++)
                        if (a = this.handlers[t],
                        a.canHandle(e))
                            return a.handle(e);
                    var n = new Error('Mediator was unable to satisfy request.');
                    return n.request = e,
                    n
                }
            }]),
            e
        }();
        t.a = new s
    }
    , function(e, t, a) {
        var n = a(11)
          , i = a(18)
          , o = a(29)
          , r = a(33)('src')
          , s = 'toString'
          , d = Function[s]
          , l = ('' + d).split(s);
        a(25).inspectSource = function(e) {
            return d.call(e)
        }
        ,
        (e.exports = function(e, t, a, s) {
            var d = 'function' == typeof a;
            d && (o(a, 'name') || i(a, 'name', t));
            e[t] === a || (d && (o(a, r) || i(a, r, e[t] ? '' + e[t] : l.join(t + ''))),
            e === n ? e[t] = a : s ? e[t] ? e[t] = a : i(e, t, a) : (delete e[t],
            i(e, t, a)))
        }
        )(Function.prototype, s, function() {
            return 'function' == typeof this && this[r] || d.call(this)
        })
    }
    , function(e) {
        e.exports = function(e) {
            return 'object' == typeof e ? null !== e : 'function' == typeof e
        }
    }
    , function(e, t, a) {
        e.exports = !a(45)(function() {
            return 7 != Object.defineProperty({}, 'a', {
                get: function() {
                    return 7
                }
            }).a
        })
    }
    , function(e) {
        var t = e.exports = {
            version: '2.5.4'
        };
        'number' == typeof __e && (__e = t)
    }
    , function(e) {
        e.exports = {}
    }
    , function(e) {
        var t = {}.toString;
        e.exports = function(e) {
            return t.call(e).slice(8, -1)
        }
    }
    , function(e, t, a) {
        var n = a(17)
          , i = a(74)
          , o = a(75)
          , r = Object.defineProperty;
        t.f = a(24) ? Object.defineProperty : function(e, t, a) {
            if (n(e),
            t = o(t, !0),
            n(a),
            i)
                try {
                    return r(e, t, a)
                } catch (t) {}
            if ('get'in a || 'set'in a)
                throw TypeError('Accessors not supported!');
            return 'value'in a && (e[t] = a.value),
            e
        }
    }
    , function(e) {
        var t = {}.hasOwnProperty;
        e.exports = function(e, a) {
            return t.call(e, a)
        }
    }
    , function(e, t, a) {
        var n = a(31);
        e.exports = function(e, t, a) {
            return (n(e),
            void 0 === t) ? e : 1 === a ? function(n) {
                return e.call(t, n)
            }
            : 2 === a ? function(n, a) {
                return e.call(t, n, a)
            }
            : 3 === a ? function(n, a, i) {
                return e.call(t, n, a, i)
            }
            : function() {
                return e.apply(t, arguments)
            }
        }
    }
    , function(e) {
        e.exports = function(e) {
            if ('function' != typeof e)
                throw TypeError(e + ' is not a function!');
            return e
        }
    }
    , function(e, t, a) {
        var n = a(27)
          , i = a(8)('toStringTag')
          , o = 'Arguments' == n(function() {
            return arguments
        }())
          , r = function(e, t) {
            try {
                return e[t]
            } catch (t) {}
        };
        e.exports = function(e) {
            var t, a, s;
            return e === void 0 ? 'Undefined' : null === e ? 'Null' : 'string' == typeof (a = r(t = Object(e), i)) ? a : o ? n(t) : 'Object' == (s = n(t)) && 'function' == typeof t.callee ? 'Arguments' : s
        }
    }
    , function(e) {
        var t = 0
          , a = Math.random();
        e.exports = function(e) {
            return 'Symbol('.concat(e === void 0 ? '' : e, ')_', (++t + a).toString(36))
        }
    }
    , function(e, t, a) {
        var n = a(23)
          , i = a(11).document
          , o = n(i) && n(i.createElement);
        e.exports = function(e) {
            return o ? i.createElement(e) : {}
        }
    }
    , function(t) {
        var a = Math.ceil;
        t.exports = function(t) {
            return isNaN(t = +t) ? 0 : (0 < t ? e : a)(t)
        }
    }
    , function(e) {
        e.exports = function(e) {
            if (e == void 0)
                throw TypeError('Can\'t call method on  ' + e);
            return e
        }
    }
    , function(e, t, a) {
        var n = a(82)
          , i = a(36);
        e.exports = function(e) {
            return n(i(e))
        }
    }
    , function(e, t, a) {
        var n = a(44)('keys')
          , i = a(33);
        e.exports = function(e) {
            return n[e] || (n[e] = i(e))
        }
    }
    , function(e, t, a) {
        var n = a(28).f
          , i = a(29)
          , o = a(8)('toStringTag');
        e.exports = function(e, t, a) {
            e && !i(e = a ? e : e.prototype, o) && n(e, o, {
                configurable: !0,
                value: t
            })
        }
    }
    , function(e, t, a) {
        'use strict';
        function n(e) {
            return -1 == ['ConstraintNotSatisfiedError', 'OverconstrainedError'].indexOf(e.name) ? Object(o.e)() && -1 != ['Error'].indexOf(e.name) ? Object(i.c)(111) : -1 == ['PermissionDeniedError', 'NotAllowedError'].indexOf(e.name) ? Object(i.c)(120) : Object(i.c)(113) : Object(i.c)(111)
        }
        a.d(t, 'a', function() {
            return n
        });
        var i = a(3)
          , o = a(2)
    }
    , function(e, a, i) {
        'use strict';
        function o(e, a, i, o, r, p, m, u) {
            var E = 'landscape' === c()
              , f = t(p.s1, p.s2)
              , R = n(p.s1, p.s2);
            if (g = {
                width: !0 == E ? R : f,
                height: !0 == E ? f : R
            },
            S = document.getElementById('mitekMedia'),
            h = document.querySelector('#mitekDisplayContainer'),
            S && h) {
                var A = d(m, u, i, o);
                s(m, u, r),
                l(A);
                var _ = n(m, u)
                  , C = t(m, u);
                m > u ? (h.style.height = C + 'px',
                h.style.width = _ + 'px') : (h.style.height = _ + 'px',
                h.style.width = C + 'px'),
                A.display = !0 === a ? 'block' : 'none';
                var T = y(A);
                e.setAttribute('style', T)
            }
        }
        function r() {
            return m
        }
        function s(e, a, n) {
            var i = g.height / a
              , o = g.width / e
              , r = 1 / t(i, o);
            if (u = Number.isFinite(r) ? r : 1,
            n) {
                var s = -1 * u;
                S.style.transform = 'translate(-50%, -50%) scale(' + s + ', ' + u + ')'
            } else
                S.style.transform = 'translate(-50%, -50%) scale(' + u + ')'
        }
        function d(e, a, i, o) {
            var r = Object(p.e)()
              , s = 'landscape' === c()
              , d = 0
              , l = 1
              , m = 0;
            d = r ? s ? i.guidePadding.mobile.landscape : i.guidePadding.mobile.portrait : i.guidePadding.desktop.landscape;
            1 === o ? m = d : 2 === o ? (l = r ? 1.25 : 1.15,
            m = d * l) : 3 === o ? (l = r ? 1.5 : 1.3,
            m = d * l) : void 0;
            var u = n(e, a)
              , g = t(e, a);
            d = parseInt(g * m / 2, 10);
            var y = parseInt(u / i.aspectRatio - 2 * d, 10)
              , S = parseInt(y * i.aspectRatio, 10);
            y + 2 * d > g && (y = parseInt(g - 2 * d, 10),
            S = parseInt(y * i.aspectRatio, 10));
            var h = parseInt((g - y) / 2, 10)
              , E = parseInt((u - S) / 2, 10)
              , f = {
                width: s ? S : y,
                height: s ? y : S,
                y: s ? h : E,
                x: s ? E : h
            };
            return f
        }
        function l(e) {
            var t = parseInt(e.width / u, 10)
              , a = parseInt(e.height / u, 10);
            m = {
                top: parseInt((g.height - a) / 2, 10),
                left: parseInt((g.width - t) / 2, 10),
                width: t,
                height: a
            }
        }
        function c() {
            var e = t(document.documentElement.clientWidth, window.innerWidth || 0)
              , a = t(document.documentElement.clientHeight, window.innerHeight || 0);
            return a > e ? 'portrait' : 'landscape'
        }
        i.d(a, 'b', function() {
            return o
        }),
        i.d(a, 'a', function() {
            return r
        });
        var p = i(2), m = {}, u = 1, g = {}, y = function(e) {
            return 'display:'.concat(e.display, '; position:absolute; top: ').concat(e.y, 'px; left: ').concat(e.x, 'px; width: ').concat(e.width, 'px; height:').concat(e.height, 'px; z-index: 100; ')
        }, S, h
    }
    , function(e) {
        'use strict';
        function t(e, t) {
            var n = e[1] || ''
              , i = e[3];
            if (!i)
                return n;
            if (t && 'function' == typeof btoa) {
                var o = a(i)
                  , r = i.sources.map(function(e) {
                    return '/*# sourceURL='.concat(i.sourceRoot).concat(e, ' */')
                });
                return [n].concat(r).concat([o]).join('\n')
            }
            return [n].join('\n')
        }
        function a(e) {
            var t = btoa(unescape(encodeURIComponent(JSON.stringify(e))))
              , a = 'sourceMappingURL=data:application/json;charset=utf-8;base64,'.concat(t);
            return '/*# '.concat(a, ' */')
        }
        e.exports = function(e) {
            var a = [];
            return a.toString = function() {
                return this.map(function(a) {
                    var n = t(a, e);
                    return a[2] ? '@media '.concat(a[2], '{').concat(n, '}') : n
                }).join('')
            }
            ,
            a.i = function(e, t) {
                'string' == typeof e && (e = [[null, e, '']]);
                for (var n = {}, o = 0, i; o < this.length; o++)
                    i = this[o][0],
                    null != i && (n[i] = !0);
                for (var r = 0, s; r < e.length; r++)
                    s = e[r],
                    null != s[0] && n[s[0]] || (t && !s[2] ? s[2] = t : t && (s[2] = '('.concat(s[2], ') and (').concat(t, ')')),
                    a.push(s))
            }
            ,
            a
        }
    }
    , function(e) {
        function t(e, t) {
            for (var a = 0; a < e.length; a++) {
                var n = e[a]
                  , i = l[n.id];
                if (i) {
                    i.refs++;
                    for (var r = 0; r < i.parts.length; r++)
                        i.parts[r](n.parts[r]);
                    for (; r < n.parts.length; r++)
                        i.parts.push(o(n.parts[r], t))
                } else {
                    for (var s = [], r = 0; r < n.parts.length; r++)
                        s.push(o(n.parts[r], t));
                    l[n.id] = {
                        id: n.id,
                        refs: 1,
                        parts: s
                    }
                }
            }
        }
        function a(e) {
            for (var t = [], a = {}, n = 0; n < e.length; n++) {
                var i = e[n]
                  , o = i[0]
                  , r = i[1]
                  , s = i[2]
                  , d = i[3]
                  , l = {
                    css: r,
                    media: s,
                    sourceMap: d
                };
                a[o] ? a[o].parts.push(l) : t.push(a[o] = {
                    id: o,
                    parts: [l]
                })
            }
            return t
        }
        function n() {
            var e = document.createElement('style')
              , t = m();
            return e.type = 'text/css',
            t.appendChild(e),
            e
        }
        function i() {
            var e = document.createElement('link')
              , t = m();
            return e.rel = 'stylesheet',
            t.appendChild(e),
            e
        }
        function o(e, t) {
            var a, o, l;
            if (t.singleton) {
                var c = g++;
                a = u || (u = n()),
                o = r.bind(null, a, c, !1),
                l = r.bind(null, a, c, !0)
            } else
                e.sourceMap && 'function' == typeof URL && 'function' == typeof URL.createObjectURL && 'function' == typeof URL.revokeObjectURL && 'function' == typeof Blob && 'function' == typeof btoa ? (a = i(),
                o = d.bind(null, a),
                l = function() {
                    a.parentNode.removeChild(a),
                    a.href && URL.revokeObjectURL(a.href)
                }
                ) : (a = n(),
                o = s.bind(null, a),
                l = function() {
                    a.parentNode.removeChild(a)
                }
                );
            return o(e),
            function(t) {
                if (t) {
                    if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap)
                        return;
                    o(e = t)
                } else
                    l()
            }
        }
        function r(e, t, a, n) {
            var i = a ? '' : n.css;
            if (e.styleSheet)
                e.styleSheet.cssText = y(t, i);
            else {
                var o = document.createTextNode(i)
                  , r = e.childNodes;
                r[t] && e.removeChild(r[t]),
                r.length ? e.insertBefore(o, r[t]) : e.appendChild(o)
            }
        }
        function s(e, t) {
            var a = t.css
              , n = t.media
              , i = t.sourceMap;
            if (n && e.setAttribute('media', n),
            e.styleSheet)
                e.styleSheet.cssText = a;
            else {
                for (; e.firstChild; )
                    e.removeChild(e.firstChild);
                e.appendChild(document.createTextNode(a))
            }
        }
        function d(e, t) {
            var a = t.css
              , n = t.media
              , i = t.sourceMap;
            i && (a += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + ' */');
            var o = new Blob([a],{
                type: 'text/css'
            })
              , r = e.href;
            e.href = URL.createObjectURL(o),
            r && URL.revokeObjectURL(r)
        }
        var l = {}
          , c = function(e) {
            var t;
            return function() {
                return 'undefined' == typeof t && (t = e.apply(this, arguments)),
                t
            }
        }
          , p = c(function() {
            return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())
        })
          , m = c(function() {
            return document.head || document.getElementsByTagName('head')[0]
        })
          , u = null
          , g = 0;
        e.exports = function(e, n) {
            if ('undefined' != typeof DEBUG && DEBUG && 'object' != typeof document)
                throw new Error('The style-loader cannot be used in a non-browser environment');
            n = n || {},
            'undefined' == typeof n.singleton && (n.singleton = p());
            var o = a(e);
            return t(o, n),
            function(e) {
                for (var r = [], s = 0; s < o.length; s++) {
                    var i = o[s]
                      , d = l[i.id];
                    d.refs--,
                    r.push(d)
                }
                if (e) {
                    var c = a(e);
                    t(c, n)
                }
                for (var s = 0, d; s < r.length; s++)
                    if (d = r[s],
                    0 === d.refs) {
                        for (var p = 0; p < d.parts.length; p++)
                            d.parts[p]();
                        delete l[d.id]
                    }
            }
        }
        ;
        var y = function() {
            var e = [];
            return function(t, a) {
                return e[t] = a,
                e.filter(Boolean).join('\n')
            }
        }()
    }
    , function(e, t, a) {
        var n = a(11)
          , i = '__core-js_shared__'
          , o = n[i] || (n[i] = {});
        e.exports = function(e) {
            return o[e] || (o[e] = {})
        }
    }
    , function(e) {
        e.exports = function(e) {
            try {
                return !!e()
            } catch (t) {
                return !0
            }
        }
    }
    , function(e) {
        e.exports = function(e, t) {
            return {
                enumerable: !(1 & e),
                configurable: !(2 & e),
                writable: !(4 & e),
                value: t
            }
        }
    }
    , function(e, t, a) {
        'use strict';
        var n = a(48)
          , i = a(49)
          , o = a(22)
          , r = a(18)
          , s = a(26)
          , d = a(78)
          , l = a(39)
          , c = a(85)
          , p = a(8)('iterator')
          , m = !([].keys && 'next'in [].keys())
          , u = 'keys'
          , g = 'values'
          , y = function() {
            return this
        };
        e.exports = function(e, t, a, S, h, E, f) {
            d(a, t, S);
            var R = function(e) {
                return !m && e in T ? T[e] : e === u ? function() {
                    return new a(this,e)
                }
                : e === g ? function() {
                    return new a(this,e)
                }
                : function() {
                    return new a(this,e)
                }
            }, A = t + ' Iterator', _ = h == g, C = !1, T = e.prototype, P = T[p] || T['@@iterator'] || h && T[h], D = P || R(h), I = h ? _ ? R('entries') : D : void 0, M = 'Array' == t ? T.entries || P : P, b, v, L;
            if (M && (L = c(M.call(new e)),
            L !== Object.prototype && L.next && (l(L, A, !0),
            !n && 'function' != typeof L[p] && r(L, p, y))),
            _ && P && P.name !== g && (C = !0,
            D = function() {
                return P.call(this)
            }
            ),
            (!n || f) && (m || C || !T[p]) && r(T, p, D),
            s[t] = D,
            s[A] = y,
            h)
                if (b = {
                    values: _ ? D : R(g),
                    keys: E ? D : R(u),
                    entries: I
                },
                f)
                    for (v in b)
                        v in T || o(T, v, b[v]);
                else
                    i(i.P + i.F * (m || C), t, b);
            return b
        }
    }
    , function(e) {
        e.exports = !1
    }
    , function(e, t, a) {
        var n = a(11)
          , i = a(25)
          , o = a(18)
          , r = a(22)
          , s = a(30)
          , d = 'prototype'
          , l = function(e, t, a) {
            var c = e & l.F, p = e & l.G, m = e & l.S, u = e & l.P, g = e & l.B, y = p ? n : m ? n[t] || (n[t] = {}) : (n[t] || {})[d], S = p ? i : i[t] || (i[t] = {}), h = S[d] || (S[d] = {}), E, f, R, A;
            for (E in p && (a = t),
            a)
                f = !c && y && void 0 !== y[E],
                R = (f ? y : a)[E],
                A = g && f ? s(R, n) : u && 'function' == typeof R ? s(Function.call, R) : R,
                y && r(y, E, R, e & l.U),
                S[E] != R && o(S, E, A),
                u && h[E] != R && (h[E] = R)
        };
        n.core = i,
        l.F = 1,
        l.G = 2,
        l.S = 4,
        l.P = 8,
        l.B = 16,
        l.W = 32,
        l.U = 64,
        l.R = 128,
        e.exports = l
    }
    , function(e, t, a) {
        var n = a(81)
          , i = a(52);
        e.exports = Object.keys || function(e) {
            return n(e, i)
        }
    }
    , function(e, a, n) {
        var i = n(35);
        e.exports = function(e) {
            return 0 < e ? t(i(e), 9007199254740991) : 0
        }
    }
    , function(e) {
        e.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf']
    }
    , function(e, t, a) {
        var n = a(11).document;
        e.exports = n && n.documentElement
    }
    , function(e, t, a) {
        var n = a(30), i = a(98), o = a(53), r = a(34), s = a(11), d = s.process, l = s.setImmediate, c = s.clearImmediate, p = s.MessageChannel, m = s.Dispatch, u = 0, g = {}, y = 'onreadystatechange', S = function() {
            var e = +this;
            if (g.hasOwnProperty(e)) {
                var t = g[e];
                delete g[e],
                t()
            }
        }, h = function(e) {
            S.call(e.data)
        }, E, f, R;
        l && c || (l = function(e) {
            for (var t = [], a = 1; arguments.length > a; )
                t.push(arguments[a++]);
            return g[++u] = function() {
                i('function' == typeof e ? e : Function(e), t)
            }
            ,
            E(u),
            u
        }
        ,
        c = function(e) {
            delete g[e]
        }
        ,
        'process' == a(27)(d) ? E = function(e) {
            d.nextTick(n(S, e, 1))
        }
        : m && m.now ? E = function(e) {
            m.now(n(S, e, 1))
        }
        : p ? (f = new p,
        R = f.port2,
        f.port1.onmessage = h,
        E = n(R.postMessage, R, 1)) : s.addEventListener && 'function' == typeof postMessage && !s.importScripts ? (E = function(e) {
            s.postMessage(e + '', '*')
        }
        ,
        s.addEventListener('message', h, !1)) : y in r('script') ? E = function(e) {
            o.appendChild(r('script'))[y] = function() {
                o.removeChild(this),
                S.call(e)
            }
        }
        : E = function(e) {
            setTimeout(n(S, e, 1), 0)
        }
        ),
        e.exports = {
            set: l,
            clear: c
        }
    }
    , function(e, t, a) {
        'use strict';
        function n(e) {
            var t, a;
            this.promise = new e(function(e, n) {
                if (t !== void 0 || a !== void 0)
                    throw TypeError('Bad Promise constructor');
                t = e,
                a = n
            }
            ),
            this.resolve = i(t),
            this.reject = i(a)
        }
        var i = a(31);
        e.exports.f = function(e) {
            return new n(e)
        }
    }
    , function(e, t, a) {
        'use strict';
        (function(e) {
            var n;
            e.document && e.document.currentScript && (n = new URL(e.document.currentScript.src),
            a.p = n.origin + a.p + '/'),
            t.a = {
                getPublicURL: function() {
                    return n
                },
                getPublicWP: function() {
                    return a.p
                },
                setPublicWP: function(e) {
                    e.endsWith('/') || (e += '/'),
                    a.p = e
                }
            }
        }
        ).call(this, a(16))
    }
    , function(t, a) {
        (function() {
            'use strict';
            function n(e) {
                return JSON.parse(JSON.stringify(e))
            }
            function i(e) {
                for (var t = g(e); '\xFF\xE0' <= t[1].slice(0, 2) && '\xFF\xEF' >= t[1].slice(0, 2); )
                    t = [t[0]].concat(t.slice(2));
                return t.join('')
            }
            function o(e) {
                return p('>' + u('B', e.length), e)
            }
            function r(e) {
                return p('>' + u('H', e.length), e)
            }
            function s(e) {
                return p('>' + u('L', e.length), e)
            }
            function d(e, t, a) {
                var i = '', d = '', l, c, m, g;
                if ('Byte' == t)
                    l = e.length,
                    4 >= l ? d = o(e) + u('\0', 4 - l) : (d = p('>L', [a]),
                    i = o(e));
                else if ('Short' == t)
                    l = e.length,
                    2 >= l ? d = r(e) + u('\0\0', 2 - l) : (d = p('>L', [a]),
                    i = r(e));
                else if ('Long' == t)
                    l = e.length,
                    1 >= l ? d = s(e) : (d = p('>L', [a]),
                    i = s(e));
                else if ('Ascii' == t)
                    c = e + '\0',
                    l = c.length,
                    4 < l ? (d = p('>L', [a]),
                    i = c) : d = c + u('\0', 4 - l);
                else if ('Rational' == t) {
                    if ('number' == typeof e[0])
                        l = 1,
                        m = e[0],
                        g = e[1],
                        c = p('>L', [m]) + p('>L', [g]);
                    else {
                        l = e.length,
                        c = '';
                        for (var y = 0; y < l; y++)
                            m = e[y][0],
                            g = e[y][1],
                            c += p('>L', [m]) + p('>L', [g])
                    }
                    d = p('>L', [a]),
                    i = c
                } else if ('SRational' == t) {
                    if ('number' == typeof e[0])
                        l = 1,
                        m = e[0],
                        g = e[1],
                        c = p('>l', [m]) + p('>l', [g]);
                    else {
                        l = e.length,
                        c = '';
                        for (var y = 0; y < l; y++)
                            m = e[y][0],
                            g = e[y][1],
                            c += p('>l', [m]) + p('>l', [g])
                    }
                    d = p('>L', [a]),
                    i = c
                } else
                    'Undefined' == t && (l = e.length,
                    4 < l ? (d = p('>L', [a]),
                    i = e) : d = e + u('\0', 4 - l));
                var n = p('>L', [l]);
                return [n, d, i]
            }
            function l(e, t, a) {
                var n = Object.keys(e).length, i = p('>H', [n]), o;
                o = -1 < ['0th', '1st'].indexOf(t) ? 2 + 12 * n + 4 : 2 + 12 * n;
                var r = '', s = '', l;
                for (var l in e) {
                    if ('string' == typeof l && (l = parseInt(l)),
                    '0th' == t && -1 < [34665, 34853].indexOf(l))
                        continue;
                    else if ('Exif' == t && 40965 == l)
                        continue;
                    else if ('1st' == t && -1 < [513, 514].indexOf(l))
                        continue;
                    var c = e[l]
                      , m = p('>H', [l])
                      , u = _[t][l].type
                      , g = p('>H', [A[u]]);
                    'number' == typeof c && (c = [c]);
                    var y = 8 + o + a + s.length
                      , S = d(c, u, y)
                      , h = S[0]
                      , E = S[1]
                      , f = S[2];
                    r += m + g + h + E,
                    s += f
                }
                return [i + r, s]
            }
            function c(e) {
                var t, a;
                if ('\xFF\xD8' == e.slice(0, 2))
                    t = g(e),
                    a = y(t),
                    this.tiftag = a ? a.slice(10) : null;
                else if (-1 < ['II', 'MM'].indexOf(e.slice(0, 2)))
                    this.tiftag = e;
                else if ('Exif' == e.slice(0, 4))
                    this.tiftag = e.slice(6);
                else
                    throw 'Given file is neither JPEG nor TIFF.'
            }
            function p(t, a) {
                if (!(a instanceof Array))
                    throw '\'pack\' error. Got invalid type argument.';
                if (t.length - 1 != a.length)
                    throw '\'pack\' error. ' + (t.length - 1) + ' marks, ' + a.length + ' elements.';
                var n;
                if ('<' == t[0])
                    n = !0;
                else if ('>' == t[0])
                    n = !1;
                else
                    throw '';
                for (var i = '', o = 1, r = null, s = null, d = null; s = t[o]; ) {
                    if ('b' == s.toLowerCase()) {
                        if (r = a[o - 1],
                        'b' == s && 0 > r && (r += 256),
                        255 < r || 0 > r)
                            throw '\'pack\' error.';
                        else
                            d = h(r);
                    } else if ('H' == s) {
                        if (r = a[o - 1],
                        65535 < r || 0 > r)
                            throw '\'pack\' error.';
                        else
                            d = h(e(r % 65536 / 256)) + h(r % 256),
                            n && (d = d.split('').reverse().join(''));
                    } else if ('l' != s.toLowerCase())
                        throw '\'pack\' error.';
                    else if (r = a[o - 1],
                    'l' == s && 0 > r && (r += 4294967296),
                    4294967295 < r || 0 > r)
                        throw '\'pack\' error.';
                    else
                        d = h(e(r / 16777216)) + h(e(r % 16777216 / 65536)) + h(e(r % 65536 / 256)) + h(r % 256),
                        n && (d = d.split('').reverse().join(''));
                    i += d,
                    o += 1
                }
                return i
            }
            function m(e, t) {
                if ('string' != typeof t)
                    throw '\'unpack\' error. Got invalid type argument.';
                for (var a = 0, n = 1; n < e.length; n++)
                    if ('b' == e[n].toLowerCase())
                        a += 1;
                    else if ('h' == e[n].toLowerCase())
                        a += 2;
                    else if ('l' == e[n].toLowerCase())
                        a += 4;
                    else
                        throw '\'unpack\' error. Got invalid mark.';
                if (a != t.length)
                    throw '\'unpack\' error. Mismatch between symbol and string length. ' + a + ':' + t.length;
                var i;
                if ('<' == e[0])
                    i = !0;
                else if ('>' == e[0])
                    i = !1;
                else
                    throw '\'unpack\' error.';
                for (var o = [], r = 0, s = 1, d = null, l = null, c = null, p = ''; l = e[s]; ) {
                    if ('b' == l.toLowerCase())
                        c = 1,
                        p = t.slice(r, r + c),
                        d = p.charCodeAt(0),
                        'b' == l && 128 <= d && (d -= 256);
                    else if ('H' == l)
                        c = 2,
                        p = t.slice(r, r + c),
                        i && (p = p.split('').reverse().join('')),
                        d = 256 * p.charCodeAt(0) + p.charCodeAt(1);
                    else if ('l' == l.toLowerCase())
                        c = 4,
                        p = t.slice(r, r + c),
                        i && (p = p.split('').reverse().join('')),
                        d = 16777216 * p.charCodeAt(0) + 65536 * p.charCodeAt(1) + 256 * p.charCodeAt(2) + p.charCodeAt(3),
                        'l' == l && 2147483648 <= d && (d -= 4294967296);
                    else
                        throw '\'unpack\' error. ' + l;
                    o.push(d),
                    r += c,
                    s += 1
                }
                return o
            }
            function u(e, t) {
                for (var a = '', n = 0; n < t; n++)
                    a += e;
                return a
            }
            function g(e) {
                if ('\xFF\xD8' != e.slice(0, 2))
                    throw 'Given data isn\'t JPEG.';
                for (var t = 2, a = ['\xFF\xD8']; ; ) {
                    if ('\xFF\xDA' == e.slice(t, t + 2)) {
                        a.push(e.slice(t));
                        break
                    } else {
                        var n = m('>H', e.slice(t + 2, t + 4))[0]
                          , i = t + n + 2;
                        a.push(e.slice(t, i)),
                        t = i
                    }
                    if (t >= e.length)
                        throw 'Wrong JPEG data.'
                }
                return a
            }
            function y(e) {
                for (var t = 0, a; t < e.length; t++)
                    if (a = e[t],
                    '\xFF\xE1' == a.slice(0, 2) && 'Exif\0\0' == a.slice(4, 10))
                        return a;
                return null
            }
            function S(e, t) {
                return '\xFF\xE0' == e[1].slice(0, 2) && '\xFF\xE1' == e[2].slice(0, 2) && 'Exif\0\0' == e[2].slice(4, 10) ? t ? (e[2] = t,
                e = ['\xFF\xD8'].concat(e.slice(2))) : null == t ? e = e.slice(0, 2).concat(e.slice(3)) : e = e.slice(0).concat(e.slice(2)) : '\xFF\xE0' == e[1].slice(0, 2) ? t && (e[1] = t) : '\xFF\xE1' == e[1].slice(0, 2) && 'Exif\0\0' == e[1].slice(4, 10) ? t ? e[1] = t : null == t && (e = e.slice(0).concat(e.slice(2))) : t && (e = [e[0], t].concat(e.slice(1))),
                e.join('')
            }
            var h = String.fromCharCode
              , E = {};
            if (E.version = '1.03',
            E.remove = function(e) {
                var t = !1;
                if ('\xFF\xD8' == e.slice(0, 2))
                    ;
                else if ('data:image/jpeg;base64,' == e.slice(0, 23) || 'data:image/jpg;base64,' == e.slice(0, 22))
                    e = R(e.split(',')[1]),
                    t = !0;
                else
                    throw 'Given data is not jpeg.';
                var a = g(e);
                if ('\xFF\xE1' == a[1].slice(0, 2) && 'Exif\0\0' == a[1].slice(4, 10))
                    a = [a[0]].concat(a.slice(2));
                else if ('\xFF\xE1' == a[2].slice(0, 2) && 'Exif\0\0' == a[2].slice(4, 10))
                    a = a.slice(0, 2).concat(a.slice(3));
                else
                    throw 'Exif not found.';
                var n = a.join('');
                return t && (n = 'data:image/jpeg;base64,' + f(n)),
                n
            }
            ,
            E.insert = function(e, t) {
                var a = !1;
                if ('Exif\0\0' != e.slice(0, 6))
                    throw 'Given data is not exif.';
                if ('\xFF\xD8' == t.slice(0, 2))
                    ;
                else if ('data:image/jpeg;base64,' == t.slice(0, 23) || 'data:image/jpg;base64,' == t.slice(0, 22))
                    t = R(t.split(',')[1]),
                    a = !0;
                else
                    throw 'Given data is not jpeg.';
                var n = '\xFF\xE1' + p('>H', [e.length + 2]) + e
                  , i = g(t)
                  , o = S(i, n);
                return a && (o = 'data:image/jpeg;base64,' + f(o)),
                o
            }
            ,
            E.load = function(e) {
                var t;
                if ('string' != typeof e)
                    throw '\'load\' gots invalid type argument.';
                else if ('\xFF\xD8' == e.slice(0, 2))
                    t = e;
                else if ('data:image/jpeg;base64,' == e.slice(0, 23) || 'data:image/jpg;base64,' == e.slice(0, 22))
                    t = R(e.split(',')[1]);
                else if ('Exif' == e.slice(0, 4))
                    t = e.slice(6);
                else
                    throw '\'load\' gots invalid file data.';
                var a = {
                    "0th": {},
                    Exif: {},
                    GPS: {},
                    Interop: {},
                    "1st": {},
                    thumbnail: null
                }
                  , n = new c(t);
                if (null === n.tiftag)
                    return a;
                n.endian_mark = 'II' == n.tiftag.slice(0, 2) ? '<' : '>';
                var i = m(n.endian_mark + 'L', n.tiftag.slice(4, 8))[0];
                a['0th'] = n.get_ifd(i, '0th');
                var o = a['0th'].first_ifd_pointer;
                if (delete a['0th'].first_ifd_pointer,
                34665 in a['0th'] && (i = a['0th'][34665],
                a.Exif = n.get_ifd(i, 'Exif')),
                34853 in a['0th'] && (i = a['0th'][34853],
                a.GPS = n.get_ifd(i, 'GPS')),
                40965 in a.Exif && (i = a.Exif[40965],
                a.Interop = n.get_ifd(i, 'Interop')),
                '\0\0\0\0' != o && (i = m(n.endian_mark + 'L', o)[0],
                a['1st'] = n.get_ifd(i, '1st'),
                513 in a['1st'] && 514 in a['1st'])) {
                    var r = a['1st'][513] + a['1st'][514]
                      , s = n.tiftag.slice(a['1st'][513], r);
                    a.thumbnail = s
                }
                return a
            }
            ,
            E.dump = function(e) {
                var t = 8, a = n(e), o = !1, r = !1, s = !1, d = !1, c, m, u, g, y;
                c = '0th'in a ? a['0th'] : {},
                'Exif'in a && Object.keys(a.Exif).length || 'Interop'in a && Object.keys(a.Interop).length ? (c[34665] = 1,
                o = !0,
                m = a.Exif,
                'Interop'in a && Object.keys(a.Interop).length ? (m[40965] = 1,
                s = !0,
                u = a.Interop) : -1 < Object.keys(m).indexOf(E.ExifIFD.InteroperabilityTag.toString()) && delete m[40965]) : -1 < Object.keys(c).indexOf(E.ImageIFD.ExifTag.toString()) && delete c[34665],
                'GPS'in a && Object.keys(a.GPS).length ? (c[E.ImageIFD.GPSTag] = 1,
                r = !0,
                g = a.GPS) : -1 < Object.keys(c).indexOf(E.ImageIFD.GPSTag.toString()) && delete c[E.ImageIFD.GPSTag],
                '1st'in a && 'thumbnail'in a && null != a.thumbnail && (d = !0,
                a['1st'][513] = 1,
                a['1st'][514] = 1,
                y = a['1st']);
                var S = l(c, '0th', 0), h = S[0].length + 12 * o + 12 * r + 4 + S[1].length, f = '', R = 0, _ = '', C = 0, T = '', P = 0, D = '', I, M, b, v, L;
                if (o && (I = l(m, 'Exif', h),
                R = I[0].length + 12 * s + I[1].length),
                r && (M = l(g, 'GPS', h + R),
                _ = M.join(''),
                C = _.length),
                s) {
                    var x = h + R + C;
                    b = l(u, 'Interop', x),
                    T = b.join(''),
                    P = T.length
                }
                if (d) {
                    var x = h + R + C + P;
                    if (v = l(y, '1st', x),
                    L = i(a.thumbnail),
                    64e3 < L.length)
                        throw 'Given thumbnail is too large. max 64kB'
                }
                var O = ''
                  , k = ''
                  , N = ''
                  , F = '\0\0\0\0';
                if (o) {
                    var w = t + h
                      , U = p('>L', [w])
                      , G = 34665
                      , B = p('>H', [G])
                      , V = p('>H', [A.Long])
                      , H = p('>L', [1]);
                    O = B + V + H + U
                }
                if (r) {
                    var w = t + h + R
                      , U = p('>L', [w])
                      , G = 34853
                      , B = p('>H', [G])
                      , V = p('>H', [A.Long])
                      , H = p('>L', [1]);
                    k = B + V + H + U
                }
                if (s) {
                    var w = t + h + R + C
                      , U = p('>L', [w])
                      , G = 40965
                      , B = p('>H', [G])
                      , V = p('>H', [A.Long])
                      , H = p('>L', [1]);
                    N = B + V + H + U
                }
                if (d) {
                    var w = t + h + R + C + P;
                    F = p('>L', [w]);
                    var j = w + v[0].length + 24 + 4 + v[1].length
                      , K = '\x02\x01\0\x04\0\0\0\x01' + p('>L', [j])
                      , q = '\x02\x02\0\x04\0\0\0\x01' + p('>L', [L.length]);
                    D = v[0] + K + q + '\0\0\0\0' + v[1] + L
                }
                var z = S[0] + O + k + F + S[1];
                return o && (f = I[0] + N + I[1]),
                'Exif\0\0MM\0*\0\0\0\b' + z + f + _ + T + D
            }
            ,
            c.prototype = {
                get_ifd: function(e, a) {
                    var n = {}, i = m(this.endian_mark + 'H', this.tiftag.slice(e, e + 2))[0], o = e + 2, r;
                    r = -1 < ['0th', '1st'].indexOf(a) ? 'Image' : a;
                    for (var t = 0; t < i; t++) {
                        e = o + 12 * t;
                        var s = m(this.endian_mark + 'H', this.tiftag.slice(e, e + 2))[0]
                          , d = m(this.endian_mark + 'H', this.tiftag.slice(e + 2, e + 4))[0]
                          , l = m(this.endian_mark + 'L', this.tiftag.slice(e + 4, e + 8))[0]
                          , c = this.tiftag.slice(e + 8, e + 12);
                        s in _[r] && (n[s] = this.convert_value([d, l, c]))
                    }
                    return '0th' == a && (e = o + 12 * i,
                    n.first_ifd_pointer = this.tiftag.slice(e, e + 4)),
                    n
                },
                convert_value: function(e) {
                    var a = null, n = e[0], t = e[1], i = e[2], o;
                    if (1 == n)
                        4 < t ? (o = m(this.endian_mark + 'L', i)[0],
                        a = m(this.endian_mark + u('B', t), this.tiftag.slice(o, o + t))) : a = m(this.endian_mark + u('B', t), i.slice(0, t));
                    else if (2 == n)
                        4 < t ? (o = m(this.endian_mark + 'L', i)[0],
                        a = this.tiftag.slice(o, o + t - 1)) : a = i.slice(0, t - 1);
                    else if (3 == n)
                        2 < t ? (o = m(this.endian_mark + 'L', i)[0],
                        a = m(this.endian_mark + u('H', t), this.tiftag.slice(o, o + 2 * t))) : a = m(this.endian_mark + u('H', t), i.slice(0, 2 * t));
                    else if (4 == n)
                        1 < t ? (o = m(this.endian_mark + 'L', i)[0],
                        a = m(this.endian_mark + u('L', t), this.tiftag.slice(o, o + 4 * t))) : a = m(this.endian_mark + u('L', t), i);
                    else if (5 == n) {
                        if (o = m(this.endian_mark + 'L', i)[0],
                        1 < t) {
                            a = [];
                            for (var r = 0; r < t; r++)
                                a.push([m(this.endian_mark + 'L', this.tiftag.slice(o + 8 * r, o + 4 + 8 * r))[0], m(this.endian_mark + 'L', this.tiftag.slice(o + 4 + 8 * r, o + 8 + 8 * r))[0]])
                        } else
                            a = [m(this.endian_mark + 'L', this.tiftag.slice(o, o + 4))[0], m(this.endian_mark + 'L', this.tiftag.slice(o + 4, o + 8))[0]];
                    } else if (7 == n)
                        4 < t ? (o = m(this.endian_mark + 'L', i)[0],
                        a = this.tiftag.slice(o, o + t)) : a = i.slice(0, t);
                    else if (10 != n)
                        throw 'Exif might be wrong. Got incorrect value type to decode. type:' + n;
                    else if (o = m(this.endian_mark + 'L', i)[0],
                    1 < t) {
                        a = [];
                        for (var r = 0; r < t; r++)
                            a.push([m(this.endian_mark + 'l', this.tiftag.slice(o + 8 * r, o + 4 + 8 * r))[0], m(this.endian_mark + 'l', this.tiftag.slice(o + 4 + 8 * r, o + 8 + 8 * r))[0]])
                    } else
                        a = [m(this.endian_mark + 'l', this.tiftag.slice(o, o + 4))[0], m(this.endian_mark + 'l', this.tiftag.slice(o + 4, o + 8))[0]];
                    return a instanceof Array && 1 == a.length ? a[0] : a
                }
            },
            'undefined' == typeof f)
                var f = function(e) {
                    for (var t = '', a = 0, n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=', i, o, r, s, d, l, c; a < e.length; )
                        i = e.charCodeAt(a++),
                        o = e.charCodeAt(a++),
                        r = e.charCodeAt(a++),
                        s = i >> 2,
                        d = (3 & i) << 4 | o >> 4,
                        l = (15 & o) << 2 | r >> 6,
                        c = 63 & r,
                        isNaN(o) ? l = c = 64 : isNaN(r) && (c = 64),
                        t = t + n.charAt(s) + n.charAt(d) + n.charAt(l) + n.charAt(c);
                    return t
                };
            if ('undefined' == typeof R)
                var R = function(e) {
                    var t = '', a = 0, n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=', i, o, r, s, d, l, c;
                    for (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ''); a < e.length; )
                        s = n.indexOf(e.charAt(a++)),
                        d = n.indexOf(e.charAt(a++)),
                        l = n.indexOf(e.charAt(a++)),
                        c = n.indexOf(e.charAt(a++)),
                        i = s << 2 | d >> 4,
                        o = (15 & d) << 4 | l >> 2,
                        r = (3 & l) << 6 | c,
                        t += h(i),
                        64 != l && (t += h(o)),
                        64 != c && (t += h(r));
                    return t
                };
            var A = {
                Byte: 1,
                Ascii: 2,
                Short: 3,
                Long: 4,
                Rational: 5,
                Undefined: 7,
                SLong: 9,
                SRational: 10
            }
              , _ = {
                Image: {
                    11: {
                        name: 'ProcessingSoftware',
                        type: 'Ascii'
                    },
                    254: {
                        name: 'NewSubfileType',
                        type: 'Long'
                    },
                    255: {
                        name: 'SubfileType',
                        type: 'Short'
                    },
                    256: {
                        name: 'ImageWidth',
                        type: 'Long'
                    },
                    257: {
                        name: 'ImageLength',
                        type: 'Long'
                    },
                    258: {
                        name: 'BitsPerSample',
                        type: 'Short'
                    },
                    259: {
                        name: 'Compression',
                        type: 'Short'
                    },
                    262: {
                        name: 'PhotometricInterpretation',
                        type: 'Short'
                    },
                    263: {
                        name: 'Threshholding',
                        type: 'Short'
                    },
                    264: {
                        name: 'CellWidth',
                        type: 'Short'
                    },
                    265: {
                        name: 'CellLength',
                        type: 'Short'
                    },
                    266: {
                        name: 'FillOrder',
                        type: 'Short'
                    },
                    269: {
                        name: 'DocumentName',
                        type: 'Ascii'
                    },
                    270: {
                        name: 'ImageDescription',
                        type: 'Ascii'
                    },
                    271: {
                        name: 'Make',
                        type: 'Ascii'
                    },
                    272: {
                        name: 'Model',
                        type: 'Ascii'
                    },
                    273: {
                        name: 'StripOffsets',
                        type: 'Long'
                    },
                    274: {
                        name: 'Orientation',
                        type: 'Short'
                    },
                    277: {
                        name: 'SamplesPerPixel',
                        type: 'Short'
                    },
                    278: {
                        name: 'RowsPerStrip',
                        type: 'Long'
                    },
                    279: {
                        name: 'StripByteCounts',
                        type: 'Long'
                    },
                    282: {
                        name: 'XResolution',
                        type: 'Rational'
                    },
                    283: {
                        name: 'YResolution',
                        type: 'Rational'
                    },
                    284: {
                        name: 'PlanarConfiguration',
                        type: 'Short'
                    },
                    290: {
                        name: 'GrayResponseUnit',
                        type: 'Short'
                    },
                    291: {
                        name: 'GrayResponseCurve',
                        type: 'Short'
                    },
                    292: {
                        name: 'T4Options',
                        type: 'Long'
                    },
                    293: {
                        name: 'T6Options',
                        type: 'Long'
                    },
                    296: {
                        name: 'ResolutionUnit',
                        type: 'Short'
                    },
                    301: {
                        name: 'TransferFunction',
                        type: 'Short'
                    },
                    305: {
                        name: 'Software',
                        type: 'Ascii'
                    },
                    306: {
                        name: 'DateTime',
                        type: 'Ascii'
                    },
                    315: {
                        name: 'Artist',
                        type: 'Ascii'
                    },
                    316: {
                        name: 'HostComputer',
                        type: 'Ascii'
                    },
                    317: {
                        name: 'Predictor',
                        type: 'Short'
                    },
                    318: {
                        name: 'WhitePoint',
                        type: 'Rational'
                    },
                    319: {
                        name: 'PrimaryChromaticities',
                        type: 'Rational'
                    },
                    320: {
                        name: 'ColorMap',
                        type: 'Short'
                    },
                    321: {
                        name: 'HalftoneHints',
                        type: 'Short'
                    },
                    322: {
                        name: 'TileWidth',
                        type: 'Short'
                    },
                    323: {
                        name: 'TileLength',
                        type: 'Short'
                    },
                    324: {
                        name: 'TileOffsets',
                        type: 'Short'
                    },
                    325: {
                        name: 'TileByteCounts',
                        type: 'Short'
                    },
                    330: {
                        name: 'SubIFDs',
                        type: 'Long'
                    },
                    332: {
                        name: 'InkSet',
                        type: 'Short'
                    },
                    333: {
                        name: 'InkNames',
                        type: 'Ascii'
                    },
                    334: {
                        name: 'NumberOfInks',
                        type: 'Short'
                    },
                    336: {
                        name: 'DotRange',
                        type: 'Byte'
                    },
                    337: {
                        name: 'TargetPrinter',
                        type: 'Ascii'
                    },
                    338: {
                        name: 'ExtraSamples',
                        type: 'Short'
                    },
                    339: {
                        name: 'SampleFormat',
                        type: 'Short'
                    },
                    340: {
                        name: 'SMinSampleValue',
                        type: 'Short'
                    },
                    341: {
                        name: 'SMaxSampleValue',
                        type: 'Short'
                    },
                    342: {
                        name: 'TransferRange',
                        type: 'Short'
                    },
                    343: {
                        name: 'ClipPath',
                        type: 'Byte'
                    },
                    344: {
                        name: 'XClipPathUnits',
                        type: 'Long'
                    },
                    345: {
                        name: 'YClipPathUnits',
                        type: 'Long'
                    },
                    346: {
                        name: 'Indexed',
                        type: 'Short'
                    },
                    347: {
                        name: 'JPEGTables',
                        type: 'Undefined'
                    },
                    351: {
                        name: 'OPIProxy',
                        type: 'Short'
                    },
                    512: {
                        name: 'JPEGProc',
                        type: 'Long'
                    },
                    513: {
                        name: 'JPEGInterchangeFormat',
                        type: 'Long'
                    },
                    514: {
                        name: 'JPEGInterchangeFormatLength',
                        type: 'Long'
                    },
                    515: {
                        name: 'JPEGRestartInterval',
                        type: 'Short'
                    },
                    517: {
                        name: 'JPEGLosslessPredictors',
                        type: 'Short'
                    },
                    518: {
                        name: 'JPEGPointTransforms',
                        type: 'Short'
                    },
                    519: {
                        name: 'JPEGQTables',
                        type: 'Long'
                    },
                    520: {
                        name: 'JPEGDCTables',
                        type: 'Long'
                    },
                    521: {
                        name: 'JPEGACTables',
                        type: 'Long'
                    },
                    529: {
                        name: 'YCbCrCoefficients',
                        type: 'Rational'
                    },
                    530: {
                        name: 'YCbCrSubSampling',
                        type: 'Short'
                    },
                    531: {
                        name: 'YCbCrPositioning',
                        type: 'Short'
                    },
                    532: {
                        name: 'ReferenceBlackWhite',
                        type: 'Rational'
                    },
                    700: {
                        name: 'XMLPacket',
                        type: 'Byte'
                    },
                    18246: {
                        name: 'Rating',
                        type: 'Short'
                    },
                    18249: {
                        name: 'RatingPercent',
                        type: 'Short'
                    },
                    32781: {
                        name: 'ImageID',
                        type: 'Ascii'
                    },
                    33421: {
                        name: 'CFARepeatPatternDim',
                        type: 'Short'
                    },
                    33422: {
                        name: 'CFAPattern',
                        type: 'Byte'
                    },
                    33423: {
                        name: 'BatteryLevel',
                        type: 'Rational'
                    },
                    33432: {
                        name: 'Copyright',
                        type: 'Ascii'
                    },
                    33434: {
                        name: 'ExposureTime',
                        type: 'Rational'
                    },
                    34377: {
                        name: 'ImageResources',
                        type: 'Byte'
                    },
                    34665: {
                        name: 'ExifTag',
                        type: 'Long'
                    },
                    34675: {
                        name: 'InterColorProfile',
                        type: 'Undefined'
                    },
                    34853: {
                        name: 'GPSTag',
                        type: 'Long'
                    },
                    34857: {
                        name: 'Interlace',
                        type: 'Short'
                    },
                    34858: {
                        name: 'TimeZoneOffset',
                        type: 'Long'
                    },
                    34859: {
                        name: 'SelfTimerMode',
                        type: 'Short'
                    },
                    37387: {
                        name: 'FlashEnergy',
                        type: 'Rational'
                    },
                    37388: {
                        name: 'SpatialFrequencyResponse',
                        type: 'Undefined'
                    },
                    37389: {
                        name: 'Noise',
                        type: 'Undefined'
                    },
                    37390: {
                        name: 'FocalPlaneXResolution',
                        type: 'Rational'
                    },
                    37391: {
                        name: 'FocalPlaneYResolution',
                        type: 'Rational'
                    },
                    37392: {
                        name: 'FocalPlaneResolutionUnit',
                        type: 'Short'
                    },
                    37393: {
                        name: 'ImageNumber',
                        type: 'Long'
                    },
                    37394: {
                        name: 'SecurityClassification',
                        type: 'Ascii'
                    },
                    37395: {
                        name: 'ImageHistory',
                        type: 'Ascii'
                    },
                    37397: {
                        name: 'ExposureIndex',
                        type: 'Rational'
                    },
                    37398: {
                        name: 'TIFFEPStandardID',
                        type: 'Byte'
                    },
                    37399: {
                        name: 'SensingMethod',
                        type: 'Short'
                    },
                    40091: {
                        name: 'XPTitle',
                        type: 'Byte'
                    },
                    40092: {
                        name: 'XPComment',
                        type: 'Byte'
                    },
                    40093: {
                        name: 'XPAuthor',
                        type: 'Byte'
                    },
                    40094: {
                        name: 'XPKeywords',
                        type: 'Byte'
                    },
                    40095: {
                        name: 'XPSubject',
                        type: 'Byte'
                    },
                    50341: {
                        name: 'PrintImageMatching',
                        type: 'Undefined'
                    },
                    50706: {
                        name: 'DNGVersion',
                        type: 'Byte'
                    },
                    50707: {
                        name: 'DNGBackwardVersion',
                        type: 'Byte'
                    },
                    50708: {
                        name: 'UniqueCameraModel',
                        type: 'Ascii'
                    },
                    50709: {
                        name: 'LocalizedCameraModel',
                        type: 'Byte'
                    },
                    50710: {
                        name: 'CFAPlaneColor',
                        type: 'Byte'
                    },
                    50711: {
                        name: 'CFALayout',
                        type: 'Short'
                    },
                    50712: {
                        name: 'LinearizationTable',
                        type: 'Short'
                    },
                    50713: {
                        name: 'BlackLevelRepeatDim',
                        type: 'Short'
                    },
                    50714: {
                        name: 'BlackLevel',
                        type: 'Rational'
                    },
                    50715: {
                        name: 'BlackLevelDeltaH',
                        type: 'SRational'
                    },
                    50716: {
                        name: 'BlackLevelDeltaV',
                        type: 'SRational'
                    },
                    50717: {
                        name: 'WhiteLevel',
                        type: 'Short'
                    },
                    50718: {
                        name: 'DefaultScale',
                        type: 'Rational'
                    },
                    50719: {
                        name: 'DefaultCropOrigin',
                        type: 'Short'
                    },
                    50720: {
                        name: 'DefaultCropSize',
                        type: 'Short'
                    },
                    50721: {
                        name: 'ColorMatrix1',
                        type: 'SRational'
                    },
                    50722: {
                        name: 'ColorMatrix2',
                        type: 'SRational'
                    },
                    50723: {
                        name: 'CameraCalibration1',
                        type: 'SRational'
                    },
                    50724: {
                        name: 'CameraCalibration2',
                        type: 'SRational'
                    },
                    50725: {
                        name: 'ReductionMatrix1',
                        type: 'SRational'
                    },
                    50726: {
                        name: 'ReductionMatrix2',
                        type: 'SRational'
                    },
                    50727: {
                        name: 'AnalogBalance',
                        type: 'Rational'
                    },
                    50728: {
                        name: 'AsShotNeutral',
                        type: 'Short'
                    },
                    50729: {
                        name: 'AsShotWhiteXY',
                        type: 'Rational'
                    },
                    50730: {
                        name: 'BaselineExposure',
                        type: 'SRational'
                    },
                    50731: {
                        name: 'BaselineNoise',
                        type: 'Rational'
                    },
                    50732: {
                        name: 'BaselineSharpness',
                        type: 'Rational'
                    },
                    50733: {
                        name: 'BayerGreenSplit',
                        type: 'Long'
                    },
                    50734: {
                        name: 'LinearResponseLimit',
                        type: 'Rational'
                    },
                    50735: {
                        name: 'CameraSerialNumber',
                        type: 'Ascii'
                    },
                    50736: {
                        name: 'LensInfo',
                        type: 'Rational'
                    },
                    50737: {
                        name: 'ChromaBlurRadius',
                        type: 'Rational'
                    },
                    50738: {
                        name: 'AntiAliasStrength',
                        type: 'Rational'
                    },
                    50739: {
                        name: 'ShadowScale',
                        type: 'SRational'
                    },
                    50740: {
                        name: 'DNGPrivateData',
                        type: 'Byte'
                    },
                    50741: {
                        name: 'MakerNoteSafety',
                        type: 'Short'
                    },
                    50778: {
                        name: 'CalibrationIlluminant1',
                        type: 'Short'
                    },
                    50779: {
                        name: 'CalibrationIlluminant2',
                        type: 'Short'
                    },
                    50780: {
                        name: 'BestQualityScale',
                        type: 'Rational'
                    },
                    50781: {
                        name: 'RawDataUniqueID',
                        type: 'Byte'
                    },
                    50827: {
                        name: 'OriginalRawFileName',
                        type: 'Byte'
                    },
                    50828: {
                        name: 'OriginalRawFileData',
                        type: 'Undefined'
                    },
                    50829: {
                        name: 'ActiveArea',
                        type: 'Short'
                    },
                    50830: {
                        name: 'MaskedAreas',
                        type: 'Short'
                    },
                    50831: {
                        name: 'AsShotICCProfile',
                        type: 'Undefined'
                    },
                    50832: {
                        name: 'AsShotPreProfileMatrix',
                        type: 'SRational'
                    },
                    50833: {
                        name: 'CurrentICCProfile',
                        type: 'Undefined'
                    },
                    50834: {
                        name: 'CurrentPreProfileMatrix',
                        type: 'SRational'
                    },
                    50879: {
                        name: 'ColorimetricReference',
                        type: 'Short'
                    },
                    50931: {
                        name: 'CameraCalibrationSignature',
                        type: 'Byte'
                    },
                    50932: {
                        name: 'ProfileCalibrationSignature',
                        type: 'Byte'
                    },
                    50934: {
                        name: 'AsShotProfileName',
                        type: 'Byte'
                    },
                    50935: {
                        name: 'NoiseReductionApplied',
                        type: 'Rational'
                    },
                    50936: {
                        name: 'ProfileName',
                        type: 'Byte'
                    },
                    50937: {
                        name: 'ProfileHueSatMapDims',
                        type: 'Long'
                    },
                    50938: {
                        name: 'ProfileHueSatMapData1',
                        type: 'Float'
                    },
                    50939: {
                        name: 'ProfileHueSatMapData2',
                        type: 'Float'
                    },
                    50940: {
                        name: 'ProfileToneCurve',
                        type: 'Float'
                    },
                    50941: {
                        name: 'ProfileEmbedPolicy',
                        type: 'Long'
                    },
                    50942: {
                        name: 'ProfileCopyright',
                        type: 'Byte'
                    },
                    50964: {
                        name: 'ForwardMatrix1',
                        type: 'SRational'
                    },
                    50965: {
                        name: 'ForwardMatrix2',
                        type: 'SRational'
                    },
                    50966: {
                        name: 'PreviewApplicationName',
                        type: 'Byte'
                    },
                    50967: {
                        name: 'PreviewApplicationVersion',
                        type: 'Byte'
                    },
                    50968: {
                        name: 'PreviewSettingsName',
                        type: 'Byte'
                    },
                    50969: {
                        name: 'PreviewSettingsDigest',
                        type: 'Byte'
                    },
                    50970: {
                        name: 'PreviewColorSpace',
                        type: 'Long'
                    },
                    50971: {
                        name: 'PreviewDateTime',
                        type: 'Ascii'
                    },
                    50972: {
                        name: 'RawImageDigest',
                        type: 'Undefined'
                    },
                    50973: {
                        name: 'OriginalRawFileDigest',
                        type: 'Undefined'
                    },
                    50974: {
                        name: 'SubTileBlockSize',
                        type: 'Long'
                    },
                    50975: {
                        name: 'RowInterleaveFactor',
                        type: 'Long'
                    },
                    50981: {
                        name: 'ProfileLookTableDims',
                        type: 'Long'
                    },
                    50982: {
                        name: 'ProfileLookTableData',
                        type: 'Float'
                    },
                    51008: {
                        name: 'OpcodeList1',
                        type: 'Undefined'
                    },
                    51009: {
                        name: 'OpcodeList2',
                        type: 'Undefined'
                    },
                    51022: {
                        name: 'OpcodeList3',
                        type: 'Undefined'
                    }
                },
                Exif: {
                    33434: {
                        name: 'ExposureTime',
                        type: 'Rational'
                    },
                    33437: {
                        name: 'FNumber',
                        type: 'Rational'
                    },
                    34850: {
                        name: 'ExposureProgram',
                        type: 'Short'
                    },
                    34852: {
                        name: 'SpectralSensitivity',
                        type: 'Ascii'
                    },
                    34855: {
                        name: 'ISOSpeedRatings',
                        type: 'Short'
                    },
                    34856: {
                        name: 'OECF',
                        type: 'Undefined'
                    },
                    34864: {
                        name: 'SensitivityType',
                        type: 'Short'
                    },
                    34865: {
                        name: 'StandardOutputSensitivity',
                        type: 'Long'
                    },
                    34866: {
                        name: 'RecommendedExposureIndex',
                        type: 'Long'
                    },
                    34867: {
                        name: 'ISOSpeed',
                        type: 'Long'
                    },
                    34868: {
                        name: 'ISOSpeedLatitudeyyy',
                        type: 'Long'
                    },
                    34869: {
                        name: 'ISOSpeedLatitudezzz',
                        type: 'Long'
                    },
                    36864: {
                        name: 'ExifVersion',
                        type: 'Undefined'
                    },
                    36867: {
                        name: 'DateTimeOriginal',
                        type: 'Ascii'
                    },
                    36868: {
                        name: 'DateTimeDigitized',
                        type: 'Ascii'
                    },
                    37121: {
                        name: 'ComponentsConfiguration',
                        type: 'Undefined'
                    },
                    37122: {
                        name: 'CompressedBitsPerPixel',
                        type: 'Rational'
                    },
                    37377: {
                        name: 'ShutterSpeedValue',
                        type: 'SRational'
                    },
                    37378: {
                        name: 'ApertureValue',
                        type: 'Rational'
                    },
                    37379: {
                        name: 'BrightnessValue',
                        type: 'SRational'
                    },
                    37380: {
                        name: 'ExposureBiasValue',
                        type: 'SRational'
                    },
                    37381: {
                        name: 'MaxApertureValue',
                        type: 'Rational'
                    },
                    37382: {
                        name: 'SubjectDistance',
                        type: 'Rational'
                    },
                    37383: {
                        name: 'MeteringMode',
                        type: 'Short'
                    },
                    37384: {
                        name: 'LightSource',
                        type: 'Short'
                    },
                    37385: {
                        name: 'Flash',
                        type: 'Short'
                    },
                    37386: {
                        name: 'FocalLength',
                        type: 'Rational'
                    },
                    37396: {
                        name: 'SubjectArea',
                        type: 'Short'
                    },
                    37500: {
                        name: 'MakerNote',
                        type: 'Undefined'
                    },
                    37510: {
                        name: 'UserComment',
                        type: 'Ascii'
                    },
                    37520: {
                        name: 'SubSecTime',
                        type: 'Ascii'
                    },
                    37521: {
                        name: 'SubSecTimeOriginal',
                        type: 'Ascii'
                    },
                    37522: {
                        name: 'SubSecTimeDigitized',
                        type: 'Ascii'
                    },
                    40960: {
                        name: 'FlashpixVersion',
                        type: 'Undefined'
                    },
                    40961: {
                        name: 'ColorSpace',
                        type: 'Short'
                    },
                    40962: {
                        name: 'PixelXDimension',
                        type: 'Long'
                    },
                    40963: {
                        name: 'PixelYDimension',
                        type: 'Long'
                    },
                    40964: {
                        name: 'RelatedSoundFile',
                        type: 'Ascii'
                    },
                    40965: {
                        name: 'InteroperabilityTag',
                        type: 'Long'
                    },
                    41483: {
                        name: 'FlashEnergy',
                        type: 'Rational'
                    },
                    41484: {
                        name: 'SpatialFrequencyResponse',
                        type: 'Undefined'
                    },
                    41486: {
                        name: 'FocalPlaneXResolution',
                        type: 'Rational'
                    },
                    41487: {
                        name: 'FocalPlaneYResolution',
                        type: 'Rational'
                    },
                    41488: {
                        name: 'FocalPlaneResolutionUnit',
                        type: 'Short'
                    },
                    41492: {
                        name: 'SubjectLocation',
                        type: 'Short'
                    },
                    41493: {
                        name: 'ExposureIndex',
                        type: 'Rational'
                    },
                    41495: {
                        name: 'SensingMethod',
                        type: 'Short'
                    },
                    41728: {
                        name: 'FileSource',
                        type: 'Undefined'
                    },
                    41729: {
                        name: 'SceneType',
                        type: 'Undefined'
                    },
                    41730: {
                        name: 'CFAPattern',
                        type: 'Undefined'
                    },
                    41985: {
                        name: 'CustomRendered',
                        type: 'Short'
                    },
                    41986: {
                        name: 'ExposureMode',
                        type: 'Short'
                    },
                    41987: {
                        name: 'WhiteBalance',
                        type: 'Short'
                    },
                    41988: {
                        name: 'DigitalZoomRatio',
                        type: 'Rational'
                    },
                    41989: {
                        name: 'FocalLengthIn35mmFilm',
                        type: 'Short'
                    },
                    41990: {
                        name: 'SceneCaptureType',
                        type: 'Short'
                    },
                    41991: {
                        name: 'GainControl',
                        type: 'Short'
                    },
                    41992: {
                        name: 'Contrast',
                        type: 'Short'
                    },
                    41993: {
                        name: 'Saturation',
                        type: 'Short'
                    },
                    41994: {
                        name: 'Sharpness',
                        type: 'Short'
                    },
                    41995: {
                        name: 'DeviceSettingDescription',
                        type: 'Undefined'
                    },
                    41996: {
                        name: 'SubjectDistanceRange',
                        type: 'Short'
                    },
                    42016: {
                        name: 'ImageUniqueID',
                        type: 'Ascii'
                    },
                    42032: {
                        name: 'CameraOwnerName',
                        type: 'Ascii'
                    },
                    42033: {
                        name: 'BodySerialNumber',
                        type: 'Ascii'
                    },
                    42034: {
                        name: 'LensSpecification',
                        type: 'Rational'
                    },
                    42035: {
                        name: 'LensMake',
                        type: 'Ascii'
                    },
                    42036: {
                        name: 'LensModel',
                        type: 'Ascii'
                    },
                    42037: {
                        name: 'LensSerialNumber',
                        type: 'Ascii'
                    },
                    42240: {
                        name: 'Gamma',
                        type: 'Rational'
                    }
                },
                GPS: {
                    0: {
                        name: 'GPSVersionID',
                        type: 'Byte'
                    },
                    1: {
                        name: 'GPSLatitudeRef',
                        type: 'Ascii'
                    },
                    2: {
                        name: 'GPSLatitude',
                        type: 'Rational'
                    },
                    3: {
                        name: 'GPSLongitudeRef',
                        type: 'Ascii'
                    },
                    4: {
                        name: 'GPSLongitude',
                        type: 'Rational'
                    },
                    5: {
                        name: 'GPSAltitudeRef',
                        type: 'Byte'
                    },
                    6: {
                        name: 'GPSAltitude',
                        type: 'Rational'
                    },
                    7: {
                        name: 'GPSTimeStamp',
                        type: 'Rational'
                    },
                    8: {
                        name: 'GPSSatellites',
                        type: 'Ascii'
                    },
                    9: {
                        name: 'GPSStatus',
                        type: 'Ascii'
                    },
                    10: {
                        name: 'GPSMeasureMode',
                        type: 'Ascii'
                    },
                    11: {
                        name: 'GPSDOP',
                        type: 'Rational'
                    },
                    12: {
                        name: 'GPSSpeedRef',
                        type: 'Ascii'
                    },
                    13: {
                        name: 'GPSSpeed',
                        type: 'Rational'
                    },
                    14: {
                        name: 'GPSTrackRef',
                        type: 'Ascii'
                    },
                    15: {
                        name: 'GPSTrack',
                        type: 'Rational'
                    },
                    16: {
                        name: 'GPSImgDirectionRef',
                        type: 'Ascii'
                    },
                    17: {
                        name: 'GPSImgDirection',
                        type: 'Rational'
                    },
                    18: {
                        name: 'GPSMapDatum',
                        type: 'Ascii'
                    },
                    19: {
                        name: 'GPSDestLatitudeRef',
                        type: 'Ascii'
                    },
                    20: {
                        name: 'GPSDestLatitude',
                        type: 'Rational'
                    },
                    21: {
                        name: 'GPSDestLongitudeRef',
                        type: 'Ascii'
                    },
                    22: {
                        name: 'GPSDestLongitude',
                        type: 'Rational'
                    },
                    23: {
                        name: 'GPSDestBearingRef',
                        type: 'Ascii'
                    },
                    24: {
                        name: 'GPSDestBearing',
                        type: 'Rational'
                    },
                    25: {
                        name: 'GPSDestDistanceRef',
                        type: 'Ascii'
                    },
                    26: {
                        name: 'GPSDestDistance',
                        type: 'Rational'
                    },
                    27: {
                        name: 'GPSProcessingMethod',
                        type: 'Undefined'
                    },
                    28: {
                        name: 'GPSAreaInformation',
                        type: 'Undefined'
                    },
                    29: {
                        name: 'GPSDateStamp',
                        type: 'Ascii'
                    },
                    30: {
                        name: 'GPSDifferential',
                        type: 'Short'
                    },
                    31: {
                        name: 'GPSHPositioningError',
                        type: 'Rational'
                    }
                },
                Interop: {
                    1: {
                        name: 'InteroperabilityIndex',
                        type: 'Ascii'
                    }
                }
            };
            _['0th'] = _.Image,
            _['1st'] = _.Image,
            E.TAGS = _,
            E.ImageIFD = {
                ProcessingSoftware: 11,
                NewSubfileType: 254,
                SubfileType: 255,
                ImageWidth: 256,
                ImageLength: 257,
                BitsPerSample: 258,
                Compression: 259,
                PhotometricInterpretation: 262,
                Threshholding: 263,
                CellWidth: 264,
                CellLength: 265,
                FillOrder: 266,
                DocumentName: 269,
                ImageDescription: 270,
                Make: 271,
                Model: 272,
                StripOffsets: 273,
                Orientation: 274,
                SamplesPerPixel: 277,
                RowsPerStrip: 278,
                StripByteCounts: 279,
                XResolution: 282,
                YResolution: 283,
                PlanarConfiguration: 284,
                GrayResponseUnit: 290,
                GrayResponseCurve: 291,
                T4Options: 292,
                T6Options: 293,
                ResolutionUnit: 296,
                TransferFunction: 301,
                Software: 305,
                DateTime: 306,
                Artist: 315,
                HostComputer: 316,
                Predictor: 317,
                WhitePoint: 318,
                PrimaryChromaticities: 319,
                ColorMap: 320,
                HalftoneHints: 321,
                TileWidth: 322,
                TileLength: 323,
                TileOffsets: 324,
                TileByteCounts: 325,
                SubIFDs: 330,
                InkSet: 332,
                InkNames: 333,
                NumberOfInks: 334,
                DotRange: 336,
                TargetPrinter: 337,
                ExtraSamples: 338,
                SampleFormat: 339,
                SMinSampleValue: 340,
                SMaxSampleValue: 341,
                TransferRange: 342,
                ClipPath: 343,
                XClipPathUnits: 344,
                YClipPathUnits: 345,
                Indexed: 346,
                JPEGTables: 347,
                OPIProxy: 351,
                JPEGProc: 512,
                JPEGInterchangeFormat: 513,
                JPEGInterchangeFormatLength: 514,
                JPEGRestartInterval: 515,
                JPEGLosslessPredictors: 517,
                JPEGPointTransforms: 518,
                JPEGQTables: 519,
                JPEGDCTables: 520,
                JPEGACTables: 521,
                YCbCrCoefficients: 529,
                YCbCrSubSampling: 530,
                YCbCrPositioning: 531,
                ReferenceBlackWhite: 532,
                XMLPacket: 700,
                Rating: 18246,
                RatingPercent: 18249,
                ImageID: 32781,
                CFARepeatPatternDim: 33421,
                CFAPattern: 33422,
                BatteryLevel: 33423,
                Copyright: 33432,
                ExposureTime: 33434,
                ImageResources: 34377,
                ExifTag: 34665,
                InterColorProfile: 34675,
                GPSTag: 34853,
                Interlace: 34857,
                TimeZoneOffset: 34858,
                SelfTimerMode: 34859,
                FlashEnergy: 37387,
                SpatialFrequencyResponse: 37388,
                Noise: 37389,
                FocalPlaneXResolution: 37390,
                FocalPlaneYResolution: 37391,
                FocalPlaneResolutionUnit: 37392,
                ImageNumber: 37393,
                SecurityClassification: 37394,
                ImageHistory: 37395,
                ExposureIndex: 37397,
                TIFFEPStandardID: 37398,
                SensingMethod: 37399,
                XPTitle: 40091,
                XPComment: 40092,
                XPAuthor: 40093,
                XPKeywords: 40094,
                XPSubject: 40095,
                PrintImageMatching: 50341,
                DNGVersion: 50706,
                DNGBackwardVersion: 50707,
                UniqueCameraModel: 50708,
                LocalizedCameraModel: 50709,
                CFAPlaneColor: 50710,
                CFALayout: 50711,
                LinearizationTable: 50712,
                BlackLevelRepeatDim: 50713,
                BlackLevel: 50714,
                BlackLevelDeltaH: 50715,
                BlackLevelDeltaV: 50716,
                WhiteLevel: 50717,
                DefaultScale: 50718,
                DefaultCropOrigin: 50719,
                DefaultCropSize: 50720,
                ColorMatrix1: 50721,
                ColorMatrix2: 50722,
                CameraCalibration1: 50723,
                CameraCalibration2: 50724,
                ReductionMatrix1: 50725,
                ReductionMatrix2: 50726,
                AnalogBalance: 50727,
                AsShotNeutral: 50728,
                AsShotWhiteXY: 50729,
                BaselineExposure: 50730,
                BaselineNoise: 50731,
                BaselineSharpness: 50732,
                BayerGreenSplit: 50733,
                LinearResponseLimit: 50734,
                CameraSerialNumber: 50735,
                LensInfo: 50736,
                ChromaBlurRadius: 50737,
                AntiAliasStrength: 50738,
                ShadowScale: 50739,
                DNGPrivateData: 50740,
                MakerNoteSafety: 50741,
                CalibrationIlluminant1: 50778,
                CalibrationIlluminant2: 50779,
                BestQualityScale: 50780,
                RawDataUniqueID: 50781,
                OriginalRawFileName: 50827,
                OriginalRawFileData: 50828,
                ActiveArea: 50829,
                MaskedAreas: 50830,
                AsShotICCProfile: 50831,
                AsShotPreProfileMatrix: 50832,
                CurrentICCProfile: 50833,
                CurrentPreProfileMatrix: 50834,
                ColorimetricReference: 50879,
                CameraCalibrationSignature: 50931,
                ProfileCalibrationSignature: 50932,
                AsShotProfileName: 50934,
                NoiseReductionApplied: 50935,
                ProfileName: 50936,
                ProfileHueSatMapDims: 50937,
                ProfileHueSatMapData1: 50938,
                ProfileHueSatMapData2: 50939,
                ProfileToneCurve: 50940,
                ProfileEmbedPolicy: 50941,
                ProfileCopyright: 50942,
                ForwardMatrix1: 50964,
                ForwardMatrix2: 50965,
                PreviewApplicationName: 50966,
                PreviewApplicationVersion: 50967,
                PreviewSettingsName: 50968,
                PreviewSettingsDigest: 50969,
                PreviewColorSpace: 50970,
                PreviewDateTime: 50971,
                RawImageDigest: 50972,
                OriginalRawFileDigest: 50973,
                SubTileBlockSize: 50974,
                RowInterleaveFactor: 50975,
                ProfileLookTableDims: 50981,
                ProfileLookTableData: 50982,
                OpcodeList1: 51008,
                OpcodeList2: 51009,
                OpcodeList3: 51022,
                NoiseProfile: 51041
            },
            E.ExifIFD = {
                ExposureTime: 33434,
                FNumber: 33437,
                ExposureProgram: 34850,
                SpectralSensitivity: 34852,
                ISOSpeedRatings: 34855,
                OECF: 34856,
                SensitivityType: 34864,
                StandardOutputSensitivity: 34865,
                RecommendedExposureIndex: 34866,
                ISOSpeed: 34867,
                ISOSpeedLatitudeyyy: 34868,
                ISOSpeedLatitudezzz: 34869,
                ExifVersion: 36864,
                DateTimeOriginal: 36867,
                DateTimeDigitized: 36868,
                ComponentsConfiguration: 37121,
                CompressedBitsPerPixel: 37122,
                ShutterSpeedValue: 37377,
                ApertureValue: 37378,
                BrightnessValue: 37379,
                ExposureBiasValue: 37380,
                MaxApertureValue: 37381,
                SubjectDistance: 37382,
                MeteringMode: 37383,
                LightSource: 37384,
                Flash: 37385,
                FocalLength: 37386,
                SubjectArea: 37396,
                MakerNote: 37500,
                UserComment: 37510,
                SubSecTime: 37520,
                SubSecTimeOriginal: 37521,
                SubSecTimeDigitized: 37522,
                FlashpixVersion: 40960,
                ColorSpace: 40961,
                PixelXDimension: 40962,
                PixelYDimension: 40963,
                RelatedSoundFile: 40964,
                InteroperabilityTag: 40965,
                FlashEnergy: 41483,
                SpatialFrequencyResponse: 41484,
                FocalPlaneXResolution: 41486,
                FocalPlaneYResolution: 41487,
                FocalPlaneResolutionUnit: 41488,
                SubjectLocation: 41492,
                ExposureIndex: 41493,
                SensingMethod: 41495,
                FileSource: 41728,
                SceneType: 41729,
                CFAPattern: 41730,
                CustomRendered: 41985,
                ExposureMode: 41986,
                WhiteBalance: 41987,
                DigitalZoomRatio: 41988,
                FocalLengthIn35mmFilm: 41989,
                SceneCaptureType: 41990,
                GainControl: 41991,
                Contrast: 41992,
                Saturation: 41993,
                Sharpness: 41994,
                DeviceSettingDescription: 41995,
                SubjectDistanceRange: 41996,
                ImageUniqueID: 42016,
                CameraOwnerName: 42032,
                BodySerialNumber: 42033,
                LensSpecification: 42034,
                LensMake: 42035,
                LensModel: 42036,
                LensSerialNumber: 42037,
                Gamma: 42240
            },
            E.GPSIFD = {
                GPSVersionID: 0,
                GPSLatitudeRef: 1,
                GPSLatitude: 2,
                GPSLongitudeRef: 3,
                GPSLongitude: 4,
                GPSAltitudeRef: 5,
                GPSAltitude: 6,
                GPSTimeStamp: 7,
                GPSSatellites: 8,
                GPSStatus: 9,
                GPSMeasureMode: 10,
                GPSDOP: 11,
                GPSSpeedRef: 12,
                GPSSpeed: 13,
                GPSTrackRef: 14,
                GPSTrack: 15,
                GPSImgDirectionRef: 16,
                GPSImgDirection: 17,
                GPSMapDatum: 18,
                GPSDestLatitudeRef: 19,
                GPSDestLatitude: 20,
                GPSDestLongitudeRef: 21,
                GPSDestLongitude: 22,
                GPSDestBearingRef: 23,
                GPSDestBearing: 24,
                GPSDestDistanceRef: 25,
                GPSDestDistance: 26,
                GPSProcessingMethod: 27,
                GPSAreaInformation: 28,
                GPSDateStamp: 29,
                GPSDifferential: 30,
                GPSHPositioningError: 31
            },
            E.InteropIFD = {
                InteroperabilityIndex: 1
            },
            t.exports && (a = t.exports = E),
            a.piexif = E
        }
        )()
    }
    , function(e, t, a) {
        'use strict';
        (function(e) {
            var n = a(13)
              , i = a.n(n)
              , o = a(14)
              , r = a.n(o)
              , s = a(59)
              , d = a.n(s)
              , l = a(9)
              , c = a.n(l)
              , p = a(6)
              , m = a.n(p)
              , u = a(15)
              , g = a(0)
              , y = a(56)
              , S = a(21)
              , h = a(60)
              , E = a(61)
              , f = a(67)
              , R = a(62)
              , A = a(12)
              , _ = a(1)
              , C = a(19)
              , T = a(10)
              , P = a(66)
              , D = a(4)
              , I = a(3)
              , M = a(2)
              , b = Object(C.a)()
              , v = 0
              , L = 0
              , x = null
              , O = !1
              , k = 2
              , N = null
              , F = null
              , w = null
              , U = 0
              , G = !1
              , B = null
              , V = 1
              , H = null
              , j = Object(M.b)(1, 3)
              , K = Object(M.b)(1, 100)
              , q = Object(M.b)(0, 3);
            S.a.addHandler(h.a),
            S.a.addHandler(E.a),
            S.a.addHandler(f.a);
            var z = {
                DL_FRONT: 'image_data',
                PASSPORT: 'image_data',
                SELFIE: 'image_data',
                CHECK_FRONT: 'image_data',
                CHECK_BACK: 'image_data',
                PDF417_BARCODE: 'data_url',
                DL_BACK: 'data_url',
                DOCUMENT: 'image_data'
            }
              , W = function(e) {
                var t = document.createElement('canvas');
                return t.setAttribute('width', e.width),
                t.setAttribute('height', e.height),
                t.getContext('2d').putImageData(e, 0, 0),
                t.toDataURL('image/jpeg', .01 * v)
            }
              , Q = function(e) {
                g.a.emit('SDK_ERROR', {
                    key: e
                }),
                g.a.removeAllListeners()
            }
              , X = function(e) {
                if ('string' != typeof e.response.imageData) {
                    if ('undefined' != typeof e.response.fourCornerA && 0 < e.response.fourCornerA.x) {
                        var t = {
                            A: [e.response.fourCornerA.x, e.response.fourCornerA.y],
                            B: [e.response.fourCornerB.x, e.response.fourCornerB.y],
                            C: [e.response.fourCornerC.x, e.response.fourCornerC.y],
                            D: [e.response.fourCornerD.x, e.response.fourCornerD.y]
                        };
                        _.f(b.MitekMibiAction.MEASURED_FOUR_CORNERS, t)
                    }
                    'AUTO' === e.response.mode && g.a.emit('LOG_MIBI_EVENT', {
                        eventName: b.MitekMibiAction.VIDEO_RECORDING_DATA,
                        eventValues: D.a.getMibiData()
                    }),
                    _.a(),
                    e.response.imageData = _.e(W(e.response.imageData))
                }
                'AUTO' === e.response.mode && D.a.isVideoRecordingEnabled ? D.a.stopRecording().then(function(t) {
                    e.response.videoData = t
                })['catch'](function(t) {
                    console.warn('Exception during recording of video', t)
                })['finally'](function() {
                    g.a.emit('FRAME_CAPTURE_RESULT', e),
                    g.a.emit('SDK_STOP'),
                    g.a.removeAllListeners()
                }) : (g.a.emit('FRAME_CAPTURE_RESULT', e),
                g.a.emit('SDK_STOP'),
                g.a.removeAllListeners())
            }
              , Y = function(e) {
                'string' != typeof e.response.imageData && (delete e.response.warnings.score,
                _.a(),
                e.response.imageData = _.e(W(e.response.imageData))),
                g.a.emit('FRAME_CAPTURE_RESULT', e)
            }
              , J = function(e, t, a) {
                var n = {
                    imageData: e,
                    maxImageSize: 'DOCUMENT' === a ? 4096 : 1920,
                    minImageSize: 450,
                    imageQuality: v,
                    imageReturnType: t
                }
                  , i = A.c(n);
                return i
            }
              , Z = null
              , $ = function() {
                null !== Z && 'undefined' != typeof Z.key && g.a.emit('FRAME_PROCESSING_FEEDBACK', Z)
            }
              , ee = function(t) {
                var a = t.setup
                  , n = void 0 === a ? 'CAPTURE_AND_PROCESS_FRAME' : a
                  , i = t.mode
                  , o = void 0 === i ? 'AUTO_CAPTURE' : i
                  , r = t.documentType
                  , s = void 0 === r ? '' : r
                  , l = t.mitekSDKPath
                  , p = void 0 === l ? '' : l
                  , y = t.captureNextFrame
                  , S = void 0 !== y && y
                  , h = t.opts
                  , E = void 0 === h ? {
                    qualityPercent: 80,
                    guidePaddingLevel: 3,
                    disableSmileDetection: !1,
                    faceDetectionLevel: 1,
                    videoContainerId: null,
                    hintMessageSize: 2,
                    thresholds: null,
                    debugLevel: 0
                } : h
                  , f = t.scienceModule
                  , C = void 0 === f ? {} : f;
                return {
                    documentType: s,
                    loopTimer: null,
                    mode: o,
                    captureNextFrame: S,
                    opts: E,
                    mitekSDKPath: p,
                    setup: n,
                    scienceModule: C,
                    launchCamManual: function() {
                        var t = this;
                        _.c();
                        var a = this
                          , n = this.documentType
                          , i = function(i) {
                            g.a.emit('IMAGE_CAPTURED'),
                            t.scienceModule.then(function(e) {
                                _.m(Object(T.a)()),
                                _.h(!0),
                                _.b(i.target.files[0]),
                                'SELFIE' !== n && !1 === Object(T.a)() && _.h(!1),
                                Object(M.e)() ? (g.a.emit('CAMERA_DISPLAY_STARTED'),
                                _.l(!1)) : _.l(!0),
                                _.f(b.MitekMibiAction.PICTURE_CAPTURED, t.documentType),
                                _.k(),
                                _.g(t.documentType),
                                g.a.on('LOG_MIBI_EVENT', function(e) {
                                    _.f(e.eventName, e.eventValues)
                                });
                                var o = 'DL_BACK' === n || 'PDF417_BARCODE' === n ? A.a.DATA_URL : A.a.IMAGE_DATA;
                                J(i.target.files[0], o, n).then(function(i) {
                                    var o = t.opts.opts.options.debugLevel;
                                    'undefined' == typeof o || Object(M.f)(o) && q(o) || (console.warn('debugLevel must be an integer value between 0 and 3'),
                                    t.opts.opts.options.debugLevel = 0),
                                    e['default']({
                                        mode: t.mode,
                                        mitekSDKPath: t.mitekSDKPath || '',
                                        thresholds: t.opts.opts.options.thresholds,
                                        debugLevel: t.opts.opts.options.debugLevel,
                                        guidePaddingLevel: t.opts.opts.options.guidePaddingLevel,
                                        resultCallback: function(e) {
                                            'success' === e.warnings.status && (_.f(b.MitekMibiAction.CV_SUCCESS, 0),
                                            _.f(b.MitekMibiAction.CV_ENCODING_QUALITY, v),
                                            _.f(b.MitekMibiAction.TOTAL_ENCODING_TIME, 0),
                                            X({
                                                request: n,
                                                response: m()({
                                                    status: e.warnings.status,
                                                    mode: 'MANUAL',
                                                    docType: t.documentType,
                                                    mibiData: _.d()
                                                }, e)
                                            }),
                                            a.reset(),
                                            g.a.removeAllListeners()),
                                            'failure' === e.warnings.status && (_.f(e.warnings.code, e.warnings.score),
                                            g.a.emit('FRAME_PROCESSING_FEEDBACK', e.warnings),
                                            _.f(b.MitekMibiAction.CV_ERROR_FAILURE, e.warnings.code),
                                            _.f(b.MitekMibiAction.CV_ENCODING_QUALITY, v),
                                            _.f(b.MitekMibiAction.TOTAL_ENCODING_TIME, 0),
                                            Y({
                                                request: n,
                                                response: m()({
                                                    status: e.warnings.status,
                                                    mode: 'MANUAL',
                                                    docType: t.documentType,
                                                    mibiData: _.d()
                                                }, e)
                                            }),
                                            a.reset(),
                                            g.a.removeAllListeners())
                                        }
                                    }).then(function() {
                                        e.processFrame({
                                            documentType: t.documentType,
                                            imageData: i.imageData,
                                            captureMode: t.mode
                                        })
                                    })
                                })['catch'](function(e) {
                                    g.a.emit('FRAME_PROCESSING_FEEDBACK', {
                                        status: 'failure',
                                        code: e.errorCode,
                                        key: e.errorCode,
                                        score: 0
                                    }),
                                    a.reset(),
                                    g.a.removeAllListeners()
                                })
                            })['catch'](function(e) {
                                return Q([e])
                            })
                        }
                          , o = document.getElementById('mitekContainer');
                        o && o.remove();
                        var r = 'SELFIE' === n ? 'user' : 'environment'
                          , s = e.document.createElement('div');
                        s.setAttribute('id', 'mitekContainer');
                        var d = '<input id="misnapNativeCapture" type="file" style="display:none" capture="'.concat(r, '" accept="image/*"  />');
                        s.insertAdjacentHTML('beforeend', d),
                        s.querySelector('#misnapNativeCapture').onchange = function(t) {
                            return i(t)
                        }
                        ,
                        e.document.querySelector('body').appendChild(s),
                        e.document.querySelector('#misnapNativeCapture').click()
                    },
                    launchCamAuto: function() {
                        var e = this
                          , t = this.documentType
                          , a = Object(R.a)()
                          , n = this;
                        Z = null;
                        var i = c()(this.opts.opts.options.hintFrequencyMS) !== void 0 && 'number' == typeof this.opts.opts.options.hintFrequencyMS ? m()({
                            hintFrequencyMS: 1200
                        }, this.opts.opts.options) : {
                            hintFrequencyMS: 1200
                        };
                        N = i.hintFrequencyMS;
                        var o = !0;
                        S = !1;
                        var r = a.run({
                            documentType: this.documentType,
                            guidePaddingLevel: L,
                            videoContainerId: F,
                            hintMessageSize: k,
                            hintAriaLive: x,
                            hintDuration: N
                        });
                        _.c(),
                        _.j(),
                        _.l(!1),
                        _.m(Object(T.a)()),
                        _.h(!0),
                        _.g(t);
                        var s = function(a) {
                            return d()(a),
                            {
                                retryFn: null,
                                captureNextFrame: e.captureNextFrame,
                                mitekSDKPath: e.mitekSDKPath,
                                thresholds: w,
                                debugLevel: U,
                                disableSmileDetection: O,
                                faceDetectionLevel: V,
                                resultCallback: function(e) {
                                    if (u.a.isScienceLoaded || u.a.updateReadinessState({
                                        ready: 'scienceLoaded'
                                    }),
                                    o && 'failure' === e.warnings.status) {
                                        _.f(e.warnings.code, e.warnings.score),
                                        Z = e.warnings;
                                        var a = m()({
                                            documentType: t,
                                            captureMode: this.mode,
                                            captureNextFrame: S
                                        }, r.getFrame(z[t]));
                                        this.processFrame(a)
                                    }
                                    if ('success' === e.warnings.status && u.a.shouldProcessFrames() && (n.reset(),
                                    _.f(b.MitekMibiAction.CV_SUCCESS, 0),
                                    _.f(b.MitekMibiAction.CV_ENCODING_QUALITY, v),
                                    _.f(b.MitekMibiAction.AUTOCAPTURE_TIME, 0),
                                    X({
                                        request: t,
                                        response: m()({
                                            status: e.warnings.status,
                                            mode: 'AUTO',
                                            docType: t,
                                            mibiData: _.d()
                                        }, e)
                                    })),
                                    o && 'success' === e.warnings.status && !u.a.shouldProcessFrames()) {
                                        Z = e.warnings;
                                        var i = m()({
                                            documentType: t,
                                            captureMode: this.mode,
                                            captureNextFrame: S
                                        }, r.getFrame(z[t]));
                                        this.processFrame(i)
                                    }
                                }
                            }
                        }
                          , l = null;
                        g.a.on('LOG_MIBI_EVENT', function(e) {
                            _.f(e.eventName, e.eventValues)
                        }),
                        g.a.on('CAPTURE_FRAME', function() {
                            S = !0
                        }),
                        g.a.on('HINT_MESSAGE_SIZE', function(e) {
                            var t = document.querySelector('#mitekHintMessage');
                            t && (Object(M.f)(e) ? 1 === e ? t.className = 'small' : 2 === e ? t.className = 'medium' : 3 === e ? t.className = 'large' : void 0 : console.warn('Pleaes provide a valid size for the hint message (1,2,3)'))
                        }),
                        g.a.on('SDK_STOP', function() {
                            clearInterval(l),
                            clearTimeout(B),
                            o = !1,
                            r.tearDownCamera(),
                            n.reset(),
                            D.a.isVideoRecordingEnabled && D.a.cancelRecording()
                        }),
                        r.startCamera(function() {
                            var a = r.getFrame(z[t])
                              , n = s({});
                            n.mode = e.mode,
                            n.processFrame = e.scienceModule.processFrame,
                            e.scienceModule['default'](n).then(function() {
                                l = setInterval(function() {
                                    $()
                                }, N),
                                _.f(b.MitekMibiAction.AUTOCAPTURE_FRAME_PROCESSING_STARTED, ''),
                                e.scienceModule.processFrame(m()({
                                    documentType: t
                                }, a))
                            })['catch'](Q)
                        })
                    },
                    launchExpectedCamera: function() {
                        this.processFrame = null,
                        'MANUAL_CAPTURE' === this.mode && this.launchCamManual(),
                        'AUTO_CAPTURE' === this.mode && this.launchCamAuto()
                    },
                    launchDirect: function() {
                        var t = this
                          , a = this
                          , n = this.documentType;
                        _.c(),
                        _.k(),
                        _.i('PROCESS_FRAME'),
                        _.l(!1),
                        _.g(n),
                        _.m(Object(T.a)()),
                        _.h(!0),
                        'SELFIE' !== n && !1 === Object(T.a)() && _.h(!1),
                        g.a.on('LOG_MIBI_EVENT', function(e) {
                            _.f(e.eventName, e.eventValues)
                        }),
                        this.scienceModule['default']({
                            mode: this.mode,
                            mitekSDKPath: this.mitekSDKPath || '',
                            thresholds: w,
                            debugLevel: U,
                            resultCallback: function(e) {
                                'success' === e.warnings.status && (_.f(b.MitekMibiAction.CV_SUCCESS, ''),
                                _.f(b.MitekMibiAction.CV_ENCODING_QUALITY, v),
                                _.f(b.MitekMibiAction.TOTAL_ENCODING_TIME, 0),
                                X({
                                    request: n,
                                    response: m()({
                                        status: e.warnings.status,
                                        mode: 'DIRECT',
                                        docType: t.documentType,
                                        mibiData: _.d()
                                    }, e)
                                }),
                                a.reset(),
                                g.a.removeAllListeners()),
                                'failure' === e.warnings.status && (_.f(e.warnings.code, e.warnings.score),
                                g.a.emit('FRAME_PROCESSING_FEEDBACK', e.warnings),
                                _.f(b.MitekMibiAction.CV_ERROR_FAILURE, e.warnings.code),
                                _.f(b.MitekMibiAction.CV_ENCODING_QUALITY, v),
                                _.f(b.MitekMibiAction.TOTAL_ENCODING_TIME, 0),
                                Y({
                                    request: n,
                                    response: m()({
                                        status: e.warnings.status,
                                        mode: 'DIRECT',
                                        docType: t.documentType,
                                        mibiData: _.d()
                                    }, e)
                                }),
                                a.reset(),
                                g.a.removeAllListeners())
                            }
                        }).then(function() {
                            var i = 'DL_BACK' === n || 'PDF417_BARCODE' === n ? A.a.DATA_URL : A.a.IMAGE_DATA
                              , o = t.documentType
                              , r = {
                                imageData: t.opts.opts.options.frame,
                                maxImageSize: 'DOCUMENT' === n ? 4096 : 1920,
                                minImageSize: 450,
                                imageReturnType: i
                            };
                            r.imageData instanceof e.File && (_.l(!0),
                            _.b(r.imageData)),
                            A.c(r).then(function(e) {
                                _.f(b.MitekMibiAction.PICTURE_CAPTURED, ''),
                                t.scienceModule.processFrame({
                                    documentType: o,
                                    imageData: e.imageData,
                                    captureMode: 'MANUAL_CAPTURE'
                                })
                            })['catch'](function(e) {
                                _.f(e.errorCode, ''),
                                g.a.emit('FRAME_PROCESSING_FEEDBACK', {
                                    status: 'failure',
                                    code: e.errorCode,
                                    key: e.errorCode,
                                    score: 0
                                }),
                                a.reset(),
                                g.a.removeAllListeners()
                            })
                        })['catch'](Q)
                    },
                    reset: function() {
                        this.captureNextFrame = !1,
                        this.processFrame = null,
                        this.documentType = null,
                        this.mode = null,
                        this.opts = null,
                        this.scienceModule = null,
                        this.mitekSDKPath = null
                    },
                    run: function(e) {
                        return this.documentType = e.documentType,
                        this.mode = e.mode,
                        this.opts = e,
                        this.scienceModule = e.scienceModule,
                        this.mitekSDKPath = e.mitekSDKPath || '',
                        'CAPTURE_AND_PROCESS_FRAME' === e.setup && this.launchExpectedCamera(e),
                        'PROCESS_FRAME' === e.setup && this.launchDirect(),
                        this
                    },
                    setMode: function(e) {
                        return this.mode = e,
                        this
                    },
                    setDocumentType: function(e) {
                        return this.documentType = e,
                        this
                    },
                    setOptions: function(e) {
                        return this.options = e,
                        this
                    }
                }
            }({
                setup: null,
                documentType: null,
                mode: null,
                opts: null,
                scienceModule: null
            })
              , te = function() {
                function t() {
                    i()(this, t)
                }
                return r()(t, [{
                    key: 'isSelfieCapture',
                    value: function(e) {
                        return 'SELFIE' === e.documentType
                    }
                }, {
                    key: 'setupSelfie',
                    value: function(t) {
                        if (!0 === this.isSelfieCapture(t)) {
                            var a = console.error
                              , n = console.warn;
                            console.warn = function() {
                                for (var t = arguments.length, a = Array(t), i = 0; i < t; i++)
                                    a[i] = arguments[i];
                                void 0 != a[0] && 'string' == typeof a[0] && (-1 < a[0].indexOf('OES_texture_float') || -1 < a[0].indexOf('EXT_color_buffer_float')) || a[0].includes('WebGL is not supported on this device') ? (g.a.emit('SDK_ERROR', Object(I.c)(339)),
                                g.a.emit('SDK_STOP'),
                                e.document.body.classList.remove('mitekNoscroll')) : n.apply(console, arguments)
                            }
                            ,
                            console.error = function() {
                                for (var t = arguments.length, n = Array(t), i = 0; i < t; i++)
                                    n[i] = arguments[i];
                                void 0 != n[0] && 'string' == typeof n[0] && -1 < n[0].indexOf('Failed to compile') ? (g.a.emit('SDK_ERROR', Object(I.c)(339)),
                                g.a.emit('SDK_STOP'),
                                e.document.body.classList.remove('mitekNoscroll')) : a.apply(console, arguments)
                            }
                            ,
                            window.addEventListener('unhandledrejection', function(t) {
                                if ('undefined' != t && 'undefined' != t.reason) {
                                    var a = new String(t.reason);
                                    -1 < a.indexOf('Failed to compile') && (g.a.emit('SDK_ERROR', Object(I.c)(339)),
                                    g.a.emit('SDK_STOP'),
                                    e.document.body.classList.remove('mitekNoscroll'))
                                }
                            })
                        }
                    }
                }, {
                    key: 'manualCapture',
                    value: function() {}
                }, {
                    key: 'autoCapture',
                    value: function() {}
                }, {
                    key: 'processCMD',
                    value: function(e, t) {
                        u.a.resetState();
                        var a = 'undefined' != typeof t.mitekSDKPath && '' !== t.mitekSDKPath ? t.mitekSDKPath : './mitekSDK/';
                        y.a.setPublicWP(a),
                        this.setupSelfie(t);
                        var n = t.documentType
                          , i = m()({}, t, {
                            documentType: n,
                            mode: 'PROCESS_FRAME' === e ? 'PROCESS_FRAME' : t.mode
                        });
                        if ('MANUAL_CAPTURE' === i.mode) {
                            var o = {
                                setup: e,
                                documentType: n,
                                mode: i.mode,
                                opts: i,
                                thresholds: w,
                                debugLevel: U,
                                scienceModule: S.a.request({
                                    documentType: n,
                                    mode: i.mode,
                                    thresholds: w,
                                    debugLevel: U
                                })
                            };
                            'string' == typeof t.mitekSDKPath && (o.mitekSDKPath = t.mitekSDKPath),
                            v = 'undefined' != typeof o.opts.options && 'undefined' != typeof o.opts.options.qualityPercent ? o.opts.options.qualityPercent : 80,
                            ee.run(o)
                        } else
                            S.a.request({
                                documentType: n,
                                mode: i.mode
                            }).then(function(a) {
                                var o = {
                                    setup: e,
                                    documentType: n,
                                    mode: i.mode,
                                    opts: i,
                                    scienceModule: a
                                };
                                if ('string' == typeof t.mitekSDKPath && (o.mitekSDKPath = t.mitekSDKPath),
                                L = 'undefined' == typeof o.opts.options.guidePaddingLevel ? 1 : o.opts.options.guidePaddingLevel,
                                O = 'undefined' != typeof o.opts.options.disableSmileDetection && o.opts.options.disableSmileDetection,
                                V = 'undefined' == typeof o.opts.options.faceDetectionLevel ? 1 : o.opts.options.faceDetectionLevel,
                                F = 'undefined' == typeof o.opts.options.videoContainerId ? null : o.opts.options.videoContainerId,
                                k = 'undefined' == typeof o.opts.options.hintMessageSize ? 2 : o.opts.options.hintMessageSize,
                                x = 'undefined' == typeof o.opts.options.hintAriaLive ? null : P.a.get(o.opts.options.hintAriaLive),
                                w = 'undefined' == typeof o.opts.options.thresholds ? null : o.opts.options.thresholds,
                                U = 'undefined' == typeof o.opts.options.debugLevel ? 0 : o.opts.options.debugLevel,
                                H = 'undefined' != typeof o.opts.options.videoSource && '' != o.opts.options.videoSource ? o.opts.options.videoSource : null,
                                G = null === H && 'undefined' != typeof o.opts.options && 'undefined' != typeof o.opts.options.videoRecordingEnabled && !0 === o.opts.options.videoRecordingEnabled,
                                D.a.videoSource = H,
                                Object(M.f)(U) && q(U) || (console.warn('debugLevel must be an integer value between 0 and 3'),
                                U = 0),
                                Object(M.f)(L) && j(L) || (console.warn('guidePaddingLevel must be an integer value between 1 and 3'),
                                L = 1),
                                null != F && 'string' != typeof F && (console.warn('videoContainerId must be a valid string'),
                                F = null),
                                null == F || document.querySelector('#' + F) || (console.warn('videoContainerId must reference a valid HTML element with an ID of \'' + F + '\''),
                                F = null),
                                Object(M.f)(k) && j(k) || (console.warn('hintMessageSize must be an integer value between 1 and 3'),
                                k = 2),
                                Object(M.f)(V) && j(V) || (console.warn('faceDetectionLevel must be an integer value between 1 and 3'),
                                V = 1),
                                G) {
                                    if (D.a.isVideoRecordingEnabled = !0,
                                    !D.a.supportsRecording())
                                        return g.a.emit('SDK_ERROR', Object(I.c)(130)),
                                        g.a.emit('SDK_STOP'),
                                        void self.reset();
                                    var r = 'undefined' != typeof o.opts.options && 'undefined' != typeof o.opts.options.audioRecordingEnabled && o.opts.options.audioRecordingEnabled
                                      , s = 'undefined' != typeof o.opts.options && 'undefined' != typeof o.opts.options.videoRecordingMessage ? o.opts.options.videoRecordingMessage : D.a.recordingMessage
                                      , d = 'undefined' != typeof o.opts.options && 'undefined' != typeof o.opts.options.videoQuality && o.opts.options.videoQuality ? o.opts.options.videoQuality : D.a.qualityPercent;
                                    0 < U && D.a.enableDebug(),
                                    D.a.isAudioRecordingEnabled = r,
                                    D.a.recordingMessage = s,
                                    B = setTimeout(function() {
                                        console.warn('Video has exceeded maximum recording time of: ' + D.a.getMaximumVideoRecordingTimeMS() + ' MS'),
                                        g.a.emit('SDK_ERROR', Object(I.c)(500)),
                                        g.a.emit('SDK_STOP')
                                    }, D.a.getMaximumVideoRecordingTimeMS()),
                                    Object(M.f)(d) && K(d) ? D.a.videoQuality = d : console.warn('videoQuality must be an integer value between 1 and 100')
                                }
                                v = o.opts.options.qualityPercent,
                                ee.run(o)
                            })['catch'](function(e) {
                                g.a.emit('SDK_ERROR', e)
                            });
                        'undefined' !== c()(t.userActionEvent) + '' && document.getElementById('mitekMediaStreamSource').play()
                    }
                }]),
                t
            }();
            t.a = new te
        }
        ).call(this, a(16))
    }
    , function(e) {
        e.exports = function(e) {
            if (null == e)
                throw new TypeError('Cannot destructure undefined')
        }
        ,
        e.exports['default'] = e.exports,
        e.exports.__esModule = !0
    }
    , function(e, t, a) {
        'use strict';
        var n = a(10)
          , i = a(3);
        t.a = {
            canHandle: function(e) {
                return 'DL_FRONT' === e.documentType || 'PASSPORT' === e.documentType || 'CHECK_FRONT' === e.documentType || 'CHECK_BACK' === e.documentType || 'DOCUMENT' === e.documentType
            },
            handle: function(e) {
                return 'AUTO_CAPTURE' === e.mode && !1 === Object(n.a)() ? new Promise(function(e, t) {
                    t(Object(i.c)(334))
                }
                ) : ('MANUAL_CAPTURE' === e.mode || 'PROCESS_FRAME' === e.mode) && !1 === Object(n.a)() ? a.e(1).then(a.bind(null, 69)) : a.e(3).then(a.bind(null, 112))
            }
        }
    }
    , function(e, t, a) {
        'use strict';
        var n = a(10)
          , i = a(3);
        t.a = {
            canHandle: function(e) {
                return 'PDF417_BARCODE' === e.documentType || 'DL_BACK' === e.documentType
            },
            handle: function(e) {
                return 'AUTO_CAPTURE' === e.mode && !1 === Object(n.a)() ? new Promise(function(e, t) {
                    t(Object(i.c)(334))
                }
                ) : ('MANUAL_CAPTURE' === e.mode || 'PROCESS_FRAME' === e.mode) && !1 === Object(n.a)() ? a.e(1).then(a.bind(null, 69)) : Promise.all([a.e(0), a.e(6), a.e(4)]).then(a.bind(null, 113))
            }
        }
    }
    , function(e, t, a) {
        'use strict';
        (function(e) {
            function n(e, t) {
                var a = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {
                    style: null,
                    offsetWidth: document.documentElement.clientWidth,
                    offsetHeight: document.documentElement.clientWidth
                }
                  , n = window.innerWidth
                  , i = window.innerHeight;
                if (null != v) {
                    var o = document.querySelector('#' + v);
                    n = o.offsetWidth,
                    i = o.offsetHeight
                }
                A.b(e, M, t, b, z, N, n, i);
                var r = A.a();
                j = {
                    top: r.top,
                    left: r.left,
                    gw: r.width,
                    gh: r.height
                },
                c.a.emit('ORIENTATION_CHANGE', {})
            }
            function i() {
                if (_.a.isVideoRecordingEnabled && '' !== _.a.recordingMessage.trim()) {
                    var e = document.createElement('div');
                    e.setAttribute('id', 'mitekVideoRecordingMessage'),
                    x && e.setAttribute('aria-live', x);
                    var t = document.createElement('div');
                    t.setAttribute('id', 'mitekVideoRecordingIcon');
                    var a = document.createElement('span');
                    a.setAttribute('id', 'mitekVideoRecordingMessageText'),
                    a.innerHTML = _.a.recordingMessage,
                    e.appendChild(t),
                    e.appendChild(a),
                    document.querySelector('#mitekDisplayContainer') && document.querySelector('#mitekDisplayContainer').appendChild(e)
                }
            }
            var o = a(9)
              , r = a.n(o)
              , s = a(6)
              , d = a.n(s)
              , l = a(15)
              , c = a(0)
              , p = a(20)
              , m = a(63)
              , u = a.n(m)
              , g = a(107)
              , y = a.n(g)
              , S = a(64)
              , h = a(65)
              , E = a(2)
              , f = a(19)
              , R = a(3)
              , A = a(41)
              , _ = a(4)
              , C = Object(R.b)().map(function(e) {
                return e.code
            })
              , T = a(110)
              , P = a(57)
              , D = new Date().getTime()
              , I = Object(f.a)()
              , M = !0
              , b = 0
              , v = null
              , L = 0
              , x = null
              , O = null
              , k = !1
              , N = {
                s1: 0,
                s2: 0
            }
              , F = !0
              , w = !1
              , U = function() {
                I.MitekMibiData.UserAgent = navigator.userAgent,
                I.MitekMibiData.Platform = Object(E.e)() ? 'Mobile' : 'Desktop'
            }
              , G = function(e, t) {
                if (Object(E.d)(e) && Object(E.d)(t)) {
                    var a = new Date().getTime() - D
                      , n = [];
                    t instanceof Array ? n = t : n.push(t),
                    n.unshift(a),
                    '' == I.MitekMibiData.UserAgent && U();
                    var i = {};
                    i[e] = n,
                    I.MitekMibiData.UXP.push(i)
                }
            };
            c.a.on('LOG_MIBI_EVENT', function(e) {
                G(e.eventName, e.eventValues)
            });
            var B = function() {
                I.MitekMibiData.UXP = []
            };
            c.a.on('FRAME_CAPTURE_RESULT', B),
            c.a.on('SDK_STOP', B);
            var V = new p.a
              , H = function(t, a) {
                var n = e.document.createElement(t);
                return a.forEach(function(e) {
                    n.setAttribute(e.key, e.val)
                }),
                n
            }
              , j = {
                landscape: {
                    x: 164,
                    y: 40,
                    w: 952,
                    h: 600,
                    b: 660,
                    r: 1116
                },
                portrait: {
                    x: 40,
                    y: 164,
                    w: 600,
                    h: 952,
                    b: 1116,
                    r: 660
                }
            }
              , K = Object(E.b)(1, 100)
              , q = function() {
                var e = {
                    jpegQualityPercentOneToHundred: .8,
                    mitekSDKPath: './mitekSDK'
                }
                  , t = function() {
                    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {
                        type: 'UNKNOWN'
                    }
                      , a = 1 < arguments.length ? arguments[1] : void 0;
                    switch ('undefined' != typeof a.jpegQualityPercentOneToHundred && Object(E.f)(a.jpegQualityPercentOneToHundred) && K(a.jpegQualityPercentOneToHundred) ? a.jpegQualityPercentOneToHundred /= 100 : a.jpegQualityPercentOneToHundred = e.jpegQualityPercentOneToHundred,
                    a.mitekSDKPath = 'undefined' == typeof a.mitekSDKPath ? e.mitekSDKPath : a.mitekSDKPath,
                    t.type) {
                    case 'APP_READY':
                        e = d()({}, e, {
                            app_ready: !0
                        });
                        break;
                    case 'ALL_SCIENCE_LOADED':
                        e = d()({}, e, {
                            science_ready: !0
                        });
                        break;
                    case 'SCREEN_UPDATE':
                        e = d()({}, e, {
                            screen: a
                        });
                        break;
                    case 'CUSTOMER_CONFIG':
                        e = d()({}, e, {
                            initialized: !0
                        }, a);
                        break;
                    case 'RESET_STATE':
                        e = e;
                        break;
                    default:
                    }
                    V.emit('COMPONENT_UPDATE', e)
                };
                return {
                    setState: t,
                    getState: function() {
                        return e
                    }
                }
            }()
              , z = !1
              , W = function() {
                var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                z = !('SELFIE' !== e.documentType && Object(E.e)());
                var t = null == e.videoContainerId ? 'fixed' : 'absolute'
                  , a = H('video', [{
                    key: 'id',
                    val: 'mitekMedia'
                }, {
                    key: 'autoplay',
                    val: !0
                }, {
                    key: 'playsinline',
                    val: !0
                }, {
                    key: 'style',
                    val: 'margin: 0; padding: 0; position: ' + t + '; object-fit: contain; transform-origin:50% 50%; top: 50%; left: 50%; pointer-events:none; transform: translate(-50%, -50%) scale(1.2541666666666667);'
                }]);
                return a.muted = !0,
                a.classList.add('fade-in'),
                a
            }
              , Q = function(e) {
                var t = W(e);
                return {
                    el: t
                }
            }
              , X = function(e) {
                var t = document.createElement('div');
                return t.setAttribute('id', u.a.guideBox),
                t.setAttribute('class', 'integrator ' + e.documentType),
                {
                    el: t
                }
            }
              , Y = function(t) {
                var a = t.mediaFeed
                  , o = void 0 === a ? '' : a
                  , s = t.canvas
                  , p = void 0 === s ? '' : s
                  , m = t.documentType
                  , u = void 0 === m ? '' : m
                  , g = t.emitter
                  , y = t.opts
                  , E = void 0 === y ? {} : y
                  , f = t.scienceModule
                  , R = void 0 === f ? {} : f;
                return {
                    mediaFeed: o,
                    canvas: p,
                    Cam$: h.a,
                    CaptureComponent: Q,
                    Guide: null,
                    run: function(t) {
                        function a(e) {
                            c.a.emit('ORIENTATION_AXIS_CHANGE', e)
                        }
                        var o = this;
                        b = t.guidePaddingLevel,
                        v = t.videoContainerId,
                        L = t.hintMessageSize,
                        x = t.hintAriaLive,
                        O = t.hintDuration,
                        M = !0;
                        var s = {}
                          , p = Object(S.a)().filter(function(e) {
                            return e.docType === t.documentType
                        })[0]
                          , m = function() {
                            return n(o.Guide.el, p, o.CaptureComponent.el)
                        }
                          , u = document.createElement('div');
                        u.setAttribute('id', 'mitekOuterContainer'),
                        null != v && u.classList.add('customContainer');
                        var g = document.createElement('div');
                        g.setAttribute('id', 'mitekDisplayContainer'),
                        null != v && g.classList.add('customContainer'),
                        this.CaptureComponent = Q(t),
                        this.Guide = X({
                            documentType: t.documentType
                        }),
                        g.appendChild(this.CaptureComponent.el),
                        null == v && document.body.classList.add('mitekNoscroll'),
                        null == v ? window.addEventListener('resize', function() {
                            m()
                        }) : document.querySelector('#' + v).addEventListener('resize', function() {
                            m()
                        }),
                        window.addEventListener('orientationchange', function() {
                            setTimeout(function() {
                                m()
                            }, 100)
                        }),
                        'SELFIE' === t.documentType && window.DeviceOrientationEvent && ('undefined' != typeof window && 'undefined' != typeof window.DeviceOrientationEvent && 'undefined' !== r()(window.DeviceOrientationEvent.requestPermission) + '' ? window.DeviceOrientationEvent.requestPermission().then(function(e) {
                            'granted' == e && window.addEventListener('deviceorientation', function(e) {
                                a(e.beta)
                            }, !0)
                        })['catch'](console.error) : window.addEventListener('deviceorientation', function(e) {
                            a(e.beta)
                        }, !0));
                        var y = document.createElement('div');
                        y.setAttribute('id', 'mitekHintMessage'),
                        1 === L ? y.setAttribute('class', 'small') : 2 === L ? y.setAttribute('class', 'medium') : 3 === L ? y.setAttribute('class', 'large') : void 0,
                        x && (y.setAttribute('aria-live', x),
                        y.setAttribute('role', 'alert'),
                        k = !1),
                        g.appendChild(y),
                        u.appendChild(g);
                        var h = this.Guide.el;
                        c.a.once('_APPEND_VIDEO_COMPONENT_', function() {
                            null === v ? document.body.appendChild(u) : document.querySelector('#' + v).appendChild(u),
                            i()
                        }),
                        window.My = this.CaptureComponent,
                        c.a.on('USER_MEDIA_STREAM_ACTIVE', function() {
                            document.querySelector('#mitekDisplayContainer') && setTimeout(function() {
                                document.querySelector('#mitekDisplayContainer').appendChild(h),
                                m()
                            }, 0)
                        });
                        var E = function() {
                            document.querySelector('#mitekHintMessage') && (document.querySelector('#mitekHintMessage').innerHTML = '',
                            document.querySelector('#mitekHintMessage').setAttribute('aria-valuetext', ''))
                        }
                          , f = function(e) {
                            if (!1 != F || !1 != w) {
                                var t = document.querySelector('#mitekHintMessage');
                                !0 == M && t && (!0 == k && t.removeAttribute('role'),
                                t.innerHTML = e,
                                t.setAttribute('aria-valuetext', e),
                                k = !0,
                                F = !1)
                            }
                        };
                        this.CaptureComponent.el.addEventListener('loadedmetadata', function() {
                            N.s1 = o.CaptureComponent.el.videoWidth,
                            N.s2 = o.CaptureComponent.el.videoHeight,
                            M = !0
                        }),
                        this.CaptureComponent.el.addEventListener('canplay', function() {
                            l.a.updateReadinessState({
                                ready: 'videoElementsLoaded'
                            }),
                            setTimeout(function() {
                                w = !0
                            }, 3e3),
                            G(I.MitekMibiAction.AUTOCAPTURE_CAMERA_DISPLAY, ''),
                            M = !0,
                            n(o.Guide.el, p)
                        });
                        var R = function() {
                            o.Guide.el.remove(),
                            e.document.querySelector('#mitekOuterContainer') && e.document.querySelector('#mitekOuterContainer').remove(),
                            e.document.body.classList.remove('mitekNoscroll')
                        };
                        return c.a.once('SDK_ERROR', function(t) {
                            try {
                                var a = t[0].code;
                                e.document.querySelector('#mitekMediaContainer') && (e.document.querySelector('#mitekMediaContainer').style.zIndex = '-1'),
                                -1 != C.indexOf(a) && c.a.emit('SDK_STOP')
                            } catch (a) {
                                console.warn(t),
                                console.warn('SDK unable read error code', a),
                                c.a.emit('SDK_STOP')
                            }
                        }),
                        {
                            getFrame: function(e) {
                                return d()({}, j, {
                                    imageData: o.Cam$.getFrame({
                                        frameType: e
                                    })
                                })
                            },
                            getScreenInfo: function() {
                                return s
                            },
                            startCamera: function(e) {
                                c.a.on('SHOW_HINT', f),
                                c.a.on('HIDE_HINT', E),
                                o.Cam$.pub('INIT', {
                                    startCallback: function() {
                                        null === _.a.videoSource ? o.CaptureComponent.el.srcObject = o.Cam$.el.srcObject.clone() : o.CaptureComponent.el.src = o.Cam$.el.src,
                                        e()
                                    },
                                    documentType: t.documentType
                                })
                            },
                            tearDownCamera: function() {
                                if (R(),
                                o.CaptureComponent.el.srcObject) {
                                    o.CaptureComponent.el.pause();
                                    var t = o.CaptureComponent.el.srcObject.getVideoTracks();
                                    t.forEach(function(e) {
                                        e.stop()
                                    });
                                    var a = o.CaptureComponent.el.srcObject.getAudioTracks();
                                    a.forEach(function(e) {
                                        e.stop()
                                    })
                                }
                                e.document.querySelector('#mitekMediaContainer') && (e.document.querySelector('#mitekMediaContainer').style.zIndex = '-1'),
                                o.Cam$.pub('STOP'),
                                c.a.emit('FRAME_PROCESSING_ENDED')
                            }
                        }
                    }
                }
            };
            t.a = function() {
                return F = !0,
                w = !1,
                e.piexif = P,
                e.screenfull = T,
                Y({})
            }
        }
        ).call(this, a(16))
    }
    , function(e, t, a) {
        var n = a(106);
        'string' == typeof n && (n = [[e.i, n, '']]);
        a(43)(n, {});
        n.locals && (e.exports = n.locals),
        !1
    }
    , function(e, t, a) {
        'use strict';
        function n() {
            return [{
                docType: 'DL_FRONT',
                aspectRatio: 1.59,
                guidePadding: {
                    desktop: {
                        landscape: .2
                    },
                    mobile: {
                        landscape: .2,
                        portrait: .2
                    }
                }
            }, {
                docType: 'PDF417_BARCODE',
                aspectRatio: 1.59,
                guidePadding: {
                    desktop: {
                        landscape: .2
                    },
                    mobile: {
                        landscape: .2,
                        portrait: .2
                    }
                }
            }, {
                docType: 'CHECK_FRONT',
                aspectRatio: 2.1818,
                guidePadding: {
                    desktop: {
                        landscape: .3
                    },
                    mobile: {
                        landscape: .2,
                        portrait: .1
                    }
                }
            }, {
                docType: 'CHECK_BACK',
                aspectRatio: 2.1818,
                guidePadding: {
                    desktop: {
                        landscape: .3
                    },
                    mobile: {
                        landscape: .2,
                        portrait: .1
                    }
                }
            }, {
                docType: 'PASSPORT',
                aspectRatio: 1.42045,
                guidePadding: {
                    desktop: {
                        landscape: .2
                    },
                    mobile: {
                        landscape: .2,
                        portrait: .2
                    }
                }
            }, {
                docType: 'SELFIE',
                aspectRatio: 1.59,
                guidePadding: {
                    desktop: {
                        landscape: .15
                    },
                    mobile: {
                        landscape: .15,
                        portrait: .2
                    }
                }
            }, {
                docType: 'DOCUMENT',
                aspectRatio: 1.294,
                guidePadding: {
                    desktop: {
                        landscape: .15
                    },
                    mobile: {
                        landscape: .15,
                        portrait: .2
                    }
                }
            }]
        }
        a.d(t, 'a', function() {
            return n
        })
    }
    , function(e, a, i) {
        'use strict';
        (function(e) {
            function o() {
                var e = n(1, A.width)
                  , t = n(1, A.height);
                P.clearRect(0, 0, e, t),
                0 < _.videoHeight && _.videoHeight === t && 0 < _.videoWidth && _.videoWidth === e && P.drawImage(_, 0, 0, e, t)
            }
            function r() {
                requestAnimationFrame(o)
            }
            var s = i(6)
              , d = i.n(s)
              , l = i(7)
              , c = i.n(l)
              , p = i(5)
              , m = i.n(p)
              , u = i(20)
              , g = i(68)
              , y = i(0)
              , S = i(40)
              , h = i(4)
              , E = i(3);
            try {} catch (t) {}
            var f = new u.a
              , R = {
                longSide: 0,
                shortSide: 0
            }
              , A = {
                width: 0,
                height: 0
            }
              , _ = e.document.createElement('video');
            _.setAttribute('id', 'mitekMediaStreamSource'),
            _.setAttribute('autoplay', !0),
            _.setAttribute('playsinline', !0),
            _.muted = !0;
            var C = e.document.createElement('div');
            C.setAttribute('id', 'mitekMediaContainer'),
            C.setAttribute('style', 'position:fixed; transform: translate(-50%, -50%) scale(0.3); opacity:0; top:0; left:0; z-index: -1;'),
            C.appendChild(_),
            e.document.body.appendChild(C);
            var T = e.document.createElement('canvas')
              , P = T.getContext('2d', {
                alpha: !1
            });
            P.mozImageSmoothingEnabled = !1,
            P.msImageSmoothingEnabled = !1,
            P.imageSmoothingEnabled = !1;
            var D = function() {
                var a = t(e.document.documentElement.clientWidth, window.innerWidth || 0)
                  , n = t(e.document.documentElement.clientHeight, window.innerHeight || 0);
                return n > a ? 'portrait' : 'landscape'
            }
              , I = function(e) {
                var t = e.width
                  , a = e.height;
                C.setAttribute('style', 'transform: translate(-50%, -50%) scale(0.3); opacity:0; top:0; left:0; margin: 0; padding: 0; position: absolute; width: '.concat(t, 'px; height: ').concat(a, 'px;')),
                _.setAttribute('width', t),
                _.setAttribute('height', a),
                _.setAttribute('style', 'margin: 0; padding: 0; width: '.concat(t, 'px; height: ').concat(a, 'px;')),
                T.setAttribute('width', t),
                T.setAttribute('height', a),
                T.setAttribute('style', 'margin: 0; padding: 0; width: '.concat(t, 'px; height: ').concat(a, 'px;'))
            }
              , M = !1
              , b = {
                css: '',
                startCallback: function() {
                    return null
                }
            }
              , v = function() {
                'landscape' === D() ? (A = {
                    width: R.longSide,
                    height: R.shortSide
                },
                y.a.emit('INNER_GUIDE_CHANGE', {})) : (A = {
                    width: R.shortSide,
                    height: R.longSide
                },
                y.a.emit('INNER_GUIDE_CHANGE', {})),
                I(A)
            }
              , L = function() {
                var a = c()(m.a.mark(function a(i) {
                    var o;
                    return m.a.wrap(function(a) {
                        for (; ; )
                            switch (a.prev = a.next) {
                            case 0:
                                !1 === M && (b = d()({}, b, i),
                                M = !0,
                                e.document.querySelector('#mitekMediaContainer') && (e.document.querySelector('#mitekMediaContainer').style.zIndex = '90'),
                                _.src = h.a.videoSource,
                                _.play(),
                                R.longSide = 1280,
                                R.shortSide = 720,
                                _.addEventListener('loadedmetadata', function() {
                                    R.longSide = n(_.videoWidth, _.videoHeight),
                                    R.shortSide = t(_.videoWidth, _.videoHeight)
                                }),
                                y.a.on('ORIENTATION_CHANGE', v),
                                v(),
                                b.startCallback(),
                                o = function() {
                                    M = !1,
                                    _.pause()
                                }
                                ,
                                _.onerror = function() {
                                    y.a.emit('SDK_ERROR', Object(E.c)(600)),
                                    y.a.emit('SDK_STOP')
                                }
                                ,
                                _.onended = function() {
                                    y.a.emit('SDK_ERROR', Object(E.c)(601)),
                                    y.a.emit('SDK_STOP')
                                }
                                ,
                                f.on('STOP', o));
                                ;
                            case 2:
                            case 'end':
                                return a.stop();
                            }
                    }, a)
                }));
                return function() {
                    return a.apply(this, arguments)
                }
            }()
              , x = function() {
                var t = c()(m.a.mark(function t(a) {
                    var n, i, o, r;
                    return m.a.wrap(function(t) {
                        for (; ; )
                            switch (t.prev = t.next) {
                            case 0:
                                if (!1 != M) {
                                    t.next = 28;
                                    break
                                }
                                return b = d()({}, b, a),
                                n = function() {
                                    var t = c()(m.a.mark(function t(a) {
                                        var n, i;
                                        return m.a.wrap(function(t) {
                                            for (; ; )
                                                switch (t.prev = t.next) {
                                                case 0:
                                                    if (M = !0,
                                                    e.document.querySelector('#mitekMediaContainer') && (e.document.querySelector('#mitekMediaContainer').style.zIndex = '90'),
                                                    'srcObject'in _)
                                                        try {
                                                            _.srcObject = a,
                                                            n = a.getVideoTracks()[0].getSettings(),
                                                            n.width > n.height ? (R.longSide = n.width,
                                                            R.shortSide = n.height) : (R.longSide = n.height,
                                                            R.shortSide = n.width)
                                                        } catch (t) {
                                                            _.src = a
                                                        }
                                                    else
                                                        try {
                                                            _.src = window.URL.createObjectURL(a)
                                                        } catch (e) {
                                                            _.src = a
                                                        }
                                                    if (!h.a.isVideoRecordingEnabled) {
                                                        t.next = 12;
                                                        break
                                                    }
                                                    return t.prev = 4,
                                                    t.next = 7,
                                                    h.a.startRecording(a, _);
                                                case 7:
                                                    t.next = 12;
                                                    break;
                                                case 9:
                                                    t.prev = 9,
                                                    t.t0 = t['catch'](4),
                                                    y.a.emit('SDK_ERROR', Object(E.c)(130));
                                                case 12:
                                                    y.a.on('ORIENTATION_CHANGE', v),
                                                    v(),
                                                    b.startCallback(),
                                                    i = function() {
                                                        M = !1;
                                                        var e = _.srcObject.getVideoTracks();
                                                        e.forEach(function(e) {
                                                            e.stop()
                                                        });
                                                        var t = _.srcObject.getAudioTracks();
                                                        t.forEach(function(e) {
                                                            e.stop()
                                                        })
                                                    }
                                                    ,
                                                    f.on('STOP', i);
                                                case 17:
                                                case 'end':
                                                    return t.stop();
                                                }
                                        }, t, null, [[4, 9]])
                                    }));
                                    return function() {
                                        return t.apply(this, arguments)
                                    }
                                }(),
                                i = function(e) {
                                    return y.a.emit('SDK_ERROR', Object(S.a)(e))
                                }
                                ,
                                t.prev = 4,
                                t.next = 7,
                                Object(g.a)(_, a);
                            case 7:
                                if (o = t.sent,
                                'undefined' != typeof o) {
                                    t.next = 13;
                                    break
                                }
                                y.a.emit('SDK_ERROR', Object(S.a)(120)),
                                y.a.emit('SDK_STOP'),
                                t.next = 23;
                                break;
                            case 13:
                                return t.prev = 13,
                                t.next = 16,
                                n(o);
                            case 16:
                                return r = t.sent,
                                t.abrupt('return', r);
                            case 20:
                                t.prev = 20,
                                t.t0 = t['catch'](13),
                                i(t.t0);
                            case 23:
                                t.next = 28;
                                break;
                            case 25:
                                t.prev = 25,
                                t.t1 = t['catch'](4),
                                i(t.t1);
                            case 28:
                            case 'end':
                                return t.stop();
                            }
                    }, t, null, [[4, 25], [13, 20]])
                }));
                return function() {
                    return t.apply(this, arguments)
                }
            }();
            f.on({
                INIT: 'INIT'
            }.INIT, function(e) {
                null === h.a.videoSource ? x(e) : L(e)
            }),
            a.a = {
                sub: function(e, t) {
                    f.on(e, t)
                },
                pub: function(e, t) {
                    f.emit(e, t)
                },
                getFrame: function(e) {
                    return r(),
                    'image_data' === e.frameType ? P.getImageData(0, 0, A.width, A.height) : T.toDataURL('image/jpeg')
                },
                el: _,
                container: C
            }
        }
        ).call(this, i(16))
    }
    , function(e, t) {
        'use strict';
        t.a = Object.freeze({
            0: 'off',
            1: 'polite',
            2: 'assertive',
            get: function(e) {
                return e in this ? this[e] : ''
            }
        })
    }
    , function(e, t, a) {
        'use strict';
        var n = function() {
            var e = function() {
                try {
                    var e = document.createElement('canvas');
                    return !!window.WebGLRenderingContext && !!(e.getContext('webgl') || e.getContext('experimental-webgl'))
                } catch (t) {
                    return !1
                }
            }();
            return e
        }
          , i = a(3)
          , o = t.a = {
            canHandle: function(e) {
                return 'SELFIE' === e.documentType
            },
            handle: function(e) {
                return 'AUTO_CAPTURE' === e.mode && !1 === n() ? new Promise(function(e, t) {
                    t(Object(i.c)(336))
                }
                ) : Promise.all([a.e(0), a.e(7), a.e(5)]).then(a.bind(null, 288))
            }
        }
    }
    , function(e, t, a) {
        'use strict';
        function n() {
            return i.apply(this, arguments)
        }
        function i() {
            return i = m()(g.a.mark(function e(t) {
                var a;
                return g.a.wrap(function(e) {
                    for (; ; )
                        switch (e.prev = e.next) {
                        case 0:
                            return a = null,
                            e.prev = 1,
                            e.next = 4,
                            navigator.mediaDevices.getUserMedia(t);
                        case 4:
                            return a = e.sent,
                            e.abrupt('return', a);
                        case 8:
                            return e.prev = 8,
                            e.t0 = e['catch'](1),
                            console.log('error getting stream', e.t0),
                            console.trace(e.t0),
                            e.abrupt('return', !1);
                        case 13:
                        case 'end':
                            return e.stop();
                        }
                }, e, null, [[1, 8]])
            })),
            i.apply(this, arguments)
        }
        function o() {
            return r.apply(this, arguments)
        }
        function r() {
            return r = m()(g.a.mark(function e() {
                var t;
                return g.a.wrap(function(e) {
                    for (; ; )
                        switch (e.prev = e.next) {
                        case 0:
                            return e.next = 2,
                            navigator.mediaDevices.enumerateDevices();
                        case 2:
                            return t = e.sent,
                            t = t.filter(function(e) {
                                return 'videoinput' == e.kind
                            }),
                            e.abrupt('return', t);
                        case 5:
                        case 'end':
                            return e.stop();
                        }
                }, e)
            })),
            r.apply(this, arguments)
        }
        function s() {
            return s = m()(g.a.mark(function e() {
                var t, a, n;
                return g.a.wrap(function(e) {
                    for (; ; )
                        switch (e.prev = e.next) {
                        case 0:
                            return e.next = 2,
                            o();
                        case 2:
                            return t = e.sent,
                            a = null,
                            n = t.filter(function(e) {
                                return 'camera2 0, facing back' === e.label
                            }),
                            n.forEach(function(e) {
                                a || (a = e.deviceId)
                            }),
                            e.abrupt('return', a);
                        case 7:
                        case 'end':
                            return e.stop();
                        }
                }, e)
            })),
            s.apply(this, arguments)
        }
        function d() {
            return l.apply(this, arguments)
        }
        function l() {
            return l = m()(g.a.mark(function e() {
                var t, a;
                return g.a.wrap(function(e) {
                    for (; ; )
                        switch (e.prev = e.next) {
                        case 0:
                            return e.prev = 0,
                            e.next = 3,
                            n(y.anyVideo);
                        case 3:
                            a = e.sent,
                            window.baseStream = a,
                            t = a instanceof MediaStream,
                            a.getVideoTracks().forEach(function(e) {
                                e.stop()
                            }),
                            e.next = 12;
                            break;
                        case 9:
                            e.prev = 9,
                            e.t0 = e['catch'](0),
                            t = !1;
                        case 12:
                            return e.abrupt('return', t);
                        case 13:
                        case 'end':
                            return e.stop();
                        }
                }, e, null, [[0, 9]])
            })),
            l.apply(this, arguments)
        }
        function c() {
            return c = m()(g.a.mark(function e(t, a) {
                var n, i, o, r, s, l;
                return g.a.wrap(function(e) {
                    for (; ; )
                        switch (e.prev = e.next) {
                        case 0:
                            if (l = function() {
                                return 'undefined' == typeof navigator.mediaDevices.getUserMedia && (navigator.mediaDevices.getUserMedia = function(e) {
                                    var t = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
                                    return t ? new Promise(function(a, n) {
                                        t.call(navigator, e, a, n)
                                    }
                                    ) : Promise.reject(new Error('getUserMedia not supported'))
                                }
                                ),
                                navigator.mediaDevices.getUserMedia(n)
                            }
                            ,
                            s = function(e) {
                                -1 == ['ConstraintNotSatisfiedError', 'OverconstrainedError'].indexOf(e.name) ? Object(E.e)() && -1 != ['Error'].indexOf(e.name) ? r(Object(h.c)(111)) : -1 == ['PermissionDeniedError', 'NotAllowedError'].indexOf(e.name) ? r(Object(h.c)(120)) : r(Object(h.c)(113)) : r(Object(h.c)(111))
                            }
                            ,
                            r = function(e) {
                                S.a.emit('USER_MEDIA_ERROR', e)
                            }
                            ,
                            o = function(e) {
                                var a = e.getVideoTracks();
                                if (e.oninactive = function() {
                                    S.a.emit('USER_MEDIA_STREAM_INACTIVE', {
                                        payload: t,
                                        constraints: i,
                                        videoTracks: a
                                    })
                                }
                                ,
                                t.srcObject = e,
                                'srcObject'in t)
                                    ;
                                else
                                    try {
                                        t.src = window.URL.createObjectURL(e)
                                    } catch (a) {
                                        t.src = e
                                    }
                                S.a.emit('USER_MEDIA_STREAM_ACTIVE')
                            }
                            ,
                            E.i.init(),
                            !Object(E.c)()) {
                                e.next = 9;
                                break
                            }
                            return e.next = 8,
                            d();
                        case 8:
                            e.sent;
                        case 9:
                            if (n = {
                                audio: f.a.getAudioConstraint(),
                                video: {
                                    width: {
                                        ideal: 'DOCUMENT' === a.documentType ? 1920 : 1280
                                    },
                                    height: {
                                        ideal: 'DOCUMENT' === a.documentType ? 1080 : 720
                                    },
                                    facingMode: 'SELFIE' === a.documentType ? 'user' : 'environment',
                                    focusMode: 'continuous'
                                }
                            },
                            i = window.constraints = {
                                audio: !1,
                                video: !0
                            },
                            'undefined' == typeof navigator.mediaDevices && (navigator.mediaDevices = {}),
                            'undefined' == typeof navigator.mediaDevices.enumerateDevices || 'function' != typeof navigator.mediaDevices.enumerateDevices) {
                                e.next = 14;
                                break
                            }
                            return e.abrupt('return', new Promise(function(e, t) {
                                navigator.mediaDevices.enumerateDevices().then(function(t) {
                                    t.filter(function(e) {
                                        return 'camera2 0, facing back' === e.label
                                    }).forEach(function(e) {
                                        n.video.deviceId = e.deviceId
                                    }),
                                    e(n)
                                })['catch'](function(e) {
                                    t(e)
                                })
                            }
                            ).then(function(e) {
                                return l(e)
                            }));
                        case 14:
                        case 'end':
                            return e.stop();
                        }
                }, e)
            })),
            c.apply(this, arguments)
        }
        var p = a(7)
          , m = a.n(p)
          , u = a(5)
          , g = a.n(u)
          , y = {
            rearCamera: {
                audio: !1,
                video: {
                    facingMode: {
                        exact: 'enviroment'
                    }
                }
            },
            anyVideo: {
                video: !0
            }
        }
          , S = a(0)
          , h = a(3)
          , E = a(2)
          , f = a(4)
          , R = Object(h.a)()
          , A = t.a = function() {
            return c.apply(this, arguments)
        }
    }
    , , function(e, t, a) {
        e.exports = a(111)
    }
    , function(e) {
        var t = function(e) {
            'use strict';
            function t(e, t, a, i) {
                var o = t && t.prototype instanceof n ? t : n
                  , r = Object.create(o.prototype)
                  , s = new m(i || []);
                return r._invoke = d(e, a, s),
                r
            }
            function a(e, t, a) {
                try {
                    return {
                        type: 'normal',
                        arg: e.call(t, a)
                    }
                } catch (e) {
                    return {
                        type: 'throw',
                        arg: e
                    }
                }
            }
            function n() {}
            function i() {}
            function o() {}
            function r(e) {
                ['next', 'throw', 'return'].forEach(function(t) {
                    e[t] = function(e) {
                        return this._invoke(t, e)
                    }
                })
            }
            function s(e) {
                function t(n, i, o, r) {
                    var s = a(e[n], e, i);
                    if ('throw' === s.type)
                        r(s.arg);
                    else {
                        var d = s.arg
                          , l = d.value;
                        return l && 'object' == typeof l && S.call(l, '__await') ? Promise.resolve(l.__await).then(function(e) {
                            t('next', e, o, r)
                        }, function(e) {
                            t('throw', e, o, r)
                        }) : Promise.resolve(l).then(function(e) {
                            d.value = e,
                            o(d)
                        }, function(e) {
                            return t('throw', e, o, r)
                        })
                    }
                }
                function n(e, a) {
                    function n() {
                        return new Promise(function(n, i) {
                            t(e, a, n, i)
                        }
                        )
                    }
                    return i = i ? i.then(n, n) : n()
                }
                var i;
                this._invoke = n
            }
            function d(e, t, n) {
                var i = A;
                return function(o, r) {
                    if (i === C)
                        throw new Error('Generator is already running');
                    if (i === T) {
                        if ('throw' === o)
                            throw r;
                        return g()
                    }
                    for (n.method = o,
                    n.arg = r; ; ) {
                        var s = n.delegate;
                        if (s) {
                            var d = l(s, n);
                            if (d) {
                                if (d === P)
                                    continue;
                                return d
                            }
                        }
                        if ('next' === n.method)
                            n.sent = n._sent = n.arg;
                        else if ('throw' === n.method) {
                            if (i === A)
                                throw i = T,
                                n.arg;
                            n.dispatchException(n.arg)
                        } else
                            'return' === n.method && n.abrupt('return', n.arg);
                        i = C;
                        var c = a(e, t, n);
                        if ('normal' === c.type) {
                            if (i = n.done ? T : _,
                            c.arg === P)
                                continue;
                            return {
                                value: c.arg,
                                done: n.done
                            }
                        }
                        'throw' === c.type && (i = T,
                        n.method = 'throw',
                        n.arg = c.arg)
                    }
                }
            }
            function l(e, t) {
                var n = e.iterator[t.method];
                if (void 0 === n) {
                    if (t.delegate = null,
                    'throw' === t.method) {
                        if (e.iterator['return'] && (t.method = 'return',
                        t.arg = void 0,
                        l(e, t),
                        'throw' === t.method))
                            return P;
                        t.method = 'throw',
                        t.arg = new TypeError('The iterator does not provide a \'throw\' method')
                    }
                    return P
                }
                var i = a(n, e.iterator, t.arg);
                if ('throw' === i.type)
                    return t.method = 'throw',
                    t.arg = i.arg,
                    t.delegate = null,
                    P;
                var o = i.arg;
                if (!o)
                    return t.method = 'throw',
                    t.arg = new TypeError('iterator result is not an object'),
                    t.delegate = null,
                    P;
                if (o.done)
                    t[e.resultName] = o.value,
                    t.next = e.nextLoc,
                    'return' !== t.method && (t.method = 'next',
                    t.arg = void 0);
                else
                    return o;
                return t.delegate = null,
                P
            }
            function c(e) {
                var t = {
                    tryLoc: e[0]
                };
                1 in e && (t.catchLoc = e[1]),
                2 in e && (t.finallyLoc = e[2],
                t.afterLoc = e[3]),
                this.tryEntries.push(t)
            }
            function p(e) {
                var t = e.completion || {};
                t.type = 'normal',
                delete t.arg,
                e.completion = t
            }
            function m(e) {
                this.tryEntries = [{
                    tryLoc: 'root'
                }],
                e.forEach(c, this),
                this.reset(!0)
            }
            function u(e) {
                if (e) {
                    var t = e[E];
                    if (t)
                        return t.call(e);
                    if ('function' == typeof e.next)
                        return e;
                    if (!isNaN(e.length)) {
                        var a = -1
                          , n = function t() {
                            for (; ++a < e.length; )
                                if (S.call(e, a))
                                    return t.value = e[a],
                                    t.done = !1,
                                    t;
                            return t.value = void 0,
                            t.done = !0,
                            t
                        };
                        return n.next = n
                    }
                }
                return {
                    next: g
                }
            }
            function g() {
                return {
                    value: void 0,
                    done: !0
                }
            }
            var y = Object.prototype
              , S = y.hasOwnProperty
              , h = 'function' == typeof Symbol ? Symbol : {}
              , E = h.iterator || '@@iterator'
              , f = h.asyncIterator || '@@asyncIterator'
              , R = h.toStringTag || '@@toStringTag';
            e.wrap = t;
            var A = 'suspendedStart'
              , _ = 'suspendedYield'
              , C = 'executing'
              , T = 'completed'
              , P = {}
              , D = {};
            D[E] = function() {
                return this
            }
            ;
            var I = Object.getPrototypeOf
              , M = I && I(I(u([])));
            M && M !== y && S.call(M, E) && (D = M);
            var b = o.prototype = n.prototype = Object.create(D);
            return i.prototype = b.constructor = o,
            o.constructor = i,
            o[R] = i.displayName = 'GeneratorFunction',
            e.isGeneratorFunction = function(e) {
                var t = 'function' == typeof e && e.constructor;
                return !!t && (t === i || 'GeneratorFunction' === (t.displayName || t.name))
            }
            ,
            e.mark = function(e) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : (e.__proto__ = o,
                !(R in e) && (e[R] = 'GeneratorFunction')),
                e.prototype = Object.create(b),
                e
            }
            ,
            e.awrap = function(e) {
                return {
                    __await: e
                }
            }
            ,
            r(s.prototype),
            s.prototype[f] = function() {
                return this
            }
            ,
            e.AsyncIterator = s,
            e.async = function(a, n, i, o) {
                var r = new s(t(a, n, i, o));
                return e.isGeneratorFunction(n) ? r : r.next().then(function(e) {
                    return e.done ? e.value : r.next()
                })
            }
            ,
            r(b),
            b[R] = 'Generator',
            b[E] = function() {
                return this
            }
            ,
            b.toString = function() {
                return '[object Generator]'
            }
            ,
            e.keys = function(e) {
                var t = [];
                for (var a in e)
                    t.push(a);
                return t.reverse(),
                function a() {
                    for (; t.length; ) {
                        var n = t.pop();
                        if (n in e)
                            return a.value = n,
                            a.done = !1,
                            a
                    }
                    return a.done = !0,
                    a
                }
            }
            ,
            e.values = u,
            m.prototype = {
                constructor: m,
                reset: function(e) {
                    if (this.prev = 0,
                    this.next = 0,
                    this.sent = this._sent = void 0,
                    this.done = !1,
                    this.delegate = null,
                    this.method = 'next',
                    this.arg = void 0,
                    this.tryEntries.forEach(p),
                    !e)
                        for (var t in this)
                            't' === t.charAt(0) && S.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0)
                },
                stop: function() {
                    this.done = !0;
                    var e = this.tryEntries[0]
                      , t = e.completion;
                    if ('throw' === t.type)
                        throw t.arg;
                    return this.rval
                },
                dispatchException: function(e) {
                    function t(t, n) {
                        return o.type = 'throw',
                        o.arg = e,
                        a.next = t,
                        n && (a.method = 'next',
                        a.arg = void 0),
                        !!n
                    }
                    if (this.done)
                        throw e;
                    for (var a = this, n = this.tryEntries.length - 1; 0 <= n; --n) {
                        var i = this.tryEntries[n]
                          , o = i.completion;
                        if ('root' === i.tryLoc)
                            return t('end');
                        if (i.tryLoc <= this.prev) {
                            var r = S.call(i, 'catchLoc')
                              , s = S.call(i, 'finallyLoc');
                            if (r && s) {
                                if (this.prev < i.catchLoc)
                                    return t(i.catchLoc, !0);
                                if (this.prev < i.finallyLoc)
                                    return t(i.finallyLoc)
                            } else if (r) {
                                if (this.prev < i.catchLoc)
                                    return t(i.catchLoc, !0);
                            } else if (!s)
                                throw new Error('try statement without catch or finally');
                            else if (this.prev < i.finallyLoc)
                                return t(i.finallyLoc)
                        }
                    }
                },
                abrupt: function(e, t) {
                    for (var a = this.tryEntries.length - 1, n; 0 <= a; --a)
                        if (n = this.tryEntries[a],
                        n.tryLoc <= this.prev && S.call(n, 'finallyLoc') && this.prev < n.finallyLoc) {
                            var i = n;
                            break
                        }
                    i && ('break' === e || 'continue' === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                    var o = i ? i.completion : {};
                    return o.type = e,
                    o.arg = t,
                    i ? (this.method = 'next',
                    this.next = i.finallyLoc,
                    P) : this.complete(o)
                },
                complete: function(e, t) {
                    if ('throw' === e.type)
                        throw e.arg;
                    return 'break' === e.type || 'continue' === e.type ? this.next = e.arg : 'return' === e.type ? (this.rval = this.arg = e.arg,
                    this.method = 'return',
                    this.next = 'end') : 'normal' === e.type && t && (this.next = t),
                    P
                },
                finish: function(e) {
                    for (var t = this.tryEntries.length - 1, a; 0 <= t; --t)
                        if (a = this.tryEntries[t],
                        a.finallyLoc === e)
                            return this.complete(a.completion, a.afterLoc),
                            p(a),
                            P
                },
                catch: function(e) {
                    for (var t = this.tryEntries.length - 1, a; 0 <= t; --t)
                        if (a = this.tryEntries[t],
                        a.tryLoc === e) {
                            var n = a.completion;
                            if ('throw' === n.type) {
                                var i = n.arg;
                                p(a)
                            }
                            return i
                        }
                    throw new Error('illegal catch attempt')
                },
                delegateYield: function(e, t, a) {
                    return this.delegate = {
                        iterator: u(e),
                        resultName: t,
                        nextLoc: a
                    },
                    'next' === this.method && (this.arg = void 0),
                    P
                }
            },
            e
        }(e.exports);
        try {
            regeneratorRuntime = t
        } catch (e) {
            Function('r', 'regeneratorRuntime = r')(t)
        }
    }
    , function(e, t, a) {
        a(73),
        a(76),
        a(87),
        a(91),
        e.exports = a(25).Promise
    }
    , function(e, t, a) {
        'use strict';
        var n = a(32);
        ({})[a(8)('toStringTag')] = 'z',
        a(22)(Object.prototype, 'toString', function() {
            return '[object ' + n(this) + ']'
        }, !0)
    }
    , function(e, t, a) {
        e.exports = !a(24) && !a(45)(function() {
            return 7 != Object.defineProperty(a(34)('div'), 'a', {
                get: function() {
                    return 7
                }
            }).a
        })
    }
    , function(e, t, a) {
        var n = a(23);
        e.exports = function(e, t) {
            if (!n(e))
                return e;
            var a, i;
            if (t && 'function' == typeof (a = e.toString) && !n(i = a.call(e)))
                return i;
            if ('function' == typeof (a = e.valueOf) && !n(i = a.call(e)))
                return i;
            if (!t && 'function' == typeof (a = e.toString) && !n(i = a.call(e)))
                return i;
            throw TypeError('Can\'t convert object to primitive value')
        }
    }
    , function(e, t, a) {
        'use strict';
        var n = a(77)(!0);
        a(47)(String, 'String', function(e) {
            this._t = e + '',
            this._i = 0
        }, function() {
            var e = this._t, t = this._i, a;
            return t >= e.length ? {
                value: void 0,
                done: !0
            } : (a = n(e, t),
            this._i += a.length,
            {
                value: a,
                done: !1
            })
        })
    }
    , function(e, t, a) {
        var n = a(35)
          , o = a(36);
        e.exports = function(e) {
            return function(t, r) {
                var d = o(t) + '', s = n(r), i = d.length, l, a;
                return 0 > s || s >= i ? e ? '' : void 0 : (l = d.charCodeAt(s),
                55296 > l || 56319 < l || s + 1 === i || 56320 > (a = d.charCodeAt(s + 1)) || 57343 < a ? e ? d.charAt(s) : l : e ? d.slice(s, s + 2) : (l - 55296 << 10) + (a - 56320) + 65536)
            }
        }
    }
    , function(e, t, a) {
        'use strict';
        var n = a(79)
          , i = a(46)
          , o = a(39)
          , r = {};
        a(18)(r, a(8)('iterator'), function() {
            return this
        }),
        e.exports = function(e, t, a) {
            e.prototype = n(r, {
                next: i(1, a)
            }),
            o(e, t + ' Iterator')
        }
    }
    , function(e, t, a) {
        var n = a(17)
          , i = a(80)
          , o = a(52)
          , r = a(38)('IE_PROTO')
          , s = function() {}
          , d = 'prototype'
          , l = function() {
            var e = a(34)('iframe'), t = o.length, n = '<', i = '>', r;
            for (e.style.display = 'none',
            a(53).appendChild(e),
            e.src = 'javascript:',
            r = e.contentWindow.document,
            r.open(),
            r.write(n + 'script' + i + 'document.F=Object' + n + '/script' + i),
            r.close(),
            l = r.F; t--; )
                delete l[d][o[t]];
            return l()
        };
        e.exports = Object.create || function(e, t) {
            var a;
            return null === e ? a = l() : (s[d] = n(e),
            a = new s,
            s[d] = null,
            a[r] = e),
            void 0 === t ? a : i(a, t)
        }
    }
    , function(e, t, a) {
        var n = a(28)
          , o = a(17)
          , r = a(50);
        e.exports = a(24) ? Object.defineProperties : function(e, t) {
            o(e);
            for (var a = r(t), s = a.length, d = 0, i; s > d; )
                n.f(e, i = a[d++], t[i]);
            return e
        }
    }
    , function(e, t, a) {
        var n = a(29)
          , o = a(37)
          , r = a(83)(!1)
          , i = a(38)('IE_PROTO');
        e.exports = function(e, t) {
            var a = o(e), s = 0, d = [], l;
            for (l in a)
                l != i && n(a, l) && d.push(l);
            for (; t.length > s; )
                n(a, l = t[s++]) && (~r(d, l) || d.push(l));
            return d
        }
    }
    , function(e, t, a) {
        var n = a(27);
        e.exports = Object('z').propertyIsEnumerable(0) ? Object : function(e) {
            return 'String' == n(e) ? e.split('') : Object(e)
        }
    }
    , function(e, t, a) {
        var n = a(37)
          , i = a(51)
          , o = a(84);
        e.exports = function(e) {
            return function(t, a, r) {
                var s = n(t), d = i(s.length), l = o(r, d), c;
                if (e && a != a) {
                    for (; d > l; )
                        if (c = s[l++],
                        c != c)
                            return !0;
                } else
                    for (; d > l; l++)
                        if ((e || l in s) && s[l] === a)
                            return e || l || 0;
                return !e && -1
            }
        }
    }
    , function(e, a, i) {
        var o = i(35);
        e.exports = function(e, a) {
            return e = o(e),
            0 > e ? n(e + a, 0) : t(e, a)
        }
    }
    , function(e, t, a) {
        var n = a(29)
          , i = a(86)
          , o = a(38)('IE_PROTO')
          , r = Object.prototype;
        e.exports = Object.getPrototypeOf || function(e) {
            return e = i(e),
            n(e, o) ? e[o] : 'function' == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? r : null
        }
    }
    , function(e, t, a) {
        var n = a(36);
        e.exports = function(e) {
            return Object(n(e))
        }
    }
    , function(e, t, a) {
        for (var n = a(88), o = a(50), r = a(22), s = a(11), d = a(18), l = a(26), c = a(8), p = c('iterator'), m = c('toStringTag'), u = l.Array, g = {
            CSSRuleList: !0,
            CSSStyleDeclaration: !1,
            CSSValueList: !1,
            ClientRectList: !1,
            DOMRectList: !1,
            DOMStringList: !1,
            DOMTokenList: !0,
            DataTransferItemList: !1,
            FileList: !1,
            HTMLAllCollection: !1,
            HTMLCollection: !1,
            HTMLFormElement: !1,
            HTMLSelectElement: !1,
            MediaList: !0,
            MimeTypeArray: !1,
            NamedNodeMap: !1,
            NodeList: !0,
            PaintRequestList: !1,
            Plugin: !1,
            PluginArray: !1,
            SVGLengthList: !1,
            SVGNumberList: !1,
            SVGPathSegList: !1,
            SVGPointList: !1,
            SVGStringList: !1,
            SVGTransformList: !1,
            SourceBufferList: !1,
            StyleSheetList: !0,
            TextTrackCueList: !1,
            TextTrackList: !1,
            TouchList: !1
        }, y = o(g), S = 0; S < y.length; S++) {
            var i = y[S], h = g[i], E = s[i], f = E && E.prototype, R;
            if (f && (f[p] || d(f, p, u),
            f[m] || d(f, m, i),
            l[i] = u,
            h))
                for (R in n)
                    f[R] || r(f, R, n[R], !0)
        }
    }
    , function(e, t, a) {
        'use strict';
        var n = a(89)
          , i = a(90)
          , o = a(26)
          , r = a(37);
        e.exports = a(47)(Array, 'Array', function(e, t) {
            this._t = r(e),
            this._i = 0,
            this._k = t
        }, function() {
            var e = this._t
              , t = this._k
              , a = this._i++;
            return !e || a >= e.length ? (this._t = void 0,
            i(1)) : 'keys' == t ? i(0, a) : 'values' == t ? i(0, e[a]) : i(0, [a, e[a]])
        }, 'values'),
        o.Arguments = o.Array,
        n('keys'),
        n('values'),
        n('entries')
    }
    , function(e, t, a) {
        var n = a(8)('unscopables')
          , i = Array.prototype;
        i[n] == void 0 && a(18)(i, n, {}),
        e.exports = function(e) {
            i[n][e] = !0
        }
    }
    , function(e) {
        e.exports = function(e, t) {
            return {
                value: t,
                done: !!e
            }
        }
    }
    , function(e, t, a) {
        'use strict';
        var n = a(48), i = a(11), o = a(30), r = a(32), s = a(49), d = a(23), l = a(31), c = a(92), p = a(93), m = a(97), u = a(54).set, g = a(99)(), y = a(55), S = a(100), h = a(101), E = 'Promise', f = i.TypeError, R = i.process, A = i[E], _ = 'process' == r(R), C = function() {}, T = k = y.f, P = !!function() {
            try {
                var e = A.resolve(1)
                  , t = (e.constructor = {})[a(8)('species')] = function(e) {
                    e(C, C)
                }
                ;
                return (_ || 'function' == typeof PromiseRejectionEvent) && e.then(C)instanceof t
            } catch (t) {}
        }(), D = function(e) {
            var t;
            return !!(d(e) && 'function' == typeof (t = e.then)) && t
        }, I = function(e, t) {
            if (!e._n) {
                e._n = !0;
                var a = e._c;
                g(function() {
                    for (var n = e._v, o = 1 == e._s, r = 0, i = function(t) {
                        var a = o ? t.ok : t.fail, i = t.resolve, r = t.reject, s = t.domain, d, l, c;
                        try {
                            a ? (!o && (2 == e._h && v(e),
                            e._h = 1),
                            !0 === a ? d = n : (s && s.enter(),
                            d = a(n),
                            s && (s.exit(),
                            c = !0)),
                            d === t.promise ? r(f('Promise-chain cycle')) : (l = D(d)) ? l.call(d, i, r) : i(d)) : r(n)
                        } catch (t) {
                            s && !c && s.exit(),
                            r(t)
                        }
                    }; a.length > r; )
                        i(a[r++]);
                    e._c = [],
                    e._n = !1,
                    t && !e._h && M(e)
                })
            }
        }, M = function(e) {
            u.call(i, function() {
                var t = e._v, a = b(e), n, o, r;
                if (a && (n = S(function() {
                    _ ? R.emit('unhandledRejection', t, e) : (o = i.onunhandledrejection) ? o({
                        promise: e,
                        reason: t
                    }) : (r = i.console) && r.error && r.error('Unhandled promise rejection', t)
                }),
                e._h = _ || b(e) ? 2 : 1),
                e._a = void 0,
                a && n.e)
                    throw n.v
            })
        }, b = function(e) {
            return 1 !== e._h && 0 === (e._a || e._c).length
        }, v = function(e) {
            u.call(i, function() {
                var t;
                _ ? R.emit('rejectionHandled', e) : (t = i.onrejectionhandled) && t({
                    promise: e,
                    reason: e._v
                })
            })
        }, L = function(e) {
            var t = this;
            t._d || (t._d = !0,
            t = t._w || t,
            t._v = e,
            t._s = 2,
            !t._a && (t._a = t._c.slice()),
            I(t, !0))
        }, x = function(e) {
            var t = this, a;
            if (!t._d) {
                t._d = !0,
                t = t._w || t;
                try {
                    if (t === e)
                        throw f('Promise can\'t be resolved itself');
                    (a = D(e)) ? g(function() {
                        var n = {
                            _w: t,
                            _d: !1
                        };
                        try {
                            a.call(e, o(x, n, 1), o(L, n, 1))
                        } catch (t) {
                            L.call(n, t)
                        }
                    }) : (t._v = e,
                    t._s = 1,
                    I(t, !1))
                } catch (a) {
                    L.call({
                        _w: t,
                        _d: !1
                    }, a)
                }
            }
        }, O, k, N, F;
        P || (A = function(e) {
            c(this, A, E, '_h'),
            l(e),
            O.call(this);
            try {
                e(o(x, this, 1), o(L, this, 1))
            } catch (e) {
                L.call(this, e)
            }
        }
        ,
        O = function() {
            this._c = [],
            this._a = void 0,
            this._s = 0,
            this._d = !1,
            this._v = void 0,
            this._h = 0,
            this._n = !1
        }
        ,
        O.prototype = a(102)(A.prototype, {
            then: function(e, t) {
                var a = T(m(this, A));
                return a.ok = 'function' != typeof e || e,
                a.fail = 'function' == typeof t && t,
                a.domain = _ ? R.domain : void 0,
                this._c.push(a),
                this._a && this._a.push(a),
                this._s && I(this, !1),
                a.promise
            },
            catch: function(e) {
                return this.then(void 0, e)
            }
        }),
        N = function() {
            var e = new O;
            this.promise = e,
            this.resolve = o(x, e, 1),
            this.reject = o(L, e, 1)
        }
        ,
        y.f = T = function(e) {
            return e === A || e === F ? new N(e) : k(e)
        }
        ),
        s(s.G + s.W + s.F * !P, {
            Promise: A
        }),
        a(39)(A, E),
        a(103)(E),
        F = a(25)[E],
        s(s.S + s.F * !P, E, {
            reject: function(e) {
                var t = T(this)
                  , a = t.reject;
                return a(e),
                t.promise
            }
        }),
        s(s.S + s.F * (n || !P), E, {
            resolve: function(e) {
                return h(n && this === F ? A : this, e)
            }
        }),
        s(s.S + s.F * !(P && a(104)(function(e) {
            A.all(e)['catch'](C)
        })), E, {
            all: function(e) {
                var t = this
                  , a = T(t)
                  , n = a.resolve
                  , i = a.reject
                  , o = S(function() {
                    var a = []
                      , o = 0
                      , r = 1;
                    p(e, !1, function(e) {
                        var s = o++
                          , d = !1;
                        a.push(void 0),
                        r++,
                        t.resolve(e).then(function(e) {
                            d || (d = !0,
                            a[s] = e,
                            --r || n(a))
                        }, i)
                    }),
                    --r || n(a)
                });
                return o.e && i(o.v),
                a.promise
            },
            race: function(e) {
                var t = this
                  , a = T(t)
                  , n = a.reject
                  , i = S(function() {
                    p(e, !1, function(e) {
                        t.resolve(e).then(a.resolve, n)
                    })
                });
                return i.e && n(i.v),
                a.promise
            }
        })
    }
    , function(e) {
        e.exports = function(e, t, a, n) {
            if (!(e instanceof t) || n !== void 0 && n in e)
                throw TypeError(a + ': incorrect invocation!');
            return e
        }
    }
    , function(e, t, a) {
        var n = a(30)
          , i = a(94)
          , o = a(95)
          , r = a(17)
          , s = a(51)
          , d = a(96)
          , l = {}
          , c = {}
          , t = e.exports = function(e, t, a, p, m) {
            var u = m ? function() {
                return e
            }
            : d(e), g = n(a, p, t ? 2 : 1), y = 0, S, h, E, f;
            if ('function' != typeof u)
                throw TypeError(e + ' is not iterable!');
            if (o(u)) {
                for (S = s(e.length); S > y; y++)
                    if (f = t ? g(r(h = e[y])[0], h[1]) : g(e[y]),
                    f === l || f === c)
                        return f;
            } else
                for (E = u.call(e); !(h = E.next()).done; )
                    if (f = i(E, g, h.value, t),
                    f === l || f === c)
                        return f
        }
        ;
        t.BREAK = l,
        t.RETURN = c
    }
    , function(e, t, a) {
        var n = a(17);
        e.exports = function(t, e, a, i) {
            try {
                return i ? e(n(a)[0], a[1]) : e(a)
            } catch (a) {
                var o = t['return'];
                throw void 0 !== o && n(o.call(t)),
                a
            }
        }
    }
    , function(e, t, a) {
        var n = a(26)
          , i = a(8)('iterator')
          , o = Array.prototype;
        e.exports = function(e) {
            return e !== void 0 && (n.Array === e || o[i] === e)
        }
    }
    , function(e, t, a) {
        var n = a(32)
          , i = a(8)('iterator')
          , o = a(26);
        e.exports = a(25).getIteratorMethod = function(e) {
            if (e != void 0)
                return e[i] || e['@@iterator'] || o[n(e)]
        }
    }
    , function(e, t, a) {
        var n = a(17)
          , i = a(31)
          , o = a(8)('species');
        e.exports = function(e, t) {
            var a = n(e).constructor, r;
            return a === void 0 || (r = n(a)[o]) == void 0 ? t : i(r)
        }
    }
    , function(e) {
        e.exports = function(e, t, a) {
            var n = a === void 0;
            switch (t.length) {
            case 0:
                return n ? e() : e.call(a);
            case 1:
                return n ? e(t[0]) : e.call(a, t[0]);
            case 2:
                return n ? e(t[0], t[1]) : e.call(a, t[0], t[1]);
            case 3:
                return n ? e(t[0], t[1], t[2]) : e.call(a, t[0], t[1], t[2]);
            case 4:
                return n ? e(t[0], t[1], t[2], t[3]) : e.call(a, t[0], t[1], t[2], t[3]);
            }
            return e.apply(a, t)
        }
    }
    , function(e, t, a) {
        var n = a(11)
          , i = a(54).set
          , o = n.MutationObserver || n.WebKitMutationObserver
          , r = n.process
          , s = n.Promise
          , d = 'process' == a(27)(r);
        e.exports = function() {
            var e = function() {
                var e, n;
                for (d && (e = r.domain) && e.exit(); t; ) {
                    n = t.fn,
                    t = t.next;
                    try {
                        n()
                    } catch (n) {
                        throw t ? l() : a = void 0,
                        n
                    }
                }
                a = void 0,
                e && e.enter()
            }, t, a, l;
            if (d)
                l = function() {
                    r.nextTick(e)
                }
                ;
            else if (o && !(n.navigator && n.navigator.standalone)) {
                var c = !0
                  , p = document.createTextNode('');
                new o(e).observe(p, {
                    characterData: !0
                }),
                l = function() {
                    p.data = c = !c
                }
            } else if (s && s.resolve) {
                var m = s.resolve();
                l = function() {
                    m.then(e)
                }
            } else
                l = function() {
                    i.call(n, e)
                }
                ;
            return function(e) {
                var n = {
                    fn: e,
                    next: void 0
                };
                a && (a.next = n),
                t || (t = n,
                l()),
                a = n
            }
        }
    }
    , function(e) {
        e.exports = function(e) {
            try {
                return {
                    e: !1,
                    v: e()
                }
            } catch (t) {
                return {
                    e: !0,
                    v: t
                }
            }
        }
    }
    , function(e, t, a) {
        var n = a(17)
          , i = a(23)
          , o = a(55);
        e.exports = function(e, t) {
            if (n(e),
            i(t) && t.constructor === e)
                return t;
            var a = o.f(e)
              , r = a.resolve;
            return r(t),
            a.promise
        }
    }
    , function(e, t, a) {
        var n = a(22);
        e.exports = function(e, t, a) {
            for (var i in t)
                n(e, i, t[i], a);
            return e
        }
    }
    , function(e, t, a) {
        'use strict';
        var n = a(11)
          , i = a(28)
          , o = a(24)
          , r = a(8)('species');
        e.exports = function(e) {
            var t = n[e];
            o && t && !t[r] && i.f(t, r, {
                configurable: !0,
                get: function() {
                    return this
                }
            })
        }
    }
    , function(e, t, a) {
        var n = a(8)('iterator')
          , i = !1;
        try {
            var o = [7][n]();
            o['return'] = function() {
                i = !0
            }
            ,
            Array.from(o, function() {
                throw 2
            })
        } catch (t) {}
        e.exports = function(e, t) {
            if (!t && !i)
                return !1;
            var a = !1;
            try {
                var o = [7]
                  , r = o[n]();
                r.next = function() {
                    return {
                        done: a = !0
                    }
                }
                ,
                o[n] = function() {
                    return r
                }
                ,
                e(o)
            } catch (t) {}
            return a
        }
    }
    , function(e) {
        function t(e, t, a) {
            return t in e ? Object.defineProperty(e, t, {
                value: a,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = a,
            e
        }
        e.exports = t,
        e.exports['default'] = e.exports,
        e.exports.__esModule = !0
    }
    , function(e, t, a) {
        t = e.exports = a(42)(!1),
        t.push([e.i, '  #app-frame-provider---guideBox---1LDVV {\n    text-align: center;\n    background-size: cover;\n  }\n\n\n\n', '']),
        t.locals = {
            guideBox: 'app-frame-provider---guideBox---1LDVV'
        }
    }
    , function(e, t, a) {
        var n = a(108);
        'string' == typeof n && (n = [[e.i, n, '']]);
        a(43)(n, {});
        n.locals && (e.exports = n.locals),
        !1
    }
    , function(e, t, a) {
        t = e.exports = a(42)(!1),
        t.push([e.i, '#mitekOuterContainer {\n    width:100%;\n    height:100%;\n    display:-ms-flexbox;\n    display:flex;\n    -ms-flex-direction:column;\n    flex-direction:column;\n    overflow-y:auto;\n    overflow-x:hidden;\n    position: fixed;\n    top: 0;\n    left: 0;\n}\n#mitekVideoContainer {\n    position:fixed;\n    width:100%;\n    height:100%;\n    display: inline-block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    z-index: 1;\n}\n\n#mitekDisplayContainer {\n    position:fixed;\n    left:0;\n    top:0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width:100%;\n    height:100%;\n    overflow:hidden;\n}\n\n#mitekOuterContainer.customContainer {\n    position: relative;\n    overflow: hidden;\n}\n#mitekDisplayContainer.customContainer {\n    position: absolute;\n}\n\n.integrator {\n    border: 3px solid hsla(0,0%,100%,.7);\n    /* border-radius: 15px; */\n}\n\n#mitekHintMessage {\n    width: 80%;\n    font-family: arial;\n    font-weight: bold;\n    color: #000;\n    background: #fff;\n    padding: 15px;\n    opacity: 0.8;\n    border: 1px solid #58CE54;\n    -webkit-border-radius: 10px;\n    border-radius: 10px;\n    z-index: 101;\n    text-align: center;\n    -webkit-transform-style: preserve-3d;\n    -moz-transform-style: preserve-3d;\n    transform-style: preserve-3d;\n}\n\n#mitekVideoRecordingIcon {\n    animation: mitekBlinker 1s cubic-bezier(.2, 0, 1, 1) infinite alternate;\n    width:.5em;\n    height:.5em;\n    -webkit-border-radius: 10px;\n    border-radius:10px;\n    background: red;\n    display:inline-block;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n@keyframes mitekBlinker {\n    from { opacity: 1; }\n    to { opacity: 0; }\n}\n#mitekVideoRecordingMessage {\n    position:absolute;\n    top: 20px;\n    z-index: 101;\n    font-family: arial;\n    font-weight: normal;\n    text-align: center;\n    color: #000;\n    background-color:rgba(255,255,255, .8);\n    opacity: 0.8;\n    border: 1px solid #58CE54;\n    min-width:100px;\n    max-width:auto;\n    display:inline-block;\n    -webkit-border-radius: 40px;\n    border-radius: 40px;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    padding-left:8px;\n    padding-right:10px;\n    font-family: arial;\n    -webkit-transform-style: preserve-3d;\n    -moz-transform-style: preserve-3d;\n    transform-style: preserve-3d;\n}\n#mitekVideoRecordingMessage span {\n    padding-left: 20px;\n}\n\n#mitekHintMessage.small {\n    font-size: 1.2em;\n}\n#mitekHintMessage.medium {\n    font-size: 1.7em;\n}\n#mitekHintMessage.large {\n    font-size: 2.2em;\n}\n\n#mitekHintMessage:empty {\n    display: none;\n}\n\n.mitekNoscroll {\n    overflow: hidden !important;\n}\n\n\n.fade-in {\n  animation: fadeIn 0.2s;\n  -webkit-animation: fadeIn 0.2s;\n  -moz-animation: fadeIn 0.2s;\n  -o-animation: fadeIn 0.2s;\n  -ms-animation: fadeIn 0.2s;\n}\n@keyframes fadeIn {\n  0% {opacity:0;}\n  100% {opacity:1;}\n}\n\n@-moz-keyframes fadeIn {\n  0% {opacity:0;}\n  100% {opacity:1;}\n}\n\n@-webkit-keyframes fadeIn {\n  0% {opacity:0;}\n  100% {opacity:1;}\n}\n\n@-o-keyframes fadeIn {\n  0% {opacity:0;}\n  100% {opacity:1;}\n}\n\n@-ms-keyframes fadeIn {\n  0% {opacity:0;}\n  100% {opacity:1;}\n}', ''])
    }
    , function(e) {
        var t = function(e) {
            'use strict';
            function t(e, t, a) {
                return Object.defineProperty(e, t, {
                    value: a,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }),
                e[t]
            }
            function a(e, t, a, n) {
                var o = t && t.prototype instanceof i ? t : i
                  , r = Object.create(o.prototype)
                  , s = new u(n || []);
                return r._invoke = l(e, a, s),
                r
            }
            function n(e, t, a) {
                try {
                    return {
                        type: 'normal',
                        arg: e.call(t, a)
                    }
                } catch (e) {
                    return {
                        type: 'throw',
                        arg: e
                    }
                }
            }
            function i() {}
            function o() {}
            function r() {}
            function s(e) {
                ['next', 'throw', 'return'].forEach(function(a) {
                    t(e, a, function(e) {
                        return this._invoke(a, e)
                    })
                })
            }
            function d(e, t) {
                function a(i, o, r, s) {
                    var d = n(e[i], e, o);
                    if ('throw' === d.type)
                        s(d.arg);
                    else {
                        var l = d.arg
                          , c = l.value;
                        return c && 'object' == typeof c && h.call(c, '__await') ? t.resolve(c.__await).then(function(e) {
                            a('next', e, r, s)
                        }, function(e) {
                            a('throw', e, r, s)
                        }) : t.resolve(c).then(function(e) {
                            l.value = e,
                            r(l)
                        }, function(e) {
                            return a('throw', e, r, s)
                        })
                    }
                }
                function i(e, n) {
                    function i() {
                        return new t(function(t, i) {
                            a(e, n, t, i)
                        }
                        )
                    }
                    return o = o ? o.then(i, i) : i()
                }
                var o;
                this._invoke = i
            }
            function l(e, t, a) {
                var i = _;
                return function(o, r) {
                    if (i === T)
                        throw new Error('Generator is already running');
                    if (i === P) {
                        if ('throw' === o)
                            throw r;
                        return y()
                    }
                    for (a.method = o,
                    a.arg = r; ; ) {
                        var s = a.delegate;
                        if (s) {
                            var d = c(s, a);
                            if (d) {
                                if (d === D)
                                    continue;
                                return d
                            }
                        }
                        if ('next' === a.method)
                            a.sent = a._sent = a.arg;
                        else if ('throw' === a.method) {
                            if (i === _)
                                throw i = P,
                                a.arg;
                            a.dispatchException(a.arg)
                        } else
                            'return' === a.method && a.abrupt('return', a.arg);
                        i = T;
                        var l = n(e, t, a);
                        if ('normal' === l.type) {
                            if (i = a.done ? P : C,
                            l.arg === D)
                                continue;
                            return {
                                value: l.arg,
                                done: a.done
                            }
                        }
                        'throw' === l.type && (i = P,
                        a.method = 'throw',
                        a.arg = l.arg)
                    }
                }
            }
            function c(e, t) {
                var a = e.iterator[t.method];
                if (void 0 === a) {
                    if (t.delegate = null,
                    'throw' === t.method) {
                        if (e.iterator['return'] && (t.method = 'return',
                        t.arg = void 0,
                        c(e, t),
                        'throw' === t.method))
                            return D;
                        t.method = 'throw',
                        t.arg = new TypeError('The iterator does not provide a \'throw\' method')
                    }
                    return D
                }
                var i = n(a, e.iterator, t.arg);
                if ('throw' === i.type)
                    return t.method = 'throw',
                    t.arg = i.arg,
                    t.delegate = null,
                    D;
                var o = i.arg;
                if (!o)
                    return t.method = 'throw',
                    t.arg = new TypeError('iterator result is not an object'),
                    t.delegate = null,
                    D;
                if (o.done)
                    t[e.resultName] = o.value,
                    t.next = e.nextLoc,
                    'return' !== t.method && (t.method = 'next',
                    t.arg = void 0);
                else
                    return o;
                return t.delegate = null,
                D
            }
            function p(e) {
                var t = {
                    tryLoc: e[0]
                };
                1 in e && (t.catchLoc = e[1]),
                2 in e && (t.finallyLoc = e[2],
                t.afterLoc = e[3]),
                this.tryEntries.push(t)
            }
            function m(e) {
                var t = e.completion || {};
                t.type = 'normal',
                delete t.arg,
                e.completion = t
            }
            function u(e) {
                this.tryEntries = [{
                    tryLoc: 'root'
                }],
                e.forEach(p, this),
                this.reset(!0)
            }
            function g(e) {
                if (e) {
                    var t = e[f];
                    if (t)
                        return t.call(e);
                    if ('function' == typeof e.next)
                        return e;
                    if (!isNaN(e.length)) {
                        var a = -1
                          , n = function t() {
                            for (; ++a < e.length; )
                                if (h.call(e, a))
                                    return t.value = e[a],
                                    t.done = !1,
                                    t;
                            return t.value = void 0,
                            t.done = !0,
                            t
                        };
                        return n.next = n
                    }
                }
                return {
                    next: y
                }
            }
            function y() {
                return {
                    value: void 0,
                    done: !0
                }
            }
            var S = Object.prototype
              , h = S.hasOwnProperty
              , E = 'function' == typeof Symbol ? Symbol : {}
              , f = E.iterator || '@@iterator'
              , R = E.asyncIterator || '@@asyncIterator'
              , A = E.toStringTag || '@@toStringTag';
            try {
                t({}, '')
            } catch (e) {
                t = function(e, t, a) {
                    return e[t] = a
                }
            }
            e.wrap = a;
            var _ = 'suspendedStart'
              , C = 'suspendedYield'
              , T = 'executing'
              , P = 'completed'
              , D = {}
              , I = {};
            I[f] = function() {
                return this
            }
            ;
            var M = Object.getPrototypeOf
              , b = M && M(M(g([])));
            b && b !== S && h.call(b, f) && (I = b);
            var v = r.prototype = i.prototype = Object.create(I);
            return o.prototype = v.constructor = r,
            r.constructor = o,
            o.displayName = t(r, A, 'GeneratorFunction'),
            e.isGeneratorFunction = function(e) {
                var t = 'function' == typeof e && e.constructor;
                return !!t && (t === o || 'GeneratorFunction' === (t.displayName || t.name))
            }
            ,
            e.mark = function(e) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : (e.__proto__ = r,
                t(e, A, 'GeneratorFunction')),
                e.prototype = Object.create(v),
                e
            }
            ,
            e.awrap = function(e) {
                return {
                    __await: e
                }
            }
            ,
            s(d.prototype),
            d.prototype[R] = function() {
                return this
            }
            ,
            e.AsyncIterator = d,
            e.async = function(t, n, i, o, r) {
                void 0 === r && (r = Promise);
                var s = new d(a(t, n, i, o),r);
                return e.isGeneratorFunction(n) ? s : s.next().then(function(e) {
                    return e.done ? e.value : s.next()
                })
            }
            ,
            s(v),
            t(v, A, 'Generator'),
            v[f] = function() {
                return this
            }
            ,
            v.toString = function() {
                return '[object Generator]'
            }
            ,
            e.keys = function(e) {
                var t = [];
                for (var a in e)
                    t.push(a);
                return t.reverse(),
                function a() {
                    for (; t.length; ) {
                        var n = t.pop();
                        if (n in e)
                            return a.value = n,
                            a.done = !1,
                            a
                    }
                    return a.done = !0,
                    a
                }
            }
            ,
            e.values = g,
            u.prototype = {
                constructor: u,
                reset: function(e) {
                    if (this.prev = 0,
                    this.next = 0,
                    this.sent = this._sent = void 0,
                    this.done = !1,
                    this.delegate = null,
                    this.method = 'next',
                    this.arg = void 0,
                    this.tryEntries.forEach(m),
                    !e)
                        for (var t in this)
                            't' === t.charAt(0) && h.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0)
                },
                stop: function() {
                    this.done = !0;
                    var e = this.tryEntries[0]
                      , t = e.completion;
                    if ('throw' === t.type)
                        throw t.arg;
                    return this.rval
                },
                dispatchException: function(e) {
                    function t(t, n) {
                        return o.type = 'throw',
                        o.arg = e,
                        a.next = t,
                        n && (a.method = 'next',
                        a.arg = void 0),
                        !!n
                    }
                    if (this.done)
                        throw e;
                    for (var a = this, n = this.tryEntries.length - 1; 0 <= n; --n) {
                        var i = this.tryEntries[n]
                          , o = i.completion;
                        if ('root' === i.tryLoc)
                            return t('end');
                        if (i.tryLoc <= this.prev) {
                            var r = h.call(i, 'catchLoc')
                              , s = h.call(i, 'finallyLoc');
                            if (r && s) {
                                if (this.prev < i.catchLoc)
                                    return t(i.catchLoc, !0);
                                if (this.prev < i.finallyLoc)
                                    return t(i.finallyLoc)
                            } else if (r) {
                                if (this.prev < i.catchLoc)
                                    return t(i.catchLoc, !0);
                            } else if (!s)
                                throw new Error('try statement without catch or finally');
                            else if (this.prev < i.finallyLoc)
                                return t(i.finallyLoc)
                        }
                    }
                },
                abrupt: function(e, t) {
                    for (var a = this.tryEntries.length - 1, n; 0 <= a; --a)
                        if (n = this.tryEntries[a],
                        n.tryLoc <= this.prev && h.call(n, 'finallyLoc') && this.prev < n.finallyLoc) {
                            var i = n;
                            break
                        }
                    i && ('break' === e || 'continue' === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                    var o = i ? i.completion : {};
                    return o.type = e,
                    o.arg = t,
                    i ? (this.method = 'next',
                    this.next = i.finallyLoc,
                    D) : this.complete(o)
                },
                complete: function(e, t) {
                    if ('throw' === e.type)
                        throw e.arg;
                    return 'break' === e.type || 'continue' === e.type ? this.next = e.arg : 'return' === e.type ? (this.rval = this.arg = e.arg,
                    this.method = 'return',
                    this.next = 'end') : 'normal' === e.type && t && (this.next = t),
                    D
                },
                finish: function(e) {
                    for (var t = this.tryEntries.length - 1, a; 0 <= t; --t)
                        if (a = this.tryEntries[t],
                        a.finallyLoc === e)
                            return this.complete(a.completion, a.afterLoc),
                            m(a),
                            D
                },
                catch: function(e) {
                    for (var t = this.tryEntries.length - 1, a; 0 <= t; --t)
                        if (a = this.tryEntries[t],
                        a.tryLoc === e) {
                            var n = a.completion;
                            if ('throw' === n.type) {
                                var i = n.arg;
                                m(a)
                            }
                            return i
                        }
                    throw new Error('illegal catch attempt')
                },
                delegateYield: function(e, t, a) {
                    return this.delegate = {
                        iterator: g(e),
                        resultName: t,
                        nextLoc: a
                    },
                    'next' === this.method && (this.arg = void 0),
                    D
                }
            },
            e
        }(e.exports);
        try {
            regeneratorRuntime = t
        } catch (e) {
            Function('r', 'regeneratorRuntime = r')(t)
        }
    }
    , function(a) {
        !function() {
            'use strict';
            var i = 'undefined' != typeof window && void 0 !== window.document ? window.document : {}
              , o = a.exports
              , s = function() {
                for (var a = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']], n = 0, o = a.length, r = {}, t; n < o; n++)
                    if ((t = a[n]) && t[1]in i) {
                        for (n = 0; n < t.length; n++)
                            r[a[0][n]] = t[n];
                        return r
                    }
                return !1
            }()
              , d = {
                change: s.fullscreenchange,
                error: s.fullscreenerror
            }
              , e = {
                request: function(t) {
                    return new Promise(function(a, e) {
                        var n = function() {
                            this.off('change', n),
                            a()
                        }
                        .bind(this);
                        this.on('change', n),
                        t = t || i.documentElement,
                        Promise.resolve(t[s.requestFullscreen]())['catch'](e)
                    }
                    .bind(this))
                },
                exit: function() {
                    return new Promise(function(t, e) {
                        if (this.isFullscreen) {
                            var a = function() {
                                this.off('change', a),
                                t()
                            }
                            .bind(this);
                            this.on('change', a),
                            Promise.resolve(i[s.exitFullscreen]())['catch'](e)
                        } else
                            t()
                    }
                    .bind(this))
                },
                toggle: function(t) {
                    return this.isFullscreen ? this.exit() : this.request(t)
                },
                onchange: function(t) {
                    this.on('change', t)
                },
                onerror: function(t) {
                    this.on('error', t)
                },
                on: function(t, e) {
                    var a = d[t];
                    a && i.addEventListener(a, e, !1)
                },
                off: function(t, e) {
                    var a = d[t];
                    a && i.removeEventListener(a, e, !1)
                },
                raw: s
            };
            s ? (Object.defineProperties(e, {
                isFullscreen: {
                    get: function() {
                        return !!i[s.fullscreenElement]
                    }
                },
                element: {
                    enumerable: !0,
                    get: function() {
                        return i[s.fullscreenElement]
                    }
                },
                isEnabled: {
                    enumerable: !0,
                    get: function() {
                        return !!i[s.fullscreenEnabled]
                    }
                }
            }),
            o ? a.exports = e : window.screenfull = e) : o ? a.exports = {
                isEnabled: !1
            } : window.screenfull = {
                isEnabled: !1
            }
        }()
    }
    , function(e, t, a) {
        'use strict';
        function n() {
            return {
                CAMERA_DISPLAY_STARTED: 'CAMERA_DISPLAY_STARTED',
                IMAGE_CAPTURED: 'IMAGE_CAPTURED',
                FRAME_CAPTURE_RESULT: 'FRAME_CAPTURE_RESULT',
                FRAME_PROCESSING_ENDED: 'FRAME_PROCESSING_ENDED',
                FRAME_PROCESSING_FEEDBACK: 'FRAME_PROCESSING_FEEDBACK',
                FRAME_PROCESSING_STARTED: 'FRAME_PROCESSING_STARTED',
                SDK_ERROR: 'SDK_ERROR',
                SDK_READY: 'SDK_READY'
            }
        }
        function i() {
            return {
                CAPTURE_AND_PROCESS_FRAME: 'CAPTURE_AND_PROCESS_FRAME',
                PROCESS_FRAME: 'PROCESS_FRAME',
                CAPTURE_FRAME: 'CAPTURE_FRAME',
                SDK_START: 'SDK_START',
                SDK_STOP: 'SDK_STOP',
                SDK_QUIT: 'SDK_QUIT',
                SHOW_HINT: 'SHOW_HINT',
                HIDE_HINT: 'HIDE_HINT',
                HINT_MESSAGE_SIZE: 'HINT_MESSAGE_SIZE'
            }
        }
        function o(e) {
            var t = [].slice.call(arguments)
              , a = m.apply(null, t);
            a && ('FRAME_PROCESSING_FEEDBACK' === e ? f.a.on(t[0], t[1]) : f.a.once(t[0], t[1]),
            'FRAME_CAPTURE_RESULT' === e && f.a.on('SDK_STOP', function() {
                setTimeout(function() {
                    return f.a.removeAllListeners()
                })
            }))
        }
        function r(e, t) {
            var a = [].slice.call(arguments)
              , n = h.apply(null, a);
            n ? 'SDK_STOP' === e || 'CAPTURE_FRAME' === e ? f.a.emit(e) : 'SHOW_HINT' === e || 'HIDE_HINT' === e || 'HINT_MESSAGE_SIZE' === e ? f.a.emit(e, t) : E.a.processCMD(e, t) : f.a.emit('SDK_ERROR', Object(u.c)(331))
        }
        function s() {
            return R
        }
        function d(e) {
            'back' === e.doctype
        }
        a.r(t),
        a.d(t, 'on', function() {
            return o
        }),
        a.d(t, 'cmd', function() {
            return r
        }),
        a.d(t, 'getVersion', function() {
            return s
        }),
        a.d(t, 'init', function() {
            return d
        });
        var l = a(71)
          , c = a(72)
          , p = a(2)
          , m = function(e) {
            var t = [].slice.call(arguments);
            if (1 === t.length || 2 < t.length)
                return !1;
            if ('function' != typeof t[1])
                return !1;
            n();
            return Object(p.d)(n()[e])
        }
          , u = a(3)
          , g = i()
          , y = Object(u.a)()
          , S = function(e) {
            return Object(p.d)(i()[e])
        }
          , h = function(e) {
            return S(e)
        }
          , E = a(58)
          , f = a(0)
          , R = '4.9.5'
    }
    ])
});
